// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: string;
};

/**
 * UserSchema
 *
 * Defining a User Schema for user with Ninja
 *
 * See: https://django-ninja.dev/guides/response/django-pydantic/
 */
export type UserSchema = {
  /**
   * ID
   */
  id?: number | null;
  /**
   * Email address
   */
  email: string;
  /**
   * First Name
   */
  first_name?: string | null;
  /**
   * Last Name
   */
  last_name?: string | null;
  /**
   * Role
   */
  role?: string | null;
};

/**
 * AgencyStateSchema
 *
 * Schema for Agency State with writing company information
 */
export type AgencyStateSchema = {
  state: UsStateEnum;
  /**
   * Writingcompanyshortname
   */
  writingCompanyShortName: string;
};

/**
 * AgencyWithStatesSchema
 *
 * Defining an Agency Schema for user with Ninja
 */
export type AgencyWithStatesSchema = {
  /**
   * Agencyid
   */
  agencyId: string;
  /**
   * Name
   */
  name: string;
  /**
   * Authorizedstates
   */
  authorizedStates: Array<AgencyStateSchema>;
  /**
   * Canrefer
   */
  canRefer: boolean;
  invoicePreference: InvoicePreference;
};

/**
 * CurrentUserSchema
 *
 * Current user schema that includes user details and
 * associated agencies (all if underwriter, only agent's if agent)
 */
export type CurrentUserSchema = {
  /**
   * Id
   */
  id: number;
  /**
   * Email
   */
  email: string;
  /**
   * Firstname
   */
  firstName: string;
  /**
   * Lastname
   */
  lastName: string;
  role: UserRoleType;
  /**
   * Agentdata
   */
  agentData?: Array<AgencyWithStatesSchema> | null;
  /**
   * Underwriterdata
   */
  underwriterData?: Array<AgencyWithStatesSchema> | null;
};

/**
 * InvoicePreference
 */
export const InvoicePreference = {
  DIRECT: 'direct',
  AGENCY: 'agency',
} as const;

/**
 * InvoicePreference
 */
export type InvoicePreference =
  (typeof InvoicePreference)[keyof typeof InvoicePreference];

/**
 * UsStateEnum
 */
export const UsStateEnum = {
  AK: 'AK',
  AL: 'AL',
  AR: 'AR',
  AZ: 'AZ',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DC: 'DC',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  IA: 'IA',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  MA: 'MA',
  MD: 'MD',
  ME: 'ME',
  MI: 'MI',
  MN: 'MN',
  MO: 'MO',
  MS: 'MS',
  MT: 'MT',
  NC: 'NC',
  ND: 'ND',
  NE: 'NE',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NV: 'NV',
  NY: 'NY',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PR: 'PR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VA: 'VA',
  VI: 'VI',
  VT: 'VT',
  WA: 'WA',
  WI: 'WI',
  WV: 'WV',
  WY: 'WY',
} as const;

/**
 * UsStateEnum
 */
export type UsStateEnum = (typeof UsStateEnum)[keyof typeof UsStateEnum];

/**
 * UserRoleType
 */
export const UserRoleType = {
  AGENT: 'agent',
  UNDERWRITER: 'underwriter',
  UNDERWRITING_ADMIN: 'underwriting_admin',
  SYSTEM_ADMIN: 'system_admin',
} as const;

/**
 * UserRoleType
 */
export type UserRoleType = (typeof UserRoleType)[keyof typeof UserRoleType];

/**
 * RelatedAgentsSchema
 *
 * Get all related agents for a user, grouped by agency
 */
export type RelatedAgentsSchema = {
  /**
   * Agency
   */
  agency: {
    [key: string]: Array<RelatedUsersAgentUserSchema>;
  };
  /**
   * Agencies
   */
  agencies: {
    [key: string]: string;
  };
};

/**
 * RelatedUsersAgentUserSchema
 *
 * Copy of AgentUserSchema, used for related users endpoint
 */
export type RelatedUsersAgentUserSchema = {
  /**
   * Id
   */
  id: number;
  /**
   * Email
   */
  email: string;
  /**
   * Firstname
   */
  firstName: string;
  /**
   * Lastname
   */
  lastName: string;
  /**
   * Role
   */
  role: string;
  invoicePreference: InvoicePreference;
};

/**
 * _ResetPasswordResponse
 */
export type ResetPasswordResponse = {
  /**
   * Message
   */
  message: string;
};

/**
 * ForgotPasswordSchema
 */
export type ForgotPasswordSchema = {
  /**
   * Email
   */
  email: string;
};

/**
 * ResetPasswordSchema
 */
export type ResetPasswordSchema = {
  /**
   * User Id
   */
  user_id: number;
  /**
   * Token
   */
  token: string;
  /**
   * New Password
   */
  new_password: string;
};

/**
 * AccountsReceivableCoverage
 */
export const AccountsReceivableCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  NONE: 'none',
} as const;

/**
 * AccountsReceivableCoverage
 */
export type AccountsReceivableCoverage =
  (typeof AccountsReceivableCoverage)[keyof typeof AccountsReceivableCoverage];

/**
 * AdditionalInsured
 *
 * Additional Insured
 */
export type AdditionalInsured = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Pk
   */
  pk: string;
  /**
   * Entityname
   */
  entityName?: string | null;
  entityDba?: YesNoEnum | null;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
  /**
   * Alltemplateformscomplete
   */
  readonly allTemplateFormsComplete: boolean;
};

/**
 * AgeOfRoofResponse
 */
export type AgeOfRoofResponse = {
  /**
   * Results
   */
  results?: Array<AgeOfRoofResults> | string | null;
};

/**
 * AgeOfRoofResults
 */
export type AgeOfRoofResults = {
  /**
   * Ageofroof
   */
  ageOfRoof?: number | string | null;
  /**
   * Roofyear
   */
  roofYear?: number | string | null;
};

export type AllFormLevels =
  | PolicyFormLevels
  | LocationFormLevels
  | PracticeLocationFormLevels
  | DentistFormLevels
  | EntityFormLevels
  | CyberLiabilityFormLevels
  | GlAdditionalInsuredFormLevels
  | PlAdditionalInsuredFormLevels
  | MissionOfMercyEventFormLevels;

/**
 * AttachedDocumentType
 */
export const AttachedDocumentType = {
  NEW_BUSINESS_APPLICATION: 'new_business_application',
  RENEWAL_APPLICATION: 'renewal_application',
  PART_TIME_SUPPLEMENT: 'part_time_supplement',
  ROSTER: 'roster',
  SCHEDULE_OF_VALUES: 'schedule_of_values',
  HOLISTIC_QUESTIONNAIRE: 'holistic_questionnaire',
  ELECTIVE_COSMETIC_QUESTIONNAIRE: 'elective_cosmetic_questionnaire',
  GAP_IN_PRACTICE_QUESTIONNAIRE: 'gap_in_practice_questionnaire',
  EMPLOYMENT_PRACTICES_LIABILITY_APPLICATION:
    'employment_practices_liability_application',
  ORAL_SURGEON_SUPPLEMENTAL_APPLICATION:
    'oral_surgeon_supplemental_application',
  DENTAL_ANESTHESIOLOGIST_SUPPLEMENTAL_APPLICATION:
    'dental_anesthesiologist_supplemental_application',
  LOSS_RUNS: 'loss_runs',
  CLAIMS_NARRATIVE: 'claims_narrative',
  LICENSE_VERIFICATION: 'license_verification',
  CORPORATION_VERIFICATION: 'corporation_verification',
  BOARD_ACTION_DOCUMENTS: 'board_action_documents',
  ENDORSEMENT_REQUEST: 'endorsement_request',
  CANCELLATION_REQUEST: 'cancellation_request',
  EMAIL: 'email',
  ERP_REQUEST_TO_ISSUE: 'erp_request_to_issue',
  BIND_ORDER: 'bind_order',
  UNDERWRITING_INFORMATION: 'underwriting_information',
  INSPECTION: 'inspection',
  APPEAL: 'appeal',
  PROOF_OF_RISK_MANAGEMENT: 'proof_of_risk_management',
  PRIOR_CARRIER_DECLARATIONS: 'prior_carrier_declarations',
  LOST_POLICY_RELEASE: 'lost_policy_release',
  COI: 'coi',
  CONTRACT: 'contract',
  PHYSICIAN_STATEMENT: 'physician_statement',
  FINANCIALS: 'financials',
  DEBIT_CREDIT_WORKSHEET: 'debit_credit_worksheet',
  IRPM_WORKSHEET: 'irpm_worksheet',
  INSURED_CORRESPONDENCE: 'insured_correspondence',
  NON_RENEWAL_NOTICE: 'non_renewal_notice',
  CANCELLATION_NOTICE: 'cancellation_notice',
  PREMIUM_NOTICE: 'premium_notice',
  CONDITIONAL_RENEWAL_NOTICE: 'conditional_renewal_notice',
  PREMIUM_RENEWAL_NOTICE: 'premium_renewal_notice',
  PREMIUM_STATEMENT: 'premium_statement',
  QUOTE_PROPOSAL: 'quote_proposal',
  POLICY_SPECIMEN: 'policy_specimen',
  POLICY_BUNDLE: 'policy_bundle',
  USER_UPLOADED: 'user_uploaded',
  OTHER: 'other',
  RESCIND_NOTICE: 'rescind_notice',
  ERP_OFFER_LETTER: 'erp_offer_letter',
  SUMMARY_OF_CHANGES: 'summary_of_changes',
  ERP_ESTIMATE_WORKSHEET: 'erp_estimate_worksheet',
  NO_KNOWN_LOSS_LETTER: 'no_known_loss_letter',
} as const;

/**
 * AttachedDocumentType
 */
export type AttachedDocumentType =
  (typeof AttachedDocumentType)[keyof typeof AttachedDocumentType];

/**
 * AttachedForm
 */
export type AttachedForm = {
  /**
   * Id
   */
  id: string;
  /**
   * Uniqueattachmentid
   */
  uniqueAttachmentId: string;
  /**
   * Versionnumber
   */
  versionNumber: number;
  documentType: DocumentTypeEnum;
  /**
   * Name
   */
  name: string;
  /**
   * Formid
   */
  formId: string;
  file: DocumentOdtFile;
  /**
   * Activefrom
   */
  activeFrom: string | null;
  /**
   * Deprecationdate
   */
  deprecationDate: string | null;
  /**
   * Attachedby
   */
  attachedBy: 'system' | UserObject;
  /**
   * Uservariables
   */
  userVariables?: {
    [key: string]: unknown;
  };
  formLevel?: AllFormLevels | null;
  /**
   * Intentdescription
   */
  intentDescription?: string;
  /**
   * Attachmentdescription
   */
  attachmentDescription?: string;
  /**
   * Transactionnumber
   */
  transactionNumber: number;
  /**
   * Lastmodifiedtransactionnumber
   */
  lastModifiedTransactionNumber?: number | null;
  /**
   * Supersedesuniqueattachmentid
   */
  supersedesUniqueAttachmentId?: string | null;
};

/**
 * BCEGS
 */
export const Bcegs = {
  ONE: 'one',
  TWO: 'two',
  THREE: 'three',
  FOUR: 'four',
  FIVE: 'five',
  SIX: 'six',
  SEVEN: 'seven',
  EIGHT: 'eight',
  NINE: 'nine',
  TEN: 'ten',
  UNGRADED: 'ungraded',
  NON_PARTICIPATING: 'non_participating',
} as const;

/**
 * BCEGS
 */
export type Bcegs = (typeof Bcegs)[keyof typeof Bcegs];

/**
 * BasicEarthquakeLimits
 */
export const BasicEarthquakeLimits = {
  NOT_ELIGIBLE: 'Not Eligible',
  '$50,000': '$50,000',
} as const;

/**
 * BasicEarthquakeLimits
 */
export type BasicEarthquakeLimits =
  (typeof BasicEarthquakeLimits)[keyof typeof BasicEarthquakeLimits];

/**
 * BlackBagCoverage
 *
 * Black Bag Coverage
 */
export type BlackBagCoverage = {
  bagType: BlackBagTypeEnum;
  /**
   * Totallimit
   */
  totalLimit: number;
  /**
   * Description
   */
  description?: string | null;
};

/**
 * BlackBagCoverageDict
 */
export type BlackBagCoverageDict = {
  bagType: BlackBagTypeEnum;
  /**
   * Totallimit
   */
  totalLimit: number;
  /**
   * Description
   */
  description?: string | null;
  /**
   * Practicelocationpk
   */
  practiceLocationPk: string;
};

/**
 * BlackBagTypeEnum
 */
export const BlackBagTypeEnum = {
  STANDARD: 'standard',
  HIGHER: 'higher',
} as const;

/**
 * BlackBagTypeEnum
 */
export type BlackBagTypeEnum =
  (typeof BlackBagTypeEnum)[keyof typeof BlackBagTypeEnum];

/**
 * BuildingInflationGuard
 */
export const BuildingInflationGuard = {
  '0_3%': '0.3%',
  '0_4%': '0.4%',
  '0_5%': '0.5%',
  '1_0%': '1.0%',
  '1_5%': '1.5%',
  '2_0%': '2.0%',
  '2_5%': '2.5%',
  '3_0%': '3.0%',
  '3_5%': '3.5%',
  '4_0%': '4.0%',
  '4_5%': '4.5%',
  '5_0%': '5.0%',
} as const;

/**
 * BuildingInflationGuard
 */
export type BuildingInflationGuard =
  (typeof BuildingInflationGuard)[keyof typeof BuildingInflationGuard];

/**
 * BundledPropertyEnhancementEndorsement
 */
export const BundledPropertyEnhancementEndorsement = {
  GOLD: 'gold',
  NONE: 'none',
  PLATINUM: 'platinum',
} as const;

/**
 * BundledPropertyEnhancementEndorsement
 */
export type BundledPropertyEnhancementEndorsement =
  (typeof BundledPropertyEnhancementEndorsement)[keyof typeof BundledPropertyEnhancementEndorsement];

/**
 * CancelTypeEnum
 */
export const CancelTypeEnum = {
  FLAT_CANCEL: 'flat_cancel',
  PRO_RATA: 'pro_rata',
  SHORT: 'short',
} as const;

/**
 * CancelTypeEnum
 */
export type CancelTypeEnum =
  (typeof CancelTypeEnum)[keyof typeof CancelTypeEnum];

/**
 * CancellationReasonEnum
 */
export const CancellationReasonEnum = {
  DUE_TO_NON_PAYMENT: 'due_to_non_payment',
  REQUESTED_BY_INSURED: 'requested_by_insured',
  FAILURE_TO_RENEW: 'failure_to_renew',
  REQUESTED_BY_COMPANY: 'requested_by_company',
} as const;

/**
 * CancellationReasonEnum
 */
export type CancellationReasonEnum =
  (typeof CancellationReasonEnum)[keyof typeof CancellationReasonEnum];

/**
 * CommercialCertification
 */
export const CommercialCertification = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  NOT_APPLICABLE: 'not_applicable',
} as const;

/**
 * CommercialCertification
 */
export type CommercialCertification =
  (typeof CommercialCertification)[keyof typeof CommercialCertification];

/**
 * CommercialProperty
 *
 * Schema with Fields required to rate Professional Liability
 */
export type CommercialProperty = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  /**
   * Locations
   */
  locations?: Array<Location>;
  coverage?: Coverage;
  coveragePart?: CoveragePart;
  veriskRawResponse?: VeriskBusinessOwnerResponse | null;
  corelogicRawResponse?: CoreLogicAllApiResponses | null;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
};

/**
 * ComponentSociety
 *
 * Component Societies
 */
export type ComponentSociety = {
  /**
   * Name
   */
  name?: string | null;
  /**
   * Prioracts
   */
  priorActs?: string | null;
};

/**
 * ConsentType
 */
export const ConsentType = {
  NA: 'na',
  FIRST_NAMED_INSURED: 'first_named_insured',
  INSURED_DENTIST: 'insured_dentist',
} as const;

/**
 * ConsentType
 */
export type ConsentType = (typeof ConsentType)[keyof typeof ConsentType];

/**
 * ConstructionType
 */
export const ConstructionType = {
  FRAME: 'frame',
  JOINTED_MASONRY: 'jointed_masonry',
  NON_COMBUSTIBLE: 'non_combustible',
  MASONRY_NON_COMBUSTIBLE: 'masonry_non_combustible',
  MODIFIED_FIRE_RESISTIVE: 'modified_fire_resistive',
  FIRE_RESISTIVE: 'fire_resistive',
} as const;

/**
 * ConstructionType
 */
export type ConstructionType =
  (typeof ConstructionType)[keyof typeof ConstructionType];

/**
 * CoreLogicAllAPIResponses
 */
export type CoreLogicAllApiResponses = {
  flood_risk_response?: FloodRiskScoreResponse | null;
  us_earthquake_hazard_response?: UsEarthquakeHazardResponse | null;
  distance_to_shore_response?: DistanceToShoreResponse | null;
  wild_fire_risk_response?: WildfireRiskResponse | null;
  hail_risk_response?: HailRiskResponse | null;
  non_weather_water_risk?: NonWeatherRiskScoreResponse | null;
  wind_risk_score?: WindRiskScoreResponse | null;
  crime_risk_score?: CrimeRiskScoreResponse | null;
  major_system_permits?: MajorSystemPermitsResponse | null;
  roof_age?: AgeOfRoofResponse | null;
};

/**
 * Coverage
 */
export type Coverage = {
  bundledPropertyEnhancementEndorsements?: BundledPropertyEnhancementEndorsement | null;
  employeeDishonestyCoverageDesired?: YesNoEnum | null;
  employeeDishonestyCoverage?: EmployeeDishonestyCoverage | null;
  employeeDishonestyCoverageChoice?: StandardOrHigher | null;
  floridaSinkholeCoverageDesired?: YesNoEnum | null;
  fungiCoverageDesired?: YesNoEnum | null;
  propertyClaim?: YesNoEnum | null;
  currentlyResidence?: YesNoEnum | null;
  mostlyVacant?: YesNoEnum | null;
  trailerHome?: YesNoEnum | null;
  increasedWelfareLimitsDesired?: YesNoEnum | null;
  /**
   * Increasedwelfarelimits
   */
  increasedWelfareLimits?: number | null;
};

/**
 * CoverageAmount
 */
export type CoverageAmount = {
  /**
   * Writtenamount
   */
  writtenAmount?: number;
  /**
   * Annualamount
   */
  annualAmount?: number;
  /**
   * Billedamount
   */
  billedAmount?: number;
  amountType?: AmounttypeEnum;
};

/**
 * CoverageBasis
 */
export const CoverageBasis = {
  CLAIMS: 'claims',
  OCCURRENCE: 'occurrence',
} as const;

/**
 * CoverageBasis
 */
export type CoverageBasis = (typeof CoverageBasis)[keyof typeof CoverageBasis];

/**
 * CoveragePart
 */
export type CoveragePart = {
  /**
   * Writtenpolicypremium
   */
  writtenPolicyPremium?: number;
  /**
   * Annualpolicypremium
   */
  annualPolicyPremium?: number;
  /**
   * Billedpolicypremium
   */
  billedPolicyPremium?: number;
  /**
   * Premiumdetail
   */
  premiumDetail?: {
    [key: string]: unknown;
  };
};

/**
 * CrimeRiskScoreResponse
 */
export type CrimeRiskScoreResponse = {
  /**
   * Riskindex
   */
  riskIndex: number | string | null;
};

/**
 * CyberLiability
 */
export type CyberLiability = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  totalLimitOfInsurance?: LimitOfInsurance | null;
  /**
   * Numberofdentists
   */
  numberOfDentists?: number | null;
  /**
   * Retroactivedate
   */
  retroactiveDate?: string | null;
  deductible?: Deductible;
  /**
   * Sublimitofliability
   */
  sublimitOfLiability?: number;
  coverageBasis?: CoverageBasis;
  coveragePart?: CoveragePart;
  /**
   * Erpexpirationdate
   *
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: string | null;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
};

export type CyberLiabilityFormLevels = 'CYBER';

/**
 * Deductible
 */
export const Deductible = { 2500: '2500', 5000: '5000' } as const;

/**
 * Deductible
 */
export type Deductible = (typeof Deductible)[keyof typeof Deductible];

/**
 * DefenseDeductibleDesired
 */
export const DefenseDeductibleDesired = {
  NONE: 'none',
  LIMIT_2_5K: 'limit_2_5k',
  LIMIT_5K: 'limit_5k',
  LIMIT_10K: 'limit_10k',
  LIMIT_15K: 'limit_15k',
  LIMIT_25K: 'limit_25k',
  LIMIT_50K: 'limit_50k',
  LIMIT_75K: 'limit_75k',
  LIMIT_100K: 'limit_100k',
  LIMIT_250K: 'limit_250k',
} as const;

/**
 * DefenseDeductibleDesired
 */
export type DefenseDeductibleDesired =
  (typeof DefenseDeductibleDesired)[keyof typeof DefenseDeductibleDesired];

/**
 * Dentist
 *
 * Generic Dentist
 */
export type Dentist = {
  /**
   * Pk
   */
  pk?: string;
  information?: DentistInformation;
  additionalPricing?: DentistAdditionalPricing;
  procedures?: DentistProcedures;
  underwritingQuestions?: DentistUnderwritingQuestions;
  /**
   * Ratedprice
   */
  ratedPrice?: number | null;
  /**
   * Finalratedclassification
   */
  finalRatedClassification?: string | null;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
  /**
   * Premiums
   */
  premiums?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  /**
   * Taxes
   */
  taxes?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  /**
   * Premiumdetail
   */
  premiumDetail?: {
    [key: string]: unknown;
  };
  /**
   * Erpquotesnapshot
   */
  erpQuoteSnapshot?: {
    [key: string]: unknown;
  } | null;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
  /**
   * Expirationdate
   */
  readonly expirationDate: string | null;
  /**
   * Effectivedate
   */
  readonly effectiveDate: string | null;
  /**
   * Alltemplateformscomplete
   */
  readonly allTemplateFormsComplete: boolean;
};

/**
 * DentistAdditionalPricing
 */
export type DentistAdditionalPricing = {
  claimsClosed?: YesNoEnum | null;
  /**
   * Experienceratingfactor
   */
  experienceRatingFactor?: number | null;
  /**
   * Yearoflastclaim
   */
  yearOfLastClaim?: number | null;
  /**
   * Dentistflatpremiumadjustment
   */
  dentistFlatPremiumAdjustment?: number | null;
  /**
   * Losspreventionmod
   */
  lossPreventionMod?: number | null;
  treatmentUnderIvSedation?: YesNoEnum | null;
  treatmentUnderOralSedation?: YesNoEnum | null;
  treatmentByAnother?: YesNoEnum | null;
  /**
   * Proceduremix
   */
  procedureMix?: number | null;
  /**
   * Proceduremixexplanation
   */
  procedureMixExplanation?: string | null;
  completeHistory?: YesNoEnum | null;
  cbctImaging?: YesNoEnum | null;
  residencyCompleted?: YesNoEnum | null;
  boardCertified?: YesNoEnum | null;
  /**
   * Exposuremod
   */
  exposureMod?: number | null;
  /**
   * Exposuremodexplanation
   */
  exposureModExplanation?: string | null;
  electiveCosmeticProcedures?: YesNoEnum | null;
  holisticServices?: YesNoEnum | null;
  locumTenens?: YesNoEnum | null;
  teledentistry?: YesNoEnum | null;
  tempStaffingAgency?: YesNoEnum | null;
  /**
   * Unusualriskcharacteristics
   */
  unusualRiskCharacteristics?: number | null;
  /**
   * Classriskcharacteristicscreditsdebits
   */
  classRiskCharacteristicsCreditsDebits?: number | null;
  additionalUnusualRiskCharacteristicsExplanation?: UnusualRiskExplanation | null;
  /**
   * Unusualriskcharacteristicsexplanation
   */
  unusualRiskCharacteristicsExplanation?: string | null;
  moAdditionalCreditDebit?: MoAdditionalCreditDebit;
  nyAdditionalCreditDebit?: NyAdditionalCreditDebit;
  /**
   * Underwritingspecificriskcharacteristics
   */
  underwritingSpecificRiskCharacteristics?: number | null;
  /**
   * Underwritingspecificriskcharacteristicsexplanation
   */
  underwritingSpecificRiskCharacteristicsExplanation?: string | null;
  /**
   * Totalscheduleratingfordentistpl
   */
  totalScheduleRatingForDentistPl?: number | null;
  useLargeGroupFactor?: YesNoEnum | null;
  /**
   * Parenthadclassriskvalue
   */
  parentHadClassRiskValue?: boolean | null;
};

export const DentistFormLevels = {
  INSURED_DENTIST: 'INSURED_DENTIST',
  INSURED_DENTIST_AND_OWNED_ENTITY: 'INSURED_DENTIST_AND_OWNED_ENTITY',
} as const;

export type DentistFormLevels =
  (typeof DentistFormLevels)[keyof typeof DentistFormLevels];

/**
 * DentistInformation
 */
export type DentistInformation = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Dentistid
   */
  dentistId: string;
  /**
   * Firstname
   */
  firstName?: string;
  /**
   * Middlename
   */
  middleName?: string | null;
  /**
   * Lastname
   */
  lastName?: string;
  /**
   * Professionaldesignation
   */
  professionalDesignation?: Array<ItemsEnum>;
  numHoursPerWeek?: WeeklyPracticeHours | null;
  moonlightingReason?: MoonlightingReason | null;
  /**
   * Moonlightingreasondescription
   */
  moonlightingReasonDescription?: string | null;
  /**
   * Projectedresidencycompletiondate
   */
  projectedResidencyCompletionDate?: string | null;
  practiceSpecialty?: PracticeSpecialty | null;
  /**
   * Primarypracticelocation
   */
  primaryPracticeLocation?: string | null;
  yearsInPractice?: YearsPracticing | null;
  /**
   * Yearswithaspen
   */
  yearsWithAspen?: number | null;
  boardCertified?: YesNoEnum | null;
  /**
   * Dateofbirth
   */
  dateOfBirth?: string | null;
  /**
   * Datepcfpremiumreceived
   */
  datePcfPremiumReceived?: string | null;
  differentLimitDesired?: YesNoEnum | null;
  /**
   * Emailaddress
   */
  emailAddress?: string | null;
  /**
   * Inpcfcertificatenumber
   */
  inPcfCertificateNumber?: string | null;
  inPcfFundParticipation?: InpcfParticipation | null;
  /**
   * Inpcfproviderid
   */
  inPcfProviderId?: string | null;
  /**
   * Inpcfsurchargeamount
   */
  inPcfSurchargeAmount?: number | null;
  laPcfFundParticipation?: YesNoEnum | null;
  leaveOfAbsence?: LeaveOfAbsence | null;
  /**
   * Loastartdate
   */
  loaStartDate?: string | null;
  /**
   * Loasetontransactionnumber
   */
  loaSetOnTransactionNumber?: number | null;
  /**
   * Loanumberofdays
   */
  loaNumberOfDays?: number | null;
  memberOfSda?: YesNoEnum | null;
  /**
   * Nameofdentalschool
   */
  nameOfDentalSchool?: string | null;
  yearMonthGraduation?: YearMonth | null;
  firstTimePractice?: YesNoEnum | null;
  newDentistType?: NewDentistType | null;
  noseCoverage?: YesNoEnum | null;
  noseCoverageLiabilityLimits?: LimitsEnum | null;
  /**
   * Nosecoverageprioractsdate
   */
  noseCoveragePriorActsDate?: string | null;
  numYearsDuration?: DurationYears | null;
  optinForRiskNewsletter?: YesNoEnum | null;
  practiceProfile?: PracticeProfile | null;
  /**
   * Prioractsdate
   */
  priorActsDate?: string | null;
  professionalLiabilityLimit?: LimitsEnum | null;
  renumeration?: YesNoEnum | null;
  residencyCompleted?: YesNoEnum | null;
  riskManagementSeminar?: YesNoEnum | null;
  /**
   * Secondarypracticelocations
   */
  secondaryPracticeLocations?: Array<string>;
  /**
   * Volunteerservices
   */
  volunteerServices?: string | null;
  workScheduleAvailable?: YesNoEnum | null;
  /**
   * Yearofattendance
   */
  yearOfAttendance?: number | null;
  yearsWithoutClaim?: YearsNoClaims | null;
  reviewRequired?: YesNoEnum | null;
  agreedRepresentationsAndFraud?: YesNoEnum | null;
  /**
   * Signature
   */
  signature?: string | null;
  /**
   * Signaturedate
   */
  signatureDate?: string | null;
  truthmd?: TruthMdData | null;
  /**
   * Erpexpirationdate
   *
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: string | null;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
  /**
   * Npinumber
   *
   * NPI number from TruthMD data.
   */
  readonly npiNumber: number | null;
  /**
   * Licenses
   *
   * Licenses from TruthMD data.
   */
  readonly licenses: Array<DentistLicense>;
};

/**
 * DentistLicense
 *
 * Dentist License
 */
export type DentistLicense = {
  /**
   * Licensenumber
   */
  licenseNumber?: string | null;
  licenseState?: UsStateEnum | null;
  /**
   * Licensestatus
   */
  licenseStatus?: string | null;
  priorDisciplinaryAction?: YesNoEnum | null;
};

/**
 * DentistProcedures
 */
export type DentistProcedures = {
  generalAnesthesia?: YesNoEnum | null;
  /**
   * Procedures
   */
  procedures?: Array<Procedure>;
  /**
   * Noprocedures
   */
  noProcedures?: boolean;
  completeHealthHistory?: YesNoEnum | null;
  patientRecordNoted?: YesNoEnum | null;
  /**
   * Professionalservices
   */
  professionalServices?: Array<ProfessionalService>;
  whoAdministersAnesthesia?: WhoAdministersAnesthesia | null;
};

/**
 * DentistSchedule
 *
 * EPLI dentist schedule entry — the SINGLE canonical definition.
 *
 * Re-exported by ``counterpart.aspen.policy_schema`` (which annotates
 * ``EmploymentPracticesLiability.dentists_schedule`` with it). PR #118
 * briefly duplicated this class there, so replayed EPLI events built one
 * class while handlers built the other (the twin-class replay quirk);
 * do not redefine it — import from here or via the
 * policy_schema re-export. Both module paths must stay importable: pickled
 * aggregate snapshots reference whichever path defined the instance's
 * class at pickle time.
 */
export type DentistSchedule = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Prioractsdate
   */
  priorActsDate: string | null;
};

/**
 * DentistUnderwritingQuestions
 */
export type DentistUnderwritingQuestions = {
  coveredByAnotherPolicy?: YesNoEnum | null;
  /**
   * Currentcarrier
   */
  currentCarrier?: string | null;
  hasAbsence?: YesNoEnum | null;
  hasMaintainedCoverage?: YesNoEnum | null;
  hasMalpracticeClaim?: YesNoEnum | null;
  hasPendingClaims?: YesNoEnum | null;
  hasReportedSituation?: YesNoNaEnum | null;
  /**
   * Negativeeventexplanation
   */
  negativeEventExplanation?: string | null;
  /**
   * Negativeevents
   */
  negativeEvents?: {
    [key in CounterpartAspenEnumsNegativeEvent]?: YesNoEnum | null;
  };
  /**
   * Whereservicesrendered
   */
  whereServicesRendered?: Array<RendersService>;
  /**
   * Yearscontinuouscoverage
   */
  yearsContinuousCoverage?: number | null;
  treatmentOfSleepApnea?: YesNoEnum | null;
};

/**
 * Details
 */
export type Details = {
  /**
   * Entityname
   */
  entityName?: string | null;
  /**
   * Associateddba
   */
  associatedDba?: string | null;
  entityCoverage?: EntityCoverage | null;
  /**
   * Entityfein
   */
  entityFein?: string | null;
  stateOfDomicile?: UsStateEnum | null;
  /**
   * Dentistsschedule
   */
  dentistsSchedule?: Array<string>;
  firstNamedInsuredIndicator?: YesNoEnum | null;
  /**
   * Businesspurpose
   */
  businessPurpose?: string | null;
  /**
   * Prioractsdate
   */
  priorActsDate?: string | null;
  inPcfFundParticipation?: InpcfParticipation | null;
  /**
   * Inpcfproviderid
   */
  inPcfProviderId?: string | null;
  /**
   * Inpcfcertificatenumber
   */
  inPcfCertificateNumber?: string | null;
  /**
   * Datepcfpremiumreceived
   */
  datePcfPremiumReceived?: string | null;
  /**
   * Inpcfsurchargeamount
   */
  inPcfSurchargeAmount?: number | null;
};

/**
 * DistanceAttributes
 */
export type DistanceAttributes = {
  /**
   * Distancefeet
   */
  distancefeet?: number | null;
};

/**
 * DistanceToCoast
 */
export type DistanceToCoast = {
  /**
   * Distance
   */
  distance?: number | null;
  unit?: DistanceUnit | null;
};

/**
 * DistanceToShoreResponse
 */
export type DistanceToShoreResponse = {
  /**
   * Attributes
   */
  attributes: DistanceAttributes | MessageAttributes;
};

/**
 * DistanceUnit
 */
export const DistanceUnit = { FEET: 'feet', MILES: 'miles' } as const;

/**
 * DistanceUnit
 */
export type DistanceUnit = (typeof DistanceUnit)[keyof typeof DistanceUnit];

/**
 * DocumentODTFile
 */
export type DocumentOdtFile = {
  /**
   * Cmss3Filepath
   */
  cmsS3FilePath: string;
  /**
   * Filetype
   */
  fileType: string;
  /**
   * Filehash
   */
  fileHash: string;
};

/**
 * DocumentTypeEnum
 */
export const DocumentTypeEnum = {
  ENDORSEMENT: 'ENDORSEMENT',
  AMENDATORY: 'AMENDATORY',
  STAMPS: 'STAMPS',
  NOTICE: 'NOTICE',
  COVERAGE_POLICY_FORM: 'COVERAGE_POLICY_FORM',
  POLICY_DECLARATIONS: 'POLICY_DECLARATIONS',
  COVER_PAGE: 'COVER_PAGE',
  POLICY_FORM_TOC: 'POLICY_FORM_TOC',
  QUOTE_DECLARATIONS: 'QUOTE_DECLARATIONS',
  GTC_POLICY_FORM: 'GTC_POLICY_FORM',
} as const;

/**
 * DocumentTypeEnum
 */
export type DocumentTypeEnum =
  (typeof DocumentTypeEnum)[keyof typeof DocumentTypeEnum];

/**
 * DurationYears
 */
export const DurationYears = {
  1: '1',
  2: '2',
  3: '3',
} as const;

/**
 * DurationYears
 */
export type DurationYears = (typeof DurationYears)[keyof typeof DurationYears];

/**
 * EPLICoverageType
 */
export const EpliCoverageType = {
  NO_COVERAGE: 'no_coverage',
  DEFENSE: 'defense',
  INDEMNITY_DEFENSE_STANDARD: 'indemnity_defense_standard',
  INDEMNITY_DEFENSE_ENHANCED: 'indemnity_defense_enhanced',
} as const;

/**
 * EPLICoverageType
 */
export type EpliCoverageType =
  (typeof EpliCoverageType)[keyof typeof EpliCoverageType];

/**
 * ERISAAndEmployeeBenefits
 */
export type ErisaAndEmployeeBenefits = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  limitOfInsurance?: ErisaLimitOfInsurance | null;
  /**
   * Prioractsdate
   */
  priorActsDate?: string | null;
  /**
   * Totalemployees
   */
  totalEmployees?: number | null;
  anyLosses?: YesNoEnum | null;
  coveragePart?: CoveragePart;
  /**
   * Erpexpirationdate
   *
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: string | null;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
};

/**
 * ERISALimitOfInsurance
 */
export const ErisaLimitOfInsurance = {
  '25K': '25k',
  '100K': '100k',
  '101K': '101k',
  '250K': '250k',
  '500K': '500k',
  '750K': '750k',
  '1M': '1m',
} as const;

/**
 * ERISALimitOfInsurance
 */
export type ErisaLimitOfInsurance =
  (typeof ErisaLimitOfInsurance)[keyof typeof ErisaLimitOfInsurance];

/**
 * ERPDuration
 *
 * ERP Duration
 */
export const ErpDuration = {
  '1_YEAR': '1 Year',
  '2_YEARS': '2 Years',
  '3_YEARS': '3 Years',
  '5_YEARS': '5 Years',
  UNLIMITED: 'Unlimited',
} as const;

/**
 * ERPDuration
 *
 * ERP Duration
 */
export type ErpDuration = (typeof ErpDuration)[keyof typeof ErpDuration];

/**
 * ERPType
 */
export const ErpType = { PREPAID: 'Prepaid', FREE: 'Free' } as const;

/**
 * ERPType
 */
export type ErpType = (typeof ErpType)[keyof typeof ErpType];

/**
 * EarthquakeBuildingClassification
 */
export const EarthquakeBuildingClassification = {
  A1: 'A1',
  B1: 'B1',
  C1: 'C1',
  D1: 'D1',
  D2: 'D2',
  D3: 'D3',
  E1: 'E1',
  E2: 'E2',
  E3: 'E3',
} as const;

/**
 * EarthquakeBuildingClassification
 */
export type EarthquakeBuildingClassification =
  (typeof EarthquakeBuildingClassification)[keyof typeof EarthquakeBuildingClassification];

/**
 * EarthquakeCoverage
 */
export const EarthquakeCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  NOT_ELIGIBLE: 'not_eligible',
  NONE: 'none',
  DESIRED: 'desired',
} as const;

/**
 * EarthquakeCoverage
 */
export type EarthquakeCoverage =
  (typeof EarthquakeCoverage)[keyof typeof EarthquakeCoverage];

/**
 * ElectronicEquipCoverage
 */
export const ElectronicEquipCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  NONE: 'none',
} as const;

/**
 * ElectronicEquipCoverage
 */
export type ElectronicEquipCoverage =
  (typeof ElectronicEquipCoverage)[keyof typeof ElectronicEquipCoverage];

/**
 * Employee
 */
export type Employee = {
  employeeType?: EmployeeType | null;
  /**
   * Numfulltime
   */
  numFulltime?: number | null;
  /**
   * Numparttime
   */
  numParttime?: number | null;
};

/**
 * EmployeeDishonestyCoverage
 */
export const EmployeeDishonestyCoverage = {
  '$100,000': '$100,000',
  '$50,000': '$50,000',
  '$75,000': '$75,000',
  '$35,000': '$35,000',
} as const;

/**
 * EmployeeDishonestyCoverage
 */
export type EmployeeDishonestyCoverage =
  (typeof EmployeeDishonestyCoverage)[keyof typeof EmployeeDishonestyCoverage];

/**
 * EmployeeType
 */
export const EmployeeType = {
  DENTAL_ANESTHESIOLOGISTS: 'dental_anesthesiologists',
  DENTISTS: 'dentists',
  ORAL_SURGEONS: 'oral_surgeons',
} as const;

/**
 * EmployeeType
 */
export type EmployeeType = (typeof EmployeeType)[keyof typeof EmployeeType];

/**
 * EmploymentPracticesLiability
 */
export type EmploymentPracticesLiability = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  epliCoverageType?: EpliCoverageType | null;
  /**
   * Dentistsschedule
   */
  dentistsSchedule?: Array<DentistSchedule>;
  /**
   * Entitiesschedule
   */
  entitiesSchedule?: Array<EntitySchedule>;
  /**
   * Epliprioractsdate
   */
  epliPriorActsDate?: string | null;
  /**
   * Numnondentistemployees
   */
  numNonDentistEmployees?: number | null;
  /**
   * Numindependentdentists
   */
  numIndependentDentists?: number | null;
  /**
   * Numemployeedentists
   */
  numEmployeeDentists?: number | null;
  /**
   * Numindependenthygienists
   */
  numIndependentHygienists?: number | null;
  limitOfInsurance?: LimitOfInsurance | null;
  deductible?: Deductible | null;
  sublimitedCoverageDesired?: YesNoEnum | null;
  /**
   * Negativeevents
   */
  negativeEvents?: Array<GlacierPolicyDomainTypeDictsNegativeEvent> | null;
  /**
   * Negativeeventsexplanation
   */
  negativeEventsExplanation?: string | null;
  /**
   * Natureofoperations
   */
  natureOfOperations?: number | null;
  /**
   * Natureofworkforce
   */
  natureOfWorkforce?: number | null;
  /**
   * Salaries
   */
  salaries?: number | null;
  /**
   * Writtenprocedures
   */
  writtenProcedures?: number | null;
  /**
   * Electroniccommunicationpolicies
   */
  electronicCommunicationPolicies?: number | null;
  /**
   * Experienceratingvalue
   */
  experienceRatingValue?: number | null;
  coveragePart?: CoveragePart;
  /**
   * Erpexpirationdate
   *
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: string | null;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
  /**
   * Defenseonlylimit
   */
  readonly defenseOnlyLimit: number | null;
  /**
   * Totalindividuals
   */
  readonly totalIndividuals: number;
  /**
   * Totalschedulerating
   */
  readonly totalScheduleRating: number;
};

/**
 * EntityCoverage
 */
export const EntityCoverage = {
  NONE: 'none',
  SEPARATE: 'separate',
  SHARED: 'shared',
  SHARE_FIRST_NAME: 'share_first_name',
} as const;

/**
 * EntityCoverage
 */
export type EntityCoverage =
  (typeof EntityCoverage)[keyof typeof EntityCoverage];

export type EntityFormLevels = 'INSURED_DENTIST_AND_OWNED_ENTITY';

/**
 * EntitySchedule
 *
 * EPLI owned-entity schedule entry — the SINGLE canonical definition.
 *
 * Same re-export / pickle contract as ``DentistSchedule`` above.
 */
export type EntitySchedule = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Prioractsdate
   */
  priorActsDate: string | null;
};

/**
 * EntitySharedLimitsType
 *
 * Entity Shared Limits Type options
 */
export const EntitySharedLimitsType = {
  SHARED_WITH_MEMBER_DENTISTS: 'shared_with_member_dentists',
  SHARED_WITH_OTHER_ENTITIES: 'shared_with_other_entities',
} as const;

/**
 * EntitySharedLimitsType
 *
 * Entity Shared Limits Type options
 */
export type EntitySharedLimitsType =
  (typeof EntitySharedLimitsType)[keyof typeof EntitySharedLimitsType];

/**
 * EntityType
 */
export const EntityType = {
  ASSOCIATION: 'association',
  TESTING_BOARD: 'testing_board',
} as const;

/**
 * EntityType
 */
export type EntityType = (typeof EntityType)[keyof typeof EntityType];

/**
 * EquipmentBreakdownDeductible
 */
export const EquipmentBreakdownDeductible = {
  500: '500',
  1000: '1000',
  2500: '2500',
  5000: '5000',
  10000: '10000',
} as const;

/**
 * EquipmentBreakdownDeductible
 */
export type EquipmentBreakdownDeductible =
  (typeof EquipmentBreakdownDeductible)[keyof typeof EquipmentBreakdownDeductible];

/**
 * ExpirationDateChangeDirection
 *
 * Direction of a "Change Expiration Date" midterm endorsement.
 *
 * EXTEND — new expiration date is after the current expiration date.
 * The change takes effect on the original expiration date and the rating
 * engine charges pro-rata premium for the additional term.
 *
 * SHORTEN — new expiration date is before the current expiration date.
 * The change takes effect on the policy effective date so the rating
 * engine returns pro-rata premium for the shortened term.
 */
export const ExpirationDateChangeDirection = {
  EXTEND: 'extend',
  SHORTEN: 'shorten',
} as const;

/**
 * ExpirationDateChangeDirection
 *
 * Direction of a "Change Expiration Date" midterm endorsement.
 *
 * EXTEND — new expiration date is after the current expiration date.
 * The change takes effect on the original expiration date and the rating
 * engine charges pro-rata premium for the additional term.
 *
 * SHORTEN — new expiration date is before the current expiration date.
 * The change takes effect on the policy effective date so the rating
 * engine returns pro-rata premium for the shortened term.
 */
export type ExpirationDateChangeDirection =
  (typeof ExpirationDateChangeDirection)[keyof typeof ExpirationDateChangeDirection];

/**
 * TermConversionEnum
 *
 * Term conversion applied by a "Change Expiration Date" midterm endorsement.
 */
export const TermConversionEnum = {
  TWO_YEAR_NEW_GRAD: 'two_year_new_grad',
} as const;

/**
 * TermConversionEnum
 *
 * Term conversion applied by a "Change Expiration Date" midterm endorsement.
 */
export type TermConversionEnum =
  (typeof TermConversionEnum)[keyof typeof TermConversionEnum];

/**
 * FileDocument
 */
export type FileDocument = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Name
   */
  name: string;
  createdBy: UserObject | null;
  replacedBy?: UserObject | null;
  /**
   * Createdat
   */
  createdAt: string;
  /**
   * Lastreplacedat
   */
  lastReplacedAt?: string | null;
  /**
   * Createdattransaction
   */
  createdAtTransaction: number;
  documentType: AttachedDocumentType;
  /**
   * Systemgenerated
   */
  systemGenerated: boolean;
  /**
   * Originalsequencenumber
   */
  originalSequenceNumber: number;
  /**
   * Description
   */
  description?: string;
  /**
   * Subcategory
   */
  subcategory?: string;
  /**
   * Filehistory
   */
  fileHistory?: Array<FileDocumentHistory>;
  readonly file: ImmutableFile;
};

/**
 * FileDocumentHistory
 */
export type FileDocumentHistory = {
  /**
   * Fileid
   */
  fileId: string;
  replacedBy?: UserObject | null;
  /**
   * Replacedat
   */
  replacedAt: string;
  fallbackFile?: ImmutableFile | null;
};

/**
 * FireWaterLimit
 */
export const FireWaterLimit = {
  '500K': '500k',
  '750K': '750k',
  '1M': '1m',
} as const;

/**
 * FireWaterLimit
 */
export type FireWaterLimit =
  (typeof FireWaterLimit)[keyof typeof FireWaterLimit];

/**
 * FirstNamedInsuredType
 */
export const FirstNamedInsuredType = {
  CORPORATION: 'corporation',
  INDIVIDUAL: 'individual',
  LLC: 'llc',
  LLP: 'llp',
  OTHER: 'other',
  PARTNERSHIP: 'partnership',
  PC_PA: 'pc_pa',
  MULTI_INDIVIDUAL: 'multi_individual',
} as const;

/**
 * FirstNamedInsuredType
 */
export type FirstNamedInsuredType =
  (typeof FirstNamedInsuredType)[keyof typeof FirstNamedInsuredType];

/**
 * FloodCoverage
 */
export const FloodCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  NOT_ELIGIBLE: 'not_eligible',
} as const;

/**
 * FloodCoverage
 */
export type FloodCoverage = (typeof FloodCoverage)[keyof typeof FloodCoverage];

/**
 * FloodRiskScoreResponse
 */
export type FloodRiskScoreResponse = {
  /**
   * Baseriskscore
   */
  baseRiskScore: string | null;
  /**
   * Baseriskrating
   */
  baseRiskRating: string | null;
  /**
   * Floodzone
   */
  floodZone: string | null;
};

/**
 * GeneralLiability
 */
export type GeneralLiability = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  limitOfInsurance?: LimitsEnum | null;
  separateAggregate?: YesNoEnum | null;
  hiredAutoDamage?: YesNoEnum | null;
  fireWaterLegalLimit?: FireWaterLimit | null;
  losses?: YesNoEnum | null;
  /**
   * Locationidsglnotcharged
   */
  locationIdsGlNotCharged?: Array<string>;
  stopGapCoverageDesired?: YesNoEnum | null;
  stopGapLimit?: StopGapLimit | null;
  /**
   * Additionalinsured
   */
  additionalInsured?: Array<GeneralLiabilityAdditionalInsured>;
  /**
   * Flatpremiumadjustment
   */
  flatPremiumAdjustment?: number | null;
  coveragePart?: CoveragePart;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
};

/**
 * GeneralLiabilityAdditionalInsured
 */
export type GeneralLiabilityAdditionalInsured = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Pk
   */
  pk: string;
  /**
   * Fallbackpk
   */
  fallbackPk?: string | null;
  typeOfContract?: TypeOfContract | null;
  /**
   * Entityname
   */
  entityName?: string | null;
  entityAddress?: UsAddress | null;
  /**
   * Newentityaddress
   */
  newEntityAddress?: string | null;
  /**
   * Insuredlocation
   */
  insuredLocation?: string | null;
  /**
   * Description
   */
  description?: string | null;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
  /**
   * Alltemplateformscomplete
   */
  readonly allTemplateFormsComplete: boolean;
};

export const GlAdditionalInsuredFormLevels = {
  GL_ADDITIONAL_INSURED: 'GL_ADDITIONAL_INSURED',
  GL_ADDITIONAL_INSURED_OR_LOCATION: 'GL_ADDITIONAL_INSURED_OR_LOCATION',
} as const;

export type GlAdditionalInsuredFormLevels =
  (typeof GlAdditionalInsuredFormLevels)[keyof typeof GlAdditionalInsuredFormLevels];

/**
 * HailRiskResponse
 */
export type HailRiskResponse = {
  /**
   * Riskscore
   */
  riskScore: string | null;
};

/**
 * HoldHarmlessClause
 */
export const HoldHarmlessClause = {
  YES: 'yes',
  NO: 'no',
  UNSURE: 'unsure',
} as const;

/**
 * HoldHarmlessClause
 */
export type HoldHarmlessClause =
  (typeof HoldHarmlessClause)[keyof typeof HoldHarmlessClause];

/**
 * INPCFParticipation
 */
export const InpcfParticipation = {
  NO: 'no',
  REFER: 'refer',
  YES: 'yes',
} as const;

/**
 * INPCFParticipation
 */
export type InpcfParticipation =
  (typeof InpcfParticipation)[keyof typeof InpcfParticipation];

/**
 * ImmutableFile
 */
export type ImmutableFile = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Name
   */
  name: string;
  /**
   * Contenttype
   */
  contentType?: string;
  /**
   * Hash
   */
  hash: string;
  /**
   * Size
   */
  size: number;
  /**
   * Isrendered
   */
  isRendered?: boolean;
};

/**
 * InflationGuard
 */
export const InflationGuard = {
  N_A: 'N/A',
  '0_3%': '0.3%',
  '0_4%': '0.4%',
  '0_5%': '0.5%',
  '1_0%': '1.0%',
  '1_5%': '1.5%',
  '2_0%': '2.0%',
  '2_5%': '2.5%',
  '3_0%': '3.0%',
  '3_5%': '3.5%',
  '4_0%': '4.0%',
  '4_5%': '4.5%',
  '5_0%': '5.0%',
} as const;

/**
 * InflationGuard
 */
export type InflationGuard =
  (typeof InflationGuard)[keyof typeof InflationGuard];

/**
 * Information
 */
export type Information = {
  accountsReceivableCoverage?: AccountsReceivableCoverage | null;
  blanketDentalPracticePersonalPropertyDesired?: YesNoEnum | null;
  /**
   * Accountsreceivablelimit
   */
  accountsReceivableLimit?: number | null;
  appurtenantStructureDesired?: YesNoEnum | null;
  /**
   * Appurtenantstructurelimit
   */
  appurtenantStructureLimit?: number | null;
  /**
   * Appurtenantstructuredescription
   */
  appurtenantStructureDescription?: string | null;
  roofSurfactingLimitationsDesired?: YesNoEnum | null;
  electronicEquipSurgeProtectors?: YesNoEnum | null;
  equipmentBreakdownDeductible?: EquipmentBreakdownDeductible | null;
  basicEarthquakeLimits?: BasicEarthquakeLimits | null;
  /**
   * Basicfloodlimits
   */
  basicFloodLimits?: number | null;
  /**
   * Buildingallowablerange
   */
  buildingAllowableRange?: number | null;
  buildingCoverageDesired?: YesNoEnum | null;
  buildingInflationGuard?: BuildingInflationGuard | null;
  buildingLeasedToOthers?: YesNoEnum | null;
  /**
   * Buildinglimit
   */
  buildingLimit?: number | null;
  /**
   * Buildingreplacementcost
   */
  buildingReplacementCost?: number | null;
  contentsInflationGuard?: InflationGuard | null;
  /**
   * Contentslimit
   */
  contentsLimit?: number | null;
  earthquakeBuildingClass?: EarthquakeBuildingClassification | null;
  ordinanceIncreaseLimitDesired?: OrdinanceLimit | null;
  demolitionIncreasedLimitDesired?: OrdinanceLimit | null;
  /**
   * Demolitionlimit
   */
  demolitionLimit?: number | null;
  electronicEquipCoverage?: ElectronicEquipCoverage | null;
  /**
   * Totalelectronicequiplimit
   */
  totalElectronicEquipLimit?: number | null;
  equipmentBreakdownCoverageDesired?: YesNoEnum | null;
  /**
   * Grossannualizedrevenue
   */
  grossAnnualizedRevenue?: number | null;
  /**
   * Higherlossassessmentlimit
   */
  higherLossAssessmentLimit?: number | null;
  practiceIncomeDesired?: YesNoEnum | null;
  incomeDocumentationReceived?: YesNoEnum | null;
  /**
   * Locationflatdeductible
   */
  locationFlatDeductible?: number | null;
  lossAssessment?: LossAssessment | null;
  mineSubsidenceDesired?: YesNoEnum | null;
  /**
   * Minesubsidencelimit
   */
  mineSubsidenceLimit?: number | null;
  namedStormDeductible?: NamedStormDeductible | null;
  /**
   * Numberofdaysopenperweek
   */
  numberOfDaysOpenPerWeek?: number | null;
  /**
   * Percentageleasedtoothers
   */
  percentageLeasedToOthers?: number | null;
  practiceIncomeWaitingPeriod?: PracticeIncomeWaitingPeriod | null;
  rentsCoverageDesired?: YesNoEnum | null;
  /**
   * Rentslimitofinsurance
   */
  rentsLimitOfInsurance?: number | null;
  /**
   * Valueddailylimitdays
   */
  valuedDailyLimitDays?: number | null;
  windhailCoverage?: WindHailCoverage | null;
  sewerBackupCoverage?: SewerBackupCoverage | null;
  /**
   * Totalsewerbackuplimit
   */
  totalSewerBackupLimit?: number | null;
  pollutionLimitCoverage?: StandardOrHigher | null;
  /**
   * Totalpollutionlimit
   */
  totalPollutionLimit?: number | null;
  floodCoverage?: FloodCoverage | null;
  /**
   * Totalfloodlimit
   */
  totalFloodLimit?: number | null;
  earthquakeCoverage?: EarthquakeCoverage | null;
  /**
   * Totalearthquakelimit
   */
  totalEarthquakeLimit?: number | null;
  lossAssessmentCoverage?: LossAssessment | null;
  /**
   * Totallossassessmentlimit
   */
  totalLossAssessmentLimit?: number | null;
  offPremCoverage?: OffPremCoverage | null;
  /**
   * Totaloffpremlimit
   */
  totalOffPremLimit?: number | null;
  signsCoverage?: StandardOrHigher | null;
  /**
   * Totalsignslimit
   */
  totalSignsLimit?: number | null;
};

/**
 * InformedConsentType
 */
export const InformedConsentType = {
  WRITTEN: 'written',
  ORAL: 'oral',
  NONE: 'none',
} as const;

/**
 * InformedConsentType
 */
export type InformedConsentType =
  (typeof InformedConsentType)[keyof typeof InformedConsentType];

/**
 * InsuranceLinesEnum
 *
 * Insurance Lines/Coverages
 */
export const InsuranceLinesEnum = {
  PL: 'pl',
  EPLI: 'epli',
  GL: 'gl',
  ERISA: 'erisa',
  CP: 'cp',
  CYBER: 'cyber',
} as const;

/**
 * InsuranceLinesEnum
 *
 * Insurance Lines/Coverages
 */
export type InsuranceLinesEnum =
  (typeof InsuranceLinesEnum)[keyof typeof InsuranceLinesEnum];

/**
 * LeaveOfAbsence
 */
export const LeaveOfAbsence = {
  INITIATE_MILITARY: 'initiate_military',
  INITIATE_REGULAR: 'initiate_regular',
} as const;

/**
 * LeaveOfAbsence
 */
export type LeaveOfAbsence =
  (typeof LeaveOfAbsence)[keyof typeof LeaveOfAbsence];

/**
 * LimitOfInsurance
 */
export const LimitOfInsurance = {
  '25K': '25k',
  '50K': '50k',
  '75K': '75k',
  '100K': '100k',
  '101K': '101k',
  '250K': '250k',
  '500K': '500k',
  '750K': '750k',
  '1M': '1m',
} as const;

/**
 * LimitOfInsurance
 */
export type LimitOfInsurance =
  (typeof LimitOfInsurance)[keyof typeof LimitOfInsurance];

/**
 * LimitsEnum
 */
export const LimitsEnum = {
  LIMIT_1M_1M: 'limit_1m_1m',
  LIMIT_1M_2M: 'limit_1m_2m',
  LIMIT_1M_3M: 'limit_1m_3m',
  LIMIT_2M_3M: 'limit_2m_3m',
  LIMIT_2M_4M: 'limit_2m_4m',
  LIMIT_2M_6M: 'limit_2m_6m',
  LIMIT_3M_3M: 'limit_3m_3m',
  LIMIT_3M_6M: 'limit_3m_6m',
  LIMIT_4M_4M: 'limit_4m_4m',
  LIMIT_5M_5M: 'limit_5m_5m',
  LIMIT_5M_6M: 'limit_5m_6m',
  LIMIT_5M_8M: 'limit_5m_8m',
  LIMIT_2M_2M: 'limit_2m_2m',
  LIMIT_3M_9M: 'limit_3m_9m',
  LIMIT_500K_1M: 'limit_500k_1m',
  LIMIT_500K_1500K: 'limit_500k_1500k',
  LIMIT_100K_300K: 'limit_100k_300k',
  LIMIT_200K_600K: 'limit_200k_600k',
  LIMIT_250K_500K: 'limit_250k_500k',
  LIMIT_250K_750K: 'limit_250k_750k',
  LIMIT_1300K_3900K: 'limit_1300k_3900k',
  LIMIT_1925K_5775K: 'limit_1925k_5775k',
  LIMIT_2050K_6150K: 'limit_2050k_6150k',
  LIMIT_2100K_6300K: 'limit_2100k_6300k',
  LIMIT_2150K_6450K: 'limit_2150k_6450k',
  LIMIT_2200K_6600K: 'limit_2200k_6600k',
  LIMIT_2250K_6750K: 'limit_2250k_6750k',
  LIMIT_2300K_6900K: 'limit_2300k_6900k',
  LIMIT_2350K_7050K: 'limit_2350k_7050k',
  LIMIT_2400K_7200K: 'limit_2400k_7200k',
  LIMIT_2450K_7350K: 'limit_2450k_7350k',
  LIMIT_2500K_7500K: 'limit_2500k_7500k',
  LIMIT_2550K_7650K: 'limit_2550k_7650k',
  LIMIT_2600K_7800K: 'limit_2600k_7800k',
  LIMIT_2650K_7950K: 'limit_2650k_7950k',
  LIMIT_2700K_8100K: 'limit_2700k_8100k',
  LIMIT_2750K_8250K: 'limit_2750k_8250k',
  LIMIT_2800K_8400K: 'limit_2800k_8400k',
  LIMIT_2850K_8550K: 'limit_2850k_8550k',
  LIMIT_2900K_8700K: 'limit_2900k_8700k',
  LIMIT_2950K_8850K: 'limit_2950k_8850k',
} as const;

/**
 * LimitsEnum
 */
export type LimitsEnum = (typeof LimitsEnum)[keyof typeof LimitsEnum];

/**
 * Location
 */
export type Location = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Pk
   */
  pk?: string;
  information?: Information;
  rating?: Rating;
  /**
   * Ratedprice
   */
  ratedPrice?: number;
  /**
   * Premiumdetail
   */
  premiumDetail?: {
    [key: string]: unknown;
  };
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
};

export type LocationFormLevels = 'LOCATION';

/**
 * LossAssessment
 */
export const LossAssessment = {
  HIGHER: 'higher',
  NO: 'no',
  ONE_K: 'one_k',
  TEN_K: 'ten_k',
  FIVE_K: 'five_k',
  TWENTY_FIVE_K: 'twenty_five_k',
  FIFTY_K: 'fifty_k',
  ONE_HUNDRED_K: 'one_hundred_k',
} as const;

/**
 * LossAssessment
 */
export type LossAssessment =
  (typeof LossAssessment)[keyof typeof LossAssessment];

/**
 * MOAdditionalCreditDebit
 */
export type MoAdditionalCreditDebit = {
  documentedPlan?: YesNoEnum | null;
  comprehensiveInfectionControl?: YesNoEnum | null;
  welldesignedSystem?: YesNoEnum | null;
  trainedPracticeManager?: YesNoEnum | null;
  continuingEducation?: YesNoEnum | null;
  riskManager?: YesNoEnum | null;
  protocols?: YesNoEnum | null;
  training?: YesNoEnum | null;
  implantRestoration?: YesNoEnum | null;
};

/**
 * MajorSystemPermitsResponse
 */
export type MajorSystemPermitsResponse = {
  /**
   * Plbgpermitlastdate
   */
  plbgPermitLastDate: string | string | null;
  /**
   * Elecpermitlastdate
   */
  elecPermitLastDate: string | string | null;
};

/**
 * MessageAttributes
 *
 * we added message field to handle the case when the distance is not available
 */
export type MessageAttributes = {
  /**
   * Message
   */
  message?: string | null;
};

/**
 * MissionOfMercyEvent
 *
 * Mission of Mercy
 */
export type MissionOfMercyEvent = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Eventbeginningdate
   */
  eventBeginningDate?: string | null;
  /**
   * Eventenddate
   */
  eventEndDate?: string | null;
  /**
   * Eventname
   */
  eventName?: string | null;
  eventType?: MissionOfMercyEventType | null;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
  /**
   * Alltemplateformscomplete
   */
  readonly allTemplateFormsComplete: boolean;
};

export type MissionOfMercyEventFormLevels = 'MOM_EVENT';

/**
 * MissionOfMercyEventType
 */
export const MissionOfMercyEventType = {
  ALL: 'all',
  ASSISTANTS_ONLY: 'assistants_only',
} as const;

/**
 * MissionOfMercyEventType
 */
export type MissionOfMercyEventType =
  (typeof MissionOfMercyEventType)[keyof typeof MissionOfMercyEventType];

/**
 * MoonlightingReason
 */
export const MoonlightingReason = {
  RESIDENCY: 'residency',
  MILITARY: 'military',
  SECOND_JOB: 'second_job',
  OTHER: 'other',
} as const;

/**
 * MoonlightingReason
 */
export type MoonlightingReason =
  (typeof MoonlightingReason)[keyof typeof MoonlightingReason];

/**
 * NYAdditionalCreditDebit
 */
export type NyAdditionalCreditDebit = {
  patientDataElectronically?: YesNoEnum | null;
  standardizedDocumentedProcedures?: YesNoEnum | null;
  dedicatedPracticeManager?: YesNoEnum | null;
  documentedProgram?: YesNoEnum | null;
  dedicatedRiskManager?: YesNoEnum | null;
  documentedRiskManagementProtocol?: YesNoEnum | null;
  tmjTherapy?: YesNoEnum | null;
  extractionOfImpactedThirdMolars?: YesNoEnum | null;
  implantPlacementUncoveringRemovalSurgery?: YesNoEnum | null;
  implantRestoration?: YesNoEnum | null;
  molarEndodontics?: YesNoEnum | null;
};

/**
 * NamedStormDeductible
 */
export const NamedStormDeductible = {
  NONE: 'none',
  ONE_PCT: 'one_pct',
  TWO_PCT: 'two_pct',
  '5%': '5%',
} as const;

/**
 * NamedStormDeductible
 */
export type NamedStormDeductible =
  (typeof NamedStormDeductible)[keyof typeof NamedStormDeductible];

/**
 * NegativeEvents
 */
export const NegativeEvents = {
  AWARE: 'aware',
  CLAIM: 'claim',
  DECLINED: 'declined',
  INVOLVED: 'involved',
} as const;

/**
 * NegativeEvents
 */
export type NegativeEvents =
  (typeof NegativeEvents)[keyof typeof NegativeEvents];

/**
 * NewDentistType
 */
export const NewDentistType = {
  FOREIGN: 'foreign',
  MILITARY: 'military',
  NEW_GRAD: 'new_grad',
  PUBLIC: 'public',
} as const;

/**
 * NewDentistType
 */
export type NewDentistType =
  (typeof NewDentistType)[keyof typeof NewDentistType];

/**
 * NonWeatherRiskScoreResponse
 */
export type NonWeatherRiskScoreResponse = {
  /**
   * Nonweatherwaterriskscore
   */
  nonWeatherWaterRiskScore: number | string | null;
};

/**
 * OffPremCoverage
 */
export const OffPremCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  NONE: 'none',
} as const;

/**
 * OffPremCoverage
 */
export type OffPremCoverage =
  (typeof OffPremCoverage)[keyof typeof OffPremCoverage];

/**
 * OrdinanceLimit
 */
export const OrdinanceLimit = {
  STANDARD: 'standard',
  HIGHER: 'higher',
} as const;

/**
 * OrdinanceLimit
 */
export type OrdinanceLimit =
  (typeof OrdinanceLimit)[keyof typeof OrdinanceLimit];

/**
 * OwnedEntity
 */
export type OwnedEntity = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Pk
   */
  pk?: string;
  details?: Details;
  questions?: Questions;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
  /**
   * Premiums
   */
  premiums?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  /**
   * Taxes
   */
  taxes?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  /**
   * Premiumdetail
   */
  premiumDetail?: {
    [key: string]: unknown;
  };
  /**
   * Erpexpirationdate
   *
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: string | null;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
  /**
   * Alltemplateformscomplete
   */
  readonly allTemplateFormsComplete: boolean;
  /**
   * Isfirstnamedinsured
   *
   * Determines if this owned entity is the first named insured.
   * This property requires the entity to be loaded within a Policy context.
   */
  readonly isFirstNamedInsured: boolean;
};

/**
 * OwnerDentistNotInsured
 */
export type OwnerDentistNotInsured = {
  /**
   * Name
   */
  name?: string | null;
  /**
   * Ownershippercentageoutsideaspen
   */
  ownershipPercentageOutsideAspen?: number | null;
};

/**
 * PLSubTypeEnum
 *
 * "Non Large Group (1 TO 9 Dentist(s))",
 * "Large Group (10 Or More Dentists)",
 * "Dental Association / Society",
 * "Testing Board",
 * "Volunteer Only",
 * "Faculty Only (Non Intramural)",
 * "Moonlighting",
 * "2 Year New Grad Policy"
 */
export const PlSubTypeEnum = {
  DENTAL_ASSOCIATION: 'dental_association',
  FACULTY_ONLY: 'faculty_only',
  LARGE_GROUP: 'large_group',
  MOONLIGHTING: 'moonlighting',
  NEW_GRAD: 'new_grad',
  NON_LARGE_DENTIST: 'non_large_dentist',
  TESTING_BOARD: 'testing_board',
  VOLUNTEER_ONLY: 'volunteer_only',
  ENTITY_ONLY: 'entity_only',
} as const;

/**
 * PLSubTypeEnum
 *
 * "Non Large Group (1 TO 9 Dentist(s))",
 * "Large Group (10 Or More Dentists)",
 * "Dental Association / Society",
 * "Testing Board",
 * "Volunteer Only",
 * "Faculty Only (Non Intramural)",
 * "Moonlighting",
 * "2 Year New Grad Policy"
 */
export type PlSubTypeEnum = (typeof PlSubTypeEnum)[keyof typeof PlSubTypeEnum];

export type PlAdditionalInsuredFormLevels = 'PL_ADDITIONAL_INSURED';

/**
 * Policy
 */
export type Policy = {
  /**
   * Pk
   */
  pk?: string;
  /**
   * Policynumber
   */
  policyNumber?: string;
  /**
   * Boundpolicynumber
   */
  boundPolicyNumber?: string;
  /**
   * Sequencenumber
   */
  sequenceNumber?: number;
  /**
   * Isissued
   */
  isIssued?: boolean;
  /**
   * Bypassvalidators
   */
  bypassValidators?: boolean;
  producer?: UserObject | null;
  underwriter?: UserObject | null;
  assignedTo?: UserObject | null;
  referredBy?: UserObject | null;
  /**
   * Transactions
   */
  transactions?: Array<Transaction>;
  /**
   * Documentwarehouse
   */
  documentWarehouse?: Array<FileDocument>;
  /**
   * Additionalmessage
   */
  additionalMessage?: string;
  /**
   * Parentpolicyid
   */
  parentPolicyId?: string | null;
  /**
   * Parentsequencenumber
   */
  parentSequenceNumber?: number | null;
  /**
   * Policyholderid
   */
  policyholderId?: string | null;
  /**
   * Baselineexpirationdate
   */
  baselineExpirationDate?: string | null;
  renewalFlag?: RenewalFlagEnum | null;
  /**
   * Reasonfornonrenewal
   */
  reasonForNonRenewal?: string | null;
  policyStatus?: PolicyStatus;
  /**
   * Deletedat
   */
  deletedAt?: string | null;
  deletedBy?: UserObject | null;
  /**
   * Deletionreason
   */
  deletionReason?: string | null;
  /**
   * Parentpolicynumber
   */
  readonly parentPolicyNumber: string | null;
  /**
   * Year
   */
  readonly year: number | null;
  readonly latestTransaction: Transaction;
  readonly details: PolicyDetails;
  /**
   * Firstnamedinsured
   */
  readonly firstNamedInsured: string;
  /**
   * Haspolicynumber
   */
  readonly hasPolicyNumber: boolean;
  /**
   * Displaynumber
   */
  readonly displayNumber: string;
  /**
   * Flaggedfornonrenewal
   *
   * Returns true if the policy has a non-renewal flag
   */
  readonly flaggedForNonRenewal: boolean;
  /**
   * Flaggedformanualrenewal
   *
   * Returns true if the policy has a manual renewal flag
   */
  readonly flaggedForManualRenewal: boolean;
  /**
   * Policystatuslabel
   *
   * Computed label combining policy_status, transaction_type, and transaction_status.
   * Replaces frontend's HeaderView statusStage construction.
   *
   * Examples:
   * - "PENDING: Midterm Transaction In Progress"
   * - "Policy Cancelled"
   * - "Bindable Quote / In Progress"
   * - "New Business / Active"
   */
  readonly policyStatusLabel: string;
  /**
   * Transactiontypelabel
   *
   * Computed label for transaction type display.
   * Replaces frontend's transactionTypeDisplayText function in cells.tsx.
   *
   * Returns labels like:
   * - "Not Bound"
   * - "Policy Bound"
   * - "Midterm (Endorsement)"
   * - "Policy (Endorsed)"
   * - "Midterm (Cancellation)"
   * - "Policy Cancelled"
   * - "Midterm (Reinstate)"
   * - "Policy Reinstated"
   * - "ERP"
   */
  readonly transactionTypeLabel: string;
  /**
   * Alerts
   *
   * Returns unacknowledged alerts for this policy
   */
  readonly alerts: Array<PolicyAlertObject>;
  /**
   * Dentists
   */
  readonly dentists: Array<Dentist>;
  /**
   * Locations
   */
  readonly locations: Array<PracticeLocation>;
  readonly professionalLiability: ProfessionalLiability;
  readonly commercialProperty: CommercialProperty;
  readonly cyberLiability: CyberLiability;
  /**
   * Ownedentities
   */
  readonly ownedEntities: Array<OwnedEntity>;
  readonly generalLiability: GeneralLiability;
  readonly employmentPracticesLiability: EmploymentPracticesLiability;
  readonly erisaAndEmployeeBenefits: ErisaAndEmployeeBenefits;
  /**
   * Maxallowedpnpdates
   *
   * Calculate the maximum allowed prior acts date for insurance lines.
   */
  readonly maxAllowedPnpDates: {
    [key in InsuranceLinesEnum]?: string;
  };
  /**
   * Annualpremium
   */
  readonly annualPremium: number;
  /**
   * Writtenpremium
   */
  readonly writtenPremium: number;
  /**
   * Coverageparts
   */
  readonly coverageParts: {
    [key in InsuranceLinesEnum]?: CoveragePart;
  };
  /**
   * Writtentax
   */
  readonly writtenTax: number;
  /**
   * Billedtax
   */
  readonly billedTax: number;
  /**
   * Billedpremium
   */
  readonly billedPremium: number;
  /**
   * Attachedforms
   */
  readonly attachedForms: Array<AttachedForm>;
  readonly hasEpliWageAndHour: YesNoEnum;
  /**
   * Alltemplateformscomplete
   */
  readonly allTemplateFormsComplete: boolean;
  /**
   * Canbequoted
   *
   * Determines if the policy can be quoted based on the current transaction's premium values.
   *
   * A policy can be quoted if any of the following premiums are greater than zero:
   * - Written premium
   * - Billed premium
   * - Annual premium
   *
   * Returns:
   * bool: True if the policy can be quoted, False otherwise.
   */
  readonly canBeQuoted: boolean;
  /**
   * Transactionid
   */
  readonly transactionId: string;
};

/**
 * PolicyAlertObject
 */
export type PolicyAlertObject = {
  /**
   * Id
   */
  id: number;
  /**
   * Createdat
   */
  createdAt: string;
  severity: PolicyAlertSeverityEnum;
  type: PolicyAlertTypeEnum;
  /**
   * Message
   */
  message: string;
  createdBy: UserObject | null;
  /**
   * Acknowledged
   */
  acknowledged: boolean;
  acknowledgedBy: UserObject | null;
};

/**
 * PolicyAlertSeverityEnum
 */
export const PolicyAlertSeverityEnum = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

/**
 * PolicyAlertSeverityEnum
 */
export type PolicyAlertSeverityEnum =
  (typeof PolicyAlertSeverityEnum)[keyof typeof PolicyAlertSeverityEnum];

/**
 * PolicyAlertTypeEnum
 */
export const PolicyAlertTypeEnum = {
  PARENT_CHANGED: 'parent_changed',
  PARENT_CANCELLED: 'parent_cancelled',
  AUTO_RENEWAL_FAILURE: 'auto_renewal_failure',
  PREMIUM_INCREASE_SUSPENSION: 'premium_increase_suspension',
} as const;

/**
 * PolicyAlertTypeEnum
 */
export type PolicyAlertTypeEnum =
  (typeof PolicyAlertTypeEnum)[keyof typeof PolicyAlertTypeEnum];

/**
 * PolicyDetails
 *
 * Aggregate detail state; these defaults seed a new policy, not later writes.
 */
export type PolicyDetails = {
  writingCompany?: WritingCompanyEnum | null;
  /**
   * Writingcompanyid
   */
  writingCompanyId?: string | null;
  /**
   * Writingcompanyname
   */
  writingCompanyName?: string | null;
  /**
   * Agency
   */
  agency?: string | null;
  /**
   * Associationcode
   */
  associationCode?: string | null;
  /**
   * Producer
   */
  producer?: string | null;
  /**
   * Producername
   */
  producerName?: string | null;
  policyType?: PolicyTypeEnum | null;
  /**
   * Rolloverexpiringpolicynumber
   */
  rolloverExpiringPolicyNumber?: string | null;
  /**
   * Rolloverexpiringpolicypremium
   */
  rolloverExpiringPolicyPremium?: number | null;
  /**
   * Prioraspenpolicynumber
   */
  priorAspenPolicyNumber?: string | null;
  quoteType?: QuoteTypeEnum | null;
  /**
   * Policyeffectivedate
   */
  policyEffectiveDate?: string | null;
  /**
   * Policyexpirationdate
   */
  policyExpirationDate?: string | null;
  /**
   * Policycancellationdate
   */
  policyCancellationDate?: string | null;
  /**
   * Insurancelinesdesired
   */
  insuranceLinesDesired?: Array<InsuranceLinesEnum>;
  plSubType?: PlSubTypeEnum | null;
  scheduleOnFile?: YesNoEnum | null;
  scheduleFile?: ScheduleFile | null;
  firstNamedInsuredType?: FirstNamedInsuredType | null;
  /**
   * Ownedentityid
   */
  ownedEntityId?: string | null;
  /**
   * Otherentitytype
   */
  otherEntityType?: string | null;
  /**
   * Entityname
   */
  entityName?: string | null;
  /**
   * Firstname
   */
  firstName?: string | null;
  /**
   * Middlename
   */
  middleName?: string | null;
  /**
   * Lastname
   */
  lastName?: string | null;
  /**
   * Professionaldesignation
   */
  professionalDesignation?: Array<ItemsEnum>;
  /**
   * Firstnamedinsureddentistid
   */
  firstNamedInsuredDentistId?: string | null;
  policyContractState?: UsStateEnum | null;
  mailingAddress?: UsAddress | null;
  billingAddress?: UsAddress | null;
  /**
   * Officephonenumber
   */
  officePhoneNumber?: string | null;
  /**
   * Cellphonenumber
   */
  cellPhoneNumber?: string | null;
  /**
   * Billingcontactfirstname
   */
  billingContactFirstName?: string | null;
  /**
   * Billingcontactlastname
   */
  billingContactLastName?: string | null;
  /**
   * Billingcontactemail
   */
  billingContactEmail?: string | null;
  /**
   * Billingcontactphone
   */
  billingContactPhone?: string | null;
  /**
   * Emailaddress
   */
  emailAddress?: string | null;
  /**
   * Practicewebsite
   */
  practiceWebsite?: string | null;
  electronicDeliveryAcceptance?: YesNoEnum | null;
  /**
   * Minimumearnedpremium
   */
  minimumEarnedPremium?: _0Enum | null;
  paymentPlan?: PolicyPaymentPlanEnum | null;
  /**
   * Brokercommissionoverride
   */
  brokerCommissionOverride?: number | null;
  overridePdf?: YesNoEnum | null;
  /**
   * Agencypk
   */
  agencyPk?: number | null;
  /**
   * Producerpk
   */
  producerPk?: number | null;
  initialTransactionSource?: SourceSystemEnum | null;
  /**
   * Lastquotedat
   */
  lastQuotedAt?: string | null;
  /**
   * Applyoverridetopremium
   */
  applyOverrideToPremium?: boolean;
  applyAsicMinimumPremium?: YesNoEnum | null;
  /**
   * Agencyname
   */
  readonly agencyName: string;
  readonly invoicePreference: InvoicePreference;
  /**
   * Brokercommission
   *
   * Get the applicable commission for a policy in a single query
   */
  readonly brokerCommission: number | null;
};

export const PolicyFormLevels = {
  POLICY: 'POLICY',
  GL: 'GL',
  ERISA: 'ERISA',
  EPL: 'EPL',
  CYBER: 'CYBER',
  COMMON: 'COMMON',
  POLICY_PROPERTY: 'POLICY_PROPERTY',
  POLICY_PROPERTY2: 'POLICY PROPERTY',
  NONE: 'NONE',
} as const;

export type PolicyFormLevels =
  (typeof PolicyFormLevels)[keyof typeof PolicyFormLevels];

/**
 * PolicyPaymentPlanEnum
 */
export const PolicyPaymentPlanEnum = {
  FULL: 'full',
  QUARTERLY: 'quarterly',
} as const;

/**
 * PolicyPaymentPlanEnum
 */
export type PolicyPaymentPlanEnum =
  (typeof PolicyPaymentPlanEnum)[keyof typeof PolicyPaymentPlanEnum];

/**
 * PolicyStatus
 */
export const PolicyStatus = {
  IN_PROGRESS: 'in_progress',
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
} as const;

/**
 * PolicyStatus
 */
export type PolicyStatus = (typeof PolicyStatus)[keyof typeof PolicyStatus];

/**
 * PolicyTypeEnum
 */
export const PolicyTypeEnum = {
  CANCEL_REWRITE: 'cancel_rewrite',
  NEW_BUSINESS: 'new_business',
  RENEWAL: 'renewal',
  ROLL_OVER: 'roll_over',
} as const;

/**
 * PolicyTypeEnum
 */
export type PolicyTypeEnum =
  (typeof PolicyTypeEnum)[keyof typeof PolicyTypeEnum];

/**
 * PracticeIncomeWaitingPeriod
 */
export const PracticeIncomeWaitingPeriod = {
  ZERO: 'zero',
  TWENTY_FOUR: 'twenty_four',
  FORTY_EIGHT: 'forty_eight',
  SEVENTY_TWO: 'seventy_two',
  NINETY_SIX: 'ninety_six',
  ONE_TWENTY: 'one_twenty',
  ONE_FOURTY_FOUR: 'one_fourty_four',
  ONE_SIXTY_EIGHT: 'one_sixty_eight',
  ONE_NINETY_SIX: 'one_ninety_six',
  TWO_SIXTEEN: 'two_sixteen',
  TWO_FORTY: 'two_forty',
  THREE_SIXTY: 'three_sixty',
  FOUR_EIGHTY: 'four_eighty',
  SIX_HUNDRED: 'six_hundred',
} as const;

/**
 * PracticeIncomeWaitingPeriod
 */
export type PracticeIncomeWaitingPeriod =
  (typeof PracticeIncomeWaitingPeriod)[keyof typeof PracticeIncomeWaitingPeriod];

/**
 * PracticeLocation
 */
export type PracticeLocation = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Pk
   */
  pk: string;
  address: UsAddress | null;
  /**
   * Sequencenumber
   */
  sequenceNumber: number;
  /**
   * Latitude
   */
  latitude?: number | null;
  /**
   * Longitude
   */
  longitude?: number | null;
  /**
   * Primary
   */
  primary?: boolean;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
  /**
   * Premiums
   */
  premiums?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  /**
   * Taxes
   */
  taxes?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  blackBagCoverage?: BlackBagCoverage | null;
  /**
   * Googleplaceid
   */
  googlePlaceId?: string | null;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
  /**
   * Alltemplateformscomplete
   */
  readonly allTemplateFormsComplete: boolean;
  /**
   * Referencedin
   *
   * Returns list of where this location is referenced in the policy.
   * This property requires the location to be loaded within a Policy context.
   */
  readonly referencedIn: Array<string>;
  /**
   * Candelete
   *
   * Determines if this practice location can be deleted.
   * Returns False if the location is being used elsewhere in the policy.
   * This property requires the location to be loaded within a Policy context.
   */
  readonly canDelete: boolean;
};

export type PracticeLocationFormLevels = 'PRACTICE_LOCATION';

/**
 * PracticeOwner
 */
export type PracticeOwner = {
  firstNameInsuredIsOwner?: YesNoEnum | null;
  insuredIsFirstTimePracticeOwner?: YesNoEnum | null;
  contractsWithProviders?: YesNoEnum | null;
  employeeDentistsInsured?: YesNoEnum | null;
  /**
   * Employees
   */
  employees?: Array<Employee>;
  employsDentists?: YesNoEnum | null;
  /**
   * Feebasedrevenue
   */
  feeBasedRevenue?: number | null;
  holdHarmlessClause?: HoldHarmlessClause | null;
  /**
   * Medicaid
   */
  medicaid?: number | null;
  /**
   * Medicare
   */
  medicare?: number | null;
  operateDentalLab?: YesNoEnum | null;
  outsideReferralsAccepted?: YesNoEnum | null;
  /**
   * Ownerdentists
   */
  ownerDentists?: Array<OwnerDentistNotInsured>;
  ownerDentistsInsured?: YesNoEnum | null;
  /**
   * Privateinsurance
   */
  privateInsurance?: number | null;
  proofOfInsurance?: YesNoEnum | null;
  radiologyServices?: YesNoEnum | null;
  /**
   * Servicesrenderedweekly
   */
  servicesRenderedWeekly?: number | null;
  writtenContracts?: YesNoEnum | null;
  /**
   * Authorizeddentist
   */
  authorizedDentist?: string | null;
  onFileProofOfInsurance?: YesNoEnum | null;
  /**
   * Totalindividuals
   *
   * Calculates sum of all individuals covered by vicarious liability insurance.
   * Depending on answers to related questions (employs_dentists and employee_dentists_insured),
   * this may return 0.
   */
  readonly totalIndividuals: number;
};

/**
 * PracticeProfile
 */
export const PracticeProfile = {
  EMPLOYEE: 'employee',
  FACULTY: 'faculty',
  CONTRACTOR: 'contractor',
  OWNER: 'owner',
  VOLUNTEER: 'volunteer',
} as const;

/**
 * PracticeProfile
 */
export type PracticeProfile =
  (typeof PracticeProfile)[keyof typeof PracticeProfile];

/**
 * PracticeSpecialty
 */
export const PracticeSpecialty = {
  ORAL_SURGERY: 'oral_surgery',
  ANESTHESIOLOGIST: 'anesthesiologist',
  ENDODONTICS: 'endodontics',
  GENERAL: 'general',
  PEDIATRIC: 'pediatric',
  PERIODONTICS: 'periodontics',
  PROSTHODONTICS: 'prosthodontics',
  PUBLIC: 'public',
  ORAL_MEDICINE: 'oral_medicine',
  FORENSIC: 'forensic',
  ORTHODONTICS: 'orthodontics',
  ORAL_RADIOLOGY: 'oral_radiology',
  OROFACIAL: 'orofacial',
  ORAL_PATHOLOGY: 'oral_pathology',
  ANESTHESIOLOGIST_DEEP_SEDATION: 'anesthesiologist_deep_sedation',
} as const;

/**
 * PracticeSpecialty
 */
export type PracticeSpecialty =
  (typeof PracticeSpecialty)[keyof typeof PracticeSpecialty];

/**
 * PremisesAndEquipmentExplanation
 */
export const PremisesAndEquipmentExplanation = {
  CREDIT_MONITORED_SYSTEM: 'credit_monitored_system',
  CREDIT_GOOD_NEIGHBOR: 'credit_good_neighbor',
  CREDIT_EASILY_ACCESSIBLE: 'credit_easily_accessible',
  CREDIT_THIRD_PARTY: 'credit_third_party',
  CREDIT_EXPERIENCED_MANAGEMENT: 'credit_experienced_management',
  DEBIT_NO_MONITORED_SYSTEM: 'debit_no_monitored_system',
  DEBIT_BAD_NEIGHBOR: 'debit_bad_neighbor',
  DEBIT_VACANT: 'debit_vacant',
  DEBIT_INEXPERIENCED_MANAGEMENT: 'debit_inexperienced_management',
} as const;

/**
 * PremisesAndEquipmentExplanation
 */
export type PremisesAndEquipmentExplanation =
  (typeof PremisesAndEquipmentExplanation)[keyof typeof PremisesAndEquipmentExplanation];

/**
 * Procedure
 *
 * Dental Procedure
 */
export type Procedure = {
  /**
   * Applies
   */
  applies?: boolean;
  procedure?: ProcedureType | null;
  /**
   * Informedconsenttypes
   */
  informedConsentTypes?: Array<InformedConsentType>;
  /**
   * Trainings
   */
  trainings?: Array<Training>;
};

/**
 * ProcedureType
 */
export const ProcedureType = {
  FULL_ARCH: 'full_arch',
  IMPACTED_MOLAR: 'impacted_molar',
  ENDODONTICS: 'endodontics',
  OTHER_IMPLANTS: 'other_implants',
  TMJ: 'tmj',
} as const;

/**
 * ProcedureType
 */
export type ProcedureType = (typeof ProcedureType)[keyof typeof ProcedureType];

/**
 * ProfessionalLiability
 *
 * Schema with Fields required to rate Professional Liability
 */
export type ProfessionalLiability = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  coverage?: ProfessionalLiabilityCoverageSection;
  practiceOwners?: PracticeOwner;
  coveragePart?: CoveragePart;
  /**
   * Plwasremovedontransactionid
   */
  plWasRemovedOnTransactionId?: number | null;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
};

/**
 * ProfessionalLiabilityCoverageSection
 *
 * Represents the Coverage Section
 */
export type ProfessionalLiabilityCoverageSection = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  consentType?: ConsentType | null;
  coverageBasis?: CoverageBasis | null;
  /**
   * Entityname
   */
  entityName?: string | null;
  entityType?: EntityType | null;
  limitsDesired?: LimitsEnum | null;
  missionOfMercyApplies?: YesNoEnum | null;
  civilRegulatoryProceed?: YesNoEnum | null;
  /**
   * Componentsocieties
   */
  componentSocieties?: Array<ComponentSociety>;
  componentSocietiesNeedScheduling?: YesNoEnum | null;
  defenseDeductibleDesired?: DefenseDeductibleDesired | null;
  /**
   * Entityprioracts
   */
  entityPriorActs?: string | null;
  /**
   * Largegroupexposuremodification
   */
  largeGroupExposureModification?: number | null;
  /**
   * Largegroupexposuremodificationexplanation
   */
  largeGroupExposureModificationExplanation?: string | null;
  /**
   * Largegroupproceduremix
   */
  largeGroupProcedureMix?: number | null;
  /**
   * Largegroupproceduremixexplanation
   */
  largeGroupProcedureMixExplanation?: string | null;
  /**
   * Largegroupunusualrisk
   */
  largeGroupUnusualRisk?: number | null;
  /**
   * Largegroupunusualriskexplanation
   */
  largeGroupUnusualRiskExplanation?: string | null;
  entitySharedLimitsType?: EntitySharedLimitsType | null;
  /**
   * Nummissionmercyall
   */
  numMissionMercyAll?: number | null;
  /**
   * Nummissionmercyhygienists
   */
  numMissionMercyHygienists?: number | null;
  /**
   * Missionofmercyevents
   */
  missionOfMercyEvents?: Array<MissionOfMercyEvent>;
  /**
   * Numconventions
   */
  numConventions?: number | null;
  /**
   * Numtestingboardexaminers
   */
  numTestingBoardExaminers?: number | null;
  optinIncreaseLimitsMatchCap?: YesNoEnum | null;
  /**
   * Policyflatadjustment
   */
  policyFlatAdjustment?: number | null;
  /**
   * Additionalinsured
   */
  additionalInsured?: Array<AdditionalInsured>;
  /**
   * Carriercommissionoverride
   */
  carrierCommissionOverride?: number | null;
  /**
   * Brokercommissionoverride
   */
  brokerCommissionOverride?: number | null;
  /**
   * Blackbagcoverage
   */
  blackBagCoverage?: Array<BlackBagCoverageDict>;
  /**
   * Erpexpirationdate
   *
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: string | null;
};

/**
 * ProfessionalService
 */
export const ProfessionalService = {
  ALTERNATIVE: 'alternative',
  CBCT: 'cbct',
  ELECTIVE: 'elective',
  LOCUM_TENENS: 'locum_tenens',
  IV_SEDATION: 'iv_sedation',
  ORAL_SEDATION: 'oral_sedation',
  APNEA: 'apnea',
  TELE: 'tele',
  TEMP: 'temp',
} as const;

/**
 * ProfessionalService
 */
export type ProfessionalService =
  (typeof ProfessionalService)[keyof typeof ProfessionalService];

/**
 * ProtectionClass
 */
export const ProtectionClass = {
  ONE: 'one',
  TWO: 'two',
  THREE: 'three',
  FOUR: 'four',
  FIVE: 'five',
  SIX: 'six',
  SEVEN: 'seven',
  EIGHT: 'eight',
  NINE: 'nine',
  TEN: 'ten',
} as const;

/**
 * ProtectionClass
 */
export type ProtectionClass =
  (typeof ProtectionClass)[keyof typeof ProtectionClass];

/**
 * Questions
 */
export type Questions = {
  /**
   * Explanation
   */
  explanation?: string | null;
  majorityOwned?: YesNoNaEnum | null;
  solelyForDentistry?: YesNoEnum | null;
};

/**
 * QuoteTypeEnum
 */
export const QuoteTypeEnum = {
  BINDABLE_QUOTE: 'bindable_quote',
  PRELIMINARY_INDICATION: 'preliminary_indication',
  POLICY: 'policy',
} as const;

/**
 * QuoteTypeEnum
 */
export type QuoteTypeEnum = (typeof QuoteTypeEnum)[keyof typeof QuoteTypeEnum];

/**
 * Rating
 */
export type Rating = {
  automaticBuildingValve?: YesNoEnum | null;
  bcegs?: Bcegs | null;
  /**
   * Buildingfeatures
   */
  buildingFeatures?: number | null;
  /**
   * Buildingfeaturesexplanation
   */
  buildingFeaturesExplanation?: string | null;
  centralFireAlarm?: YesNoEnum | null;
  /**
   * Contentsflatadjustment
   */
  contentsFlatAdjustment?: number | null;
  /**
   * Buildingflatadjustment
   */
  buildingFlatAdjustment?: number | null;
  distanceToCoast?: DistanceToCoast | null;
  /**
   * Earthquakeclass
   */
  earthquakeClass?: string | null;
  /**
   * Earthquakedistancetofault
   */
  earthquakeDistanceToFault?: string | null;
  /**
   * Earthquakeriskscore
   */
  earthquakeRiskScore?: string | null;
  /**
   * Floodriskrating
   */
  floodRiskRating?: string | null;
  /**
   * Floodriskscore
   */
  floodRiskScore?: string | null;
  /**
   * Floodzone
   */
  floodZone?: string | null;
  publicProtectionClass?: ProtectionClass | null;
  smokeDetectors?: SmokeDetectors | null;
  userSprinklerStatus?: YesNoEnum | null;
  userConstructionType?: ConstructionType | null;
  /**
   * Useryearbuilt
   */
  userYearBuilt?: number | null;
  /**
   * Userroofyear
   */
  userRoofYear?: number | null;
  veriskConstructionType?: ConstructionType | null;
  /**
   * Veriskyearbuilt
   */
  veriskYearBuilt?: number | null;
  veriskSprinklerStatus?: YesNoEnum | null;
  /**
   * Veriskroofyear
   */
  veriskRoofYear?: number | null;
  /**
   * Wildfireriskscore
   */
  wildfireRiskScore?: string | null;
  roofType?: RoofType | null;
  fortifiedCommercialCertification?: CommercialCertification | null;
  /**
   * Hailprobabilityriskscore
   */
  hailProbabilityRiskScore?: string | null;
  /**
   * Corelogicnonweatherriskscore
   */
  corelogicNonWeatherRiskScore?: number | null;
  /**
   * Corelogicstraightlinewindscore
   */
  corelogicStraightLineWindScore?: number | null;
  /**
   * Irpmlocation
   */
  irpmLocation?: number | null;
  /**
   * Irpmlocationexplanation
   */
  irpmLocationExplanation?: string | null;
  /**
   * Corelogicplumbingage
   */
  corelogicPlumbingAge?: number | null;
  /**
   * Corelogicelectricalage
   */
  corelogicElectricalAge?: number | null;
  /**
   * Roofage
   */
  roofAge?: number | null;
  /**
   * Irpmbuildingfeatures
   */
  irpmBuildingFeatures?: number | null;
  /**
   * Irpmbuildingfeaturesexplanation
   */
  irpmBuildingFeaturesExplanation?: string | null;
  /**
   * Irpmpremisesandequipment
   */
  irpmPremisesAndEquipment?: number | null;
  /**
   * Irpmpremisesandequipmentexplanation
   */
  irpmPremisesAndEquipmentExplanation?: string | null;
  irpmPremisesAndEquipmentExplanationV2?: PremisesAndEquipmentExplanation | null;
  /**
   * Irpmunderwritercreditsdebits
   */
  irpmUnderwriterCreditsDebits?: number | null;
  activatedWaterSensor?: YesNoEnum | null;
  /**
   * Crimeriskscore
   */
  crimeRiskScore?: number | null;
  /**
   * Irpmprotection
   */
  irpmProtection?: number | null;
  /**
   * Irpmprotectionexplanation
   */
  irpmProtectionExplanation?: string | null;
};

/**
 * RatingAttempt
 */
export type RatingAttempt = {
  /**
   * Requesthash
   */
  requestHash: string;
  /**
   * Ratingrequestid
   */
  ratingRequestId: string;
};

/**
 * RendersService
 *
 * Select Any Setting Where The Insured Renders Professional Services Now Or Has In The Last
 * 5 Years
 */
export const RendersService = {
  CORRECTIONAL: 'correctional',
  HOSPITAL: 'hospital',
  MOBILE: 'mobile',
  NURSING_HOME: 'nursing_home',
  SCHOOL: 'school',
  SPA: 'spa',
  NONE: 'none',
} as const;

/**
 * RendersService
 *
 * Select Any Setting Where The Insured Renders Professional Services Now Or Has In The Last
 * 5 Years
 */
export type RendersService =
  (typeof RendersService)[keyof typeof RendersService];

/**
 * RenewalFlagEnum
 */
export const RenewalFlagEnum = {
  FLAG_FOR_NON_RENEWAL: 'flag_for_non_renewal',
  FLAG_FOR_MANUAL_REVIEW: 'flag_for_manual_review',
} as const;

/**
 * RenewalFlagEnum
 */
export type RenewalFlagEnum =
  (typeof RenewalFlagEnum)[keyof typeof RenewalFlagEnum];

/**
 * RoofType
 */
export const RoofType = { METAL: 'metal', OTHER: 'other' } as const;

/**
 * RoofType
 */
export type RoofType = (typeof RoofType)[keyof typeof RoofType];

/**
 * ScheduleFile
 */
export const ScheduleFile = {
  LARGE_GROUP: 'large_group',
  NO: 'no',
  ENTITY_ONLY: 'entity_only',
} as const;

/**
 * ScheduleFile
 */
export type ScheduleFile = (typeof ScheduleFile)[keyof typeof ScheduleFile];

/**
 * SewerBackupCoverage
 */
export const SewerBackupCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  '50K': '50k',
  '100K': '100k',
} as const;

/**
 * SewerBackupCoverage
 */
export type SewerBackupCoverage =
  (typeof SewerBackupCoverage)[keyof typeof SewerBackupCoverage];

/**
 * SmokeDetectors
 */
export const SmokeDetectors = {
  CENTRAL: 'central',
  LOCAL: 'local',
  NO: 'no',
} as const;

/**
 * SmokeDetectors
 */
export type SmokeDetectors =
  (typeof SmokeDetectors)[keyof typeof SmokeDetectors];

/**
 * SourceSystemEnum
 */
export const SourceSystemEnum = {
  MOUNTAINEER: 'mountaineer',
  NEW_GRAD_APP: 'new_grad_app',
} as const;

/**
 * SourceSystemEnum
 */
export type SourceSystemEnum =
  (typeof SourceSystemEnum)[keyof typeof SourceSystemEnum];

/**
 * StandardOrHigher
 */
export const StandardOrHigher = {
  STANDARD: 'standard',
  HIGHER: 'higher',
} as const;

/**
 * StandardOrHigher
 */
export type StandardOrHigher =
  (typeof StandardOrHigher)[keyof typeof StandardOrHigher];

/**
 * StopGapLimit
 */
export const StopGapLimit = {
  '300K': '300k',
  '500K': '500k',
  '1M': '1m',
} as const;

/**
 * StopGapLimit
 */
export type StopGapLimit = (typeof StopGapLimit)[keyof typeof StopGapLimit];

/**
 * Training
 */
export const Training = {
  CE: 'ce',
  SCHOOL: 'school',
  POST_GRAD: 'post_grad',
} as const;

/**
 * Training
 */
export type Training = (typeof Training)[keyof typeof Training];

/**
 * Transaction
 */
export type Transaction = {
  /**
   * Transactionnumber
   */
  transactionNumber: number;
  /**
   * Startsequencenumber
   */
  startSequenceNumber: number;
  /**
   * Endsequencenumber
   */
  endSequenceNumber: number | null;
  status: TransactionStatus;
  transactionType: TransactionType;
  /**
   * Effectivedate
   */
  effectiveDate: string | null;
  /**
   * Createdat
   */
  createdAt: string;
  /**
   * Statusmessage
   */
  statusMessage: string;
  /**
   * Billedpremium
   */
  billedPremium: number;
  /**
   * Writtenpremium
   */
  writtenPremium: number;
  /**
   * Annualpremium
   */
  annualPremium: number;
  latestAttempt: RatingAttempt | null;
  /**
   * Previoustransactionnumber
   */
  previousTransactionNumber?: number | null;
  /**
   * Nexttransactionnumber
   */
  nextTransactionNumber?: number | null;
  /**
   * Committedat
   */
  committedAt?: string | null;
  /**
   * Billedtax
   */
  billedTax?: number;
  /**
   * Writtentax
   */
  writtenTax?: number;
  /**
   * Annualtax
   */
  annualTax?: number;
  transactionMetadata?: TransactionMetadata;
  /**
   * Confirmedratingruntimechecks
   */
  confirmedRatingRuntimeChecks?: boolean;
};

/**
 * TransactionMetadata
 *
 * Per-transaction context (reason, cancellation, expiration change).
 */
export type TransactionMetadata = {
  /**
   * Reasonforchange
   */
  reasonForChange?: string | null;
  cancellationReason?: CancellationReasonEnum | null;
  cancelType?: CancelTypeEnum | null;
  /**
   * Noticegenerationdate
   */
  noticeGenerationDate?: string | null;
  /**
   * Cancellationprocessdate
   */
  cancellationProcessDate?: string | null;
  /**
   * Newexpirationdate
   */
  newExpirationDate?: string | null;
  direction?: ExpirationDateChangeDirection | null;
  convertToTwoYearNewGrad?: TermConversionEnum | null;
};

/**
 * TransactionStatus
 */
export const TransactionStatus = {
  IN_PROGRESS: 'in_progress',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  DECLINED: 'declined',
  CANCELLED: 'cancelled',
  PENDING_REVERSION: 'pending_reversion',
  REVERTED: 'reverted',
  DISCARDED: 'discarded',
  NOT_TAKEN: 'not_taken',
} as const;

/**
 * TransactionStatus
 */
export type TransactionStatus =
  (typeof TransactionStatus)[keyof typeof TransactionStatus];

/**
 * TransactionType
 */
export const TransactionType = {
  POLICY_BOUND: 'policy_bound',
  POLICY_ENDORSEMENT: 'policy_endorsement',
  POLICY_CANCELLED: 'policy_cancelled',
  POLICY_REINSTATED: 'policy_reinstated',
  ERP: 'erp',
} as const;

/**
 * TransactionType
 */
export type TransactionType =
  (typeof TransactionType)[keyof typeof TransactionType];

/**
 * TruthMDData
 *
 * TruthMD Data for Dentist
 */
export type TruthMdData = {
  /**
   * Id
   */
  id?: string | null;
  /**
   * Npi
   */
  npi?: number | null;
  /**
   * Firstname
   */
  firstName?: string | null;
  /**
   * Middlename
   */
  middleName?: string | null;
  /**
   * Lastname
   */
  lastName?: string | null;
  /**
   * Suffix
   */
  suffix?: string | null;
  /**
   * Birthdate
   */
  birthDate?: string | null;
  /**
   * Boardcertified
   */
  boardCertified?: boolean | null;
  /**
   * Healthcareexclusions
   */
  healthCareExclusions?: boolean | null;
  /**
   * Disciplinaryboardactions
   */
  disciplinaryBoardActions?: boolean | null;
  /**
   * Governmentsanctions
   */
  governmentSanctions?: boolean | null;
  /**
   * Federalmalpractice
   */
  federalMalpractice?: boolean | null;
  /**
   * Licenses
   */
  licenses?: Array<TruthMdLicense>;
  /**
   * Specialties
   */
  specialties?: Array<TruthMdSpecialty>;
  /**
   * Licensenumber
   */
  licenseNumber?: string | null;
  /**
   * Licensestate
   */
  licenseState?: string | null;
};

/**
 * TruthMDLicense
 *
 * TruthMD License Information
 */
export type TruthMdLicense = {
  /**
   * Licensenumber
   */
  licenseNumber?: string | null;
  /**
   * Licensetype
   */
  licenseType?: string | null;
  /**
   * Licensestate
   */
  licenseState?: string | null;
  /**
   * Licensestatus
   */
  licenseStatus?: string | null;
  /**
   * Licensestatusdescription
   */
  licenseStatusDescription?: string | null;
  /**
   * Licenseissuedate
   */
  licenseIssueDate?: string | null;
  /**
   * Licenseexpirationdate
   */
  licenseExpirationDate?: string | null;
};

/**
 * TruthMDSpecialty
 *
 * TruthMD Specialty Information
 */
export type TruthMdSpecialty = {
  /**
   * Boardname
   */
  boardName?: string | null;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Primarygeneralspecialty
   */
  primaryGeneralSpecialty?: string | null;
  /**
   * Primarydetailspecialty
   */
  primaryDetailSpecialty?: string | null;
};

/**
 * TypeOfContract
 */
export const TypeOfContract = {
  LANDLORD: 'Landlord',
  EQUIPMENT_LEASE: 'Equipment Lease',
  LOSS_PAYEE: 'Loss Payee',
  OTHER: 'Other',
} as const;

/**
 * TypeOfContract
 */
export type TypeOfContract =
  (typeof TypeOfContract)[keyof typeof TypeOfContract];

/**
 * UnusualRiskExplanation
 */
export const UnusualRiskExplanation = {
  DOCUMENTED_PLAN: 'documented_plan',
  COMPREHENSIVE_INFECTION_CONTROL: 'comprehensive_infection_control',
  WELLDESIGNED_SYSTEM: 'welldesigned_system',
  TRAINED_PRACTICE_MANAGER: 'trained_practice_manager',
  CONTINUING_EDUCATION: 'continuing_education',
  NO_RISK_MANAGER: 'no_risk_manager',
  NO_PROTOCOLS: 'no_protocols',
  NO_TRAINING: 'no_training',
} as const;

/**
 * UnusualRiskExplanation
 */
export type UnusualRiskExplanation =
  (typeof UnusualRiskExplanation)[keyof typeof UnusualRiskExplanation];

/**
 * UsAddress
 */
export type UsAddress = {
  /**
   * Line1
   */
  line1: string;
  /**
   * Line2
   */
  line2: string | null;
  /**
   * City
   */
  city: string;
  /**
   * County
   */
  county?: string | null;
  state: UsStateEnum | null;
  /**
   * Zipcode
   */
  zipCode: string;
};

/**
 * UsEarthquakeHazardResponse
 */
export type UsEarthquakeHazardResponse = {
  /**
   * Usaearthquakeriskscore
   */
  USAEarthquakeRiskScore: string | null;
  /**
   * Distancetocontrollingfault
   */
  DistanceToControllingFault: string | null;
  /**
   * Magnitudeofcontrollingfault
   */
  MagnitudeOfControllingFault: string | null;
};

/**
 * UserObject
 */
export type UserObject = {
  /**
   * Userid
   */
  userId: number;
  /**
   * Firstname
   */
  firstName: string | null;
  /**
   * Middlename
   */
  middleName: string | null;
  /**
   * Lastname
   */
  lastName: string | null;
  /**
   * Email
   */
  email: string;
};

/**
 * VeriskBusinessOwnerResponse
 *
 * We had to None as default value for some fields because sometimes the API returns None
 */
export type VeriskBusinessOwnerResponse = {
  /**
   * Businessname
   */
  BusinessName: string | null;
  /**
   * Address
   */
  Address: {
    [key: string]: unknown;
  } | null;
  /**
   * Risks
   */
  Risks?: Array<{
    [key: string]: unknown;
  }> | null;
  /**
   * Buildingfireconstructioncodelist
   */
  BuildingFireConstructionCodeList?: Array<{
    [key: string]: unknown;
  }> | null;
  /**
   * Yearbuiltlist
   */
  YearBuiltList?: Array<{
    [key: string]: unknown;
  }> | null;
  /**
   * Ppclist
   */
  PpcList?: Array<{
    [key: string]: unknown;
  }> | null;
  /**
   * Sprinkleredlist
   */
  SprinkleredList?: Array<{
    [key: string]: unknown;
  }> | null;
  /**
   * Sprinklercreditvaluelist
   */
  SprinklerCreditValueList?: Array<{
    [key: string]: unknown;
  }> | null;
  /**
   * Bcegslist
   */
  BcegsList?: Array<{
    [key: string]: unknown;
  }> | null;
  /**
   * Replacementcostreport
   */
  ReplacementCostReport?: Array<{
    [key: string]: unknown;
  }> | null;
  /**
   * Roofyear
   */
  RoofYear: string | null;
  /**
   * Replacementdata
   */
  ReplacementData: {
    [key: string]: unknown;
  } | null;
  /**
   * Occupancydetails
   */
  OccupancyDetails?: Array<{
    [key: string]: unknown;
  }> | null;
};

/**
 * WeeklyPracticeHours
 */
export const WeeklyPracticeHours = {
  FULLTIME: 'fulltime',
  PARTTIME: 'parttime',
  MOONLIGHTING: 'moonlighting',
} as const;

/**
 * WeeklyPracticeHours
 */
export type WeeklyPracticeHours =
  (typeof WeeklyPracticeHours)[keyof typeof WeeklyPracticeHours];

/**
 * WhoAdministersAnesthesia
 */
export const WhoAdministersAnesthesia = {
  ANOTHER: 'another',
  INSURED: 'insured',
} as const;

/**
 * WhoAdministersAnesthesia
 */
export type WhoAdministersAnesthesia =
  (typeof WhoAdministersAnesthesia)[keyof typeof WhoAdministersAnesthesia];

/**
 * WildfireRiskResponse
 */
export type WildfireRiskResponse = {
  /**
   * Riskscore
   */
  riskScore: string | null;
};

/**
 * WindHailCoverage
 */
export const WindHailCoverage = {
  LOCATION_FIXED_DEDUCTIBLE: 'location_fixed_deductible',
  ONE_PCT: 'one_pct',
  '2%': '2%',
  FIVE_PCT: 'five_pct',
  EXCLUDED: 'excluded',
} as const;

/**
 * WindHailCoverage
 */
export type WindHailCoverage =
  (typeof WindHailCoverage)[keyof typeof WindHailCoverage];

/**
 * WindRiskScoreResponse
 */
export type WindRiskScoreResponse = {
  /**
   * Straightlinescore
   */
  straightLineScore: number | string | null;
};

/**
 * WritingCompanyEnum
 */
export const WritingCompanyEnum = { AAIC: 'aaic', ASIC: 'asic' } as const;

/**
 * WritingCompanyEnum
 */
export type WritingCompanyEnum =
  (typeof WritingCompanyEnum)[keyof typeof WritingCompanyEnum];

/**
 * YearMonth
 */
export type YearMonth = {
  /**
   * Year
   */
  year: number;
  /**
   * Month
   */
  month: number;
};

/**
 * YearsNoClaims
 */
export const YearsNoClaims = {
  Y0: 'y0',
  Y1: 'y1',
  Y2: 'y2',
  Y3: 'y3',
  Y4: 'y4',
  Y5: 'y5',
  Y6: 'y6',
  Y7: 'y7',
  Y8: 'y8',
  Y9: 'y9',
  GTE10: 'gte10',
} as const;

/**
 * YearsNoClaims
 */
export type YearsNoClaims = (typeof YearsNoClaims)[keyof typeof YearsNoClaims];

/**
 * YearsPracticing
 */
export const YearsPracticing = {
  Y0: 'y0',
  Y1: 'y1',
  Y2: 'y2',
  Y3: 'y3',
  GTE4: 'gte4',
} as const;

/**
 * YearsPracticing
 */
export type YearsPracticing =
  (typeof YearsPracticing)[keyof typeof YearsPracticing];

/**
 * YesNoEnum
 */
export const YesNoEnum = { NO: 'No', YES: 'Yes' } as const;

/**
 * YesNoEnum
 */
export type YesNoEnum = (typeof YesNoEnum)[keyof typeof YesNoEnum];

/**
 * YesNoNAEnum
 *
 * Yes / No / N/A answer, where ``N/A`` is an explicit choice distinct from
 * an unanswered (``None``) value.
 *
 * The three-valued counterpart to the platform-wide two-valued ``YesNoEnum``,
 * for fields that offer an explicit "not applicable" answer (e.g.
 * ``has_reported_situation``, ``majority_owned``). Intentionally no
 * ``__bool__`` override: N/A must not silently coerce to a falsy "No".
 */
export const YesNoNaEnum = {
  NO: 'No',
  YES: 'Yes',
  N_A: 'N/A',
} as const;

/**
 * YesNoNAEnum
 *
 * Yes / No / N/A answer, where ``N/A`` is an explicit choice distinct from
 * an unanswered (``None``) value.
 *
 * The three-valued counterpart to the platform-wide two-valued ``YesNoEnum``,
 * for fields that offer an explicit "not applicable" answer (e.g.
 * ``has_reported_situation``, ``majority_owned``). Intentionally no
 * ``__bool__`` override: N/A must not silently coerce to a falsy "No".
 */
export type YesNoNaEnum = (typeof YesNoNaEnum)[keyof typeof YesNoNaEnum];

/**
 * NegativeEvent
 *
 * Select Any That Apply To The Insured Dentist In The Last Five Years
 */
export const CounterpartAspenEnumsNegativeEvent = {
  ALLEGATIONS: 'allegations',
  CANCELED: 'canceled',
  CONVICTED: 'convicted',
  MEDICAID_FRAUD: 'medicaid_fraud',
  DRUGS: 'drugs',
  PRIVILEGES_REVOKED: 'privileges_revoked',
  INVESTIGATIONS: 'investigations',
  PL_REFUSED: 'pl_refused',
  ILLNESS: 'illness',
  NOT_INCLUDING: 'not_including',
  PRACTICED_WITHOUT_COVERAGE: 'practiced_without_coverage',
  SUSPENDED: 'suspended',
  ALCOHOLISM: 'alcoholism',
} as const;

/**
 * NegativeEvent
 *
 * Select Any That Apply To The Insured Dentist In The Last Five Years
 */
export type CounterpartAspenEnumsNegativeEvent =
  (typeof CounterpartAspenEnumsNegativeEvent)[keyof typeof CounterpartAspenEnumsNegativeEvent];

/**
 * NegativeEvent
 */
export type GlacierPolicyDomainTypeDictsNegativeEvent = {
  negativeEvent: NegativeEvents | null;
  answer: YesNoEnum | null;
};

/**
 * CreatePolicyRequest
 */
export type CreatePolicyRequest = {
  /**
   * Accountid
   */
  accountId?: string;
};

/**
 * PolicySummaryFilterSchema
 *
 * Filter schema for policy summary queries.
 */
export type PolicySummaryFilterSchema = {
  policy_type?: PolicyTypeEnum | null;
  /**
   * Has Alerts
   */
  has_alerts?: boolean | null;
  /**
   * Assigned To
   */
  assigned_to?: number | null;
  /**
   * Referred By
   */
  referred_by?: number | null;
};

/**
 * AgencySchema2
 */
export type AgencySchema2 = {
  /**
   * Phone Number
   */
  phoneNumber: string;
  /**
   * Agency Id
   */
  agencyId?: string;
  /**
   * Name
   */
  name: string;
};

/**
 * AgentUserSchema
 *
 * This is actually returns mostly of the data from the User model, but the initial
 * intent is to display agent data for endpoint related_users
 */
export type AgentUserSchema = {
  /**
   * Email
   */
  email: string;
  /**
   * Firstname
   */
  firstName: string;
  /**
   * Lastname
   */
  lastName: string;
  /**
   * Role
   */
  role: string;
  /**
   * ID
   */
  id?: number | null;
};

/**
 * PolicySummaryData
 */
export type PolicySummaryData = {
  agent?: AgentUserSchema | null;
  assignedTo?: UserSchema2 | null;
  referredBy?: UserSchema2 | null;
  agency?: AgencySchema2 | null;
  /**
   * Id
   */
  id?: string | null;
  /**
   * Quote Number
   */
  quoteNumber?: string;
  /**
   * Policy Number
   */
  policyNumber?: string;
  /**
   * Rollover Expiring Policy Number
   */
  rolloverExpiringPolicyNumber?: string | null;
  /**
   * First Named Insured
   */
  firstNamedInsured?: string;
  /**
   * Quote Type
   */
  quoteType?: string;
  /**
   * Billed Premium
   */
  billedPremium?: number;
  /**
   * Written Premium
   */
  writtenPremium?: number;
  /**
   * Transaction Status
   */
  transactionStatus?: string;
  /**
   * Transaction Type
   */
  transactionType?: string;
  /**
   * Policy Effective Date
   */
  policyEffectiveDate?: string | null;
  /**
   * Policy Expiration Date
   */
  policyExpirationDate?: string | null;
  /**
   * Policy Type
   */
  policyType?: string | null;
  /**
   * Primary Practice State
   */
  primaryPracticeState?: string | null;
  /**
   * Agency Name
   */
  agencyName?: string | null;
};

/**
 * UserSchema2
 */
export type UserSchema2 = {
  /**
   * Name
   */
  name: string;
  /**
   * Email address
   */
  email: string;
  /**
   * ID
   */
  id?: number | null;
  /**
   * First Name
   */
  firstName?: string | null;
  /**
   * Last Name
   */
  lastName?: string | null;
  /**
   * Role
   */
  role?: string | null;
};

/**
 * PolicyPrintQueueList
 */
export type PolicyPrintQueueList = {
  /**
   * Transactioneffectivedate
   */
  transactionEffectiveDate: string | null;
  /**
   * Filesprinted
   */
  filesPrinted: boolean;
  /**
   * Id
   */
  id?: string | null;
  /**
   * Transaction Id
   */
  transactionId: string;
  /**
   * Account Name
   */
  accountName?: string;
  /**
   * Policy Id
   */
  policyId: string;
  /**
   * Transaction Number
   */
  transactionNumber: number;
  /**
   * Policy Stage Effective Date
   */
  policyStageEffectiveDate?: string | null;
  /**
   * Download Documents Date
   */
  downloadDocumentsDate?: string | null;
  /**
   * Transaction Date
   */
  transactionDate?: string | null;
  /**
   * Transaction Type
   */
  transactionType: string;
  /**
   * Transaction Status
   */
  transactionStatus: string;
  /**
   * Primary Practice State
   */
  primaryPracticeState?: string | null;
  /**
   * Billed Premium
   */
  billedPremium?: number;
};

/**
 * AccountsToPrintRequest
 */
export type AccountsToPrintRequest = {
  /**
   * Print Queue Ids
   */
  print_queue_ids: Array<string>;
};

/**
 * FastPolicy
 */
export type FastPolicy = {
  /**
   * Pk
   */
  pk?: string;
  /**
   * Policynumber
   */
  policyNumber?: string;
  /**
   * Boundpolicynumber
   */
  boundPolicyNumber?: string;
  /**
   * Sequencenumber
   */
  sequenceNumber?: number;
  /**
   * Isissued
   */
  isIssued?: boolean;
  /**
   * Bypassvalidators
   */
  bypassValidators?: boolean;
  producer?: UserObject | null;
  underwriter?: UserObject | null;
  assignedTo?: UserObject | null;
  referredBy?: UserObject | null;
  /**
   * Transactions
   */
  transactions?: Array<Transaction>;
  /**
   * Documentwarehouse
   */
  documentWarehouse?: Array<FileDocument>;
  /**
   * Additionalmessage
   */
  additionalMessage?: string;
  /**
   * Parentpolicyid
   */
  parentPolicyId?: string | null;
  /**
   * Parentsequencenumber
   */
  parentSequenceNumber?: number | null;
  /**
   * Policyholderid
   */
  policyholderId?: string | null;
  /**
   * Baselineexpirationdate
   */
  baselineExpirationDate?: string | null;
  renewalFlag?: RenewalFlagEnum | null;
  /**
   * Reasonfornonrenewal
   */
  reasonForNonRenewal?: string | null;
  policyStatus?: PolicyStatus;
  /**
   * Deletedat
   */
  deletedAt?: string | null;
  deletedBy?: UserObject | null;
  /**
   * Deletionreason
   */
  deletionReason?: string | null;
  /**
   * Parentpolicynumber
   */
  readonly parentPolicyNumber: string | null;
  /**
   * Year
   */
  readonly year: number | null;
  readonly latestTransaction: Transaction;
  readonly details: PolicyDetails;
  /**
   * Firstnamedinsured
   */
  readonly firstNamedInsured: string;
  /**
   * Haspolicynumber
   */
  readonly hasPolicyNumber: boolean;
  /**
   * Displaynumber
   */
  readonly displayNumber: string;
  /**
   * Flaggedfornonrenewal
   *
   * Returns true if the policy has a non-renewal flag
   */
  readonly flaggedForNonRenewal: boolean;
  /**
   * Flaggedformanualrenewal
   *
   * Returns true if the policy has a manual renewal flag
   */
  readonly flaggedForManualRenewal: boolean;
  /**
   * Policystatuslabel
   *
   * Computed label combining policy_status, transaction_type, and transaction_status.
   * Replaces frontend's HeaderView statusStage construction.
   *
   * Examples:
   * - "PENDING: Midterm Transaction In Progress"
   * - "Policy Cancelled"
   * - "Bindable Quote / In Progress"
   * - "New Business / Active"
   */
  readonly policyStatusLabel: string;
  /**
   * Transactiontypelabel
   *
   * Computed label for transaction type display.
   * Replaces frontend's transactionTypeDisplayText function in cells.tsx.
   *
   * Returns labels like:
   * - "Not Bound"
   * - "Policy Bound"
   * - "Midterm (Endorsement)"
   * - "Policy (Endorsed)"
   * - "Midterm (Cancellation)"
   * - "Policy Cancelled"
   * - "Midterm (Reinstate)"
   * - "Policy Reinstated"
   * - "ERP"
   */
  readonly transactionTypeLabel: string;
  /**
   * Alerts
   *
   * Returns unacknowledged alerts for this policy
   */
  readonly alerts: Array<PolicyAlertObject>;
  /**
   * Dentists
   */
  readonly dentists: Array<Dentist>;
  /**
   * Locations
   */
  readonly locations: Array<PracticeLocation>;
  readonly professionalLiability: ProfessionalLiability;
  readonly commercialProperty: CommercialProperty;
  readonly cyberLiability: CyberLiability;
  /**
   * Ownedentities
   */
  readonly ownedEntities: Array<OwnedEntity>;
  readonly generalLiability: GeneralLiability;
  readonly employmentPracticesLiability: EmploymentPracticesLiability;
  readonly erisaAndEmployeeBenefits: ErisaAndEmployeeBenefits;
  /**
   * Maxallowedpnpdates
   *
   * Calculate the maximum allowed prior acts date for insurance lines.
   */
  readonly maxAllowedPnpDates: {
    [key in InsuranceLinesEnum]?: string;
  };
  /**
   * Annualpremium
   */
  readonly annualPremium: number;
  /**
   * Writtenpremium
   */
  readonly writtenPremium: number;
  /**
   * Coverageparts
   */
  readonly coverageParts: {
    [key in InsuranceLinesEnum]?: CoveragePart;
  };
  /**
   * Writtentax
   */
  readonly writtenTax: number;
  /**
   * Billedtax
   */
  readonly billedTax: number;
  /**
   * Billedpremium
   */
  readonly billedPremium: number;
  /**
   * Attachedforms
   */
  readonly attachedForms: Array<AttachedForm>;
  readonly hasEpliWageAndHour: YesNoEnum;
  /**
   * Alltemplateformscomplete
   */
  readonly allTemplateFormsComplete: boolean;
  /**
   * Canbequoted
   *
   * Determines if the policy can be quoted based on the current transaction's premium values.
   *
   * A policy can be quoted if any of the following premiums are greater than zero:
   * - Written premium
   * - Billed premium
   * - Annual premium
   *
   * Returns:
   * bool: True if the policy can be quoted, False otherwise.
   */
  readonly canBeQuoted: boolean;
  /**
   * Transactionid
   */
  readonly transactionId: string;
};

/**
 * PolicyAlertWithIdSchema
 *
 * Schema for policy alert responses that include the id.
 */
export type PolicyAlertWithIdSchema = {
  /**
   * Createdat
   */
  createdAt: string;
  severity: PolicyAlertSeverityEnum;
  type: PolicyAlertTypeEnum;
  /**
   * Message
   */
  message: string;
  createdBy: UserObject | null;
  /**
   * Acknowledged
   */
  acknowledged: boolean;
  acknowledgedBy: UserObject | null;
  /**
   * Id
   */
  id: number;
};

/**
 * BillingInfo
 */
export type BillingInfo = {
  /**
   * Writtenpremium
   */
  writtenPremium?: number | null;
  /**
   * Writtentax
   */
  writtenTax?: number | null;
  /**
   * Writtenpremiumandtax
   */
  writtenPremiumAndTax?: number | null;
};

/**
 * TransactionSummaryData
 */
export type TransactionSummaryData = {
  currentTransactionStatus: TransactionStatus;
  currentTransactionType: TransactionType;
  /**
   * Currenttransactioneffectivedate
   */
  currentTransactionEffectiveDate: string | null;
  /**
   * Ischangeexpirationdatemidterm
   */
  isChangeExpirationDateMidterm?: boolean;
  /**
   * Availableactions
   */
  availableActions?: Array<string>;
  billing?: BillingInfo | null;
};

/**
 * LastRateAttempt
 */
export type LastRateAttempt = {
  /**
   * Request
   */
  request: {
    [key: string]: unknown;
  };
  /**
   * Response
   */
  response: {
    [key: string]: unknown;
  };
  /**
   * Iserror
   */
  isError: boolean;
};

/**
 * UserId
 */
export type UserId = {
  /**
   * Userid
   */
  userId: number;
};

/**
 * DentistSummary
 */
export type DentistSummary = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Name
   */
  name?: string;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
};

/**
 * OwnedEntitySummary
 */
export type OwnedEntitySummary = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Entityname
   */
  entityName?: string | null;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
};

/**
 * PolicyWithSummaries
 */
export type PolicyWithSummaries = {
  /**
   * Pk
   */
  pk: string;
  details: PolicyDetails;
  professionalLiability?: ProfessionalLiability;
  /**
   * Locations
   */
  locations?: Array<PracticeLocationSummary>;
  /**
   * Dentistssummary
   */
  dentistsSummary?: Array<DentistSummary>;
  /**
   * Ownedentitiessummary
   */
  ownedEntitiesSummary?: Array<OwnedEntitySummary>;
};

/**
 * PracticeLocationSummary
 */
export type PracticeLocationSummary = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  address?: UsAddress | null;
  /**
   * Primary
   */
  primary?: boolean;
  blackBagCoverage?: BlackBagCoverage | null;
  /**
   * Isdeleted
   */
  readonly isDeleted: boolean;
};

/**
 * DeclineReason
 */
export type DeclineReason = {
  /**
   * Reason
   */
  reason: string;
};

/**
 * AddLocationRequest
 */
export type AddLocationRequest = {
  /**
   * Locationid
   */
  locationId?: string;
  address?: UsAddress | null;
  latitude?: LatitudeUnionFloatNoneType;
  longitude?: LongitudeUnionFloatNoneType;
  /**
   * Primary
   */
  primary?: boolean;
  /**
   * Googleplaceid
   */
  googlePlaceId?: string | null;
};

export type LatitudeUnionFloatNoneType = number | null;

export type LongitudeUnionFloatNoneType = number | null;

/**
 * MakePrimarySchema
 */
export type MakePrimarySchema = {
  /**
   * Locationid
   */
  locationId: string;
};

/**
 * UpdateLocationRequest
 */
export type UpdateLocationRequest = {
  address: UsAddress | null;
  latitude?: LatitudeUnionFloatNoneType;
  longitude?: LongitudeUnionFloatNoneType;
  /**
   * Primary
   */
  primary?: boolean;
  /**
   * Googleplaceid
   */
  googlePlaceId?: string | null;
};

/**
 * BulkUpdateLocationRequest
 */
export type BulkUpdateLocationRequest = {
  /**
   * Locationid
   */
  locationId: string;
  address: UsAddress | null;
  latitude?: LatitudeUnionFloatNoneType;
  longitude?: LongitudeUnionFloatNoneType;
  /**
   * Primary
   */
  primary?: boolean;
  /**
   * Googleplaceid
   */
  googlePlaceId?: string | null;
};

/**
 * NegativeEvent
 *
 * Select Any That Apply To The Insured Dentist In The Last Five Years
 */
export const NegativeEvent = {
  ALLEGATIONS: 'allegations',
  CANCELED: 'canceled',
  CONVICTED: 'convicted',
  MEDICAID_FRAUD: 'medicaid_fraud',
  DRUGS: 'drugs',
  PRIVILEGES_REVOKED: 'privileges_revoked',
  INVESTIGATIONS: 'investigations',
  PL_REFUSED: 'pl_refused',
  ILLNESS: 'illness',
  NOT_INCLUDING: 'not_including',
  PRACTICED_WITHOUT_COVERAGE: 'practiced_without_coverage',
  SUSPENDED: 'suspended',
  ALCOHOLISM: 'alcoholism',
} as const;

/**
 * NegativeEvent
 *
 * Select Any That Apply To The Insured Dentist In The Last Five Years
 */
export type NegativeEvent = (typeof NegativeEvent)[keyof typeof NegativeEvent];

/**
 * SetDentistAsFirstNamedInsuredSchema
 */
export type SetDentistAsFirstNamedInsuredSchema = {
  /**
   * Dentistid
   */
  dentistId: string;
};

/**
 * SetOwnedEntityAsFirstNamedInsuredSchema
 */
export type SetOwnedEntityAsFirstNamedInsuredSchema = {
  /**
   * Ownedentityid
   */
  ownedEntityId: string;
};

/**
 * CreateDentistRequestSchema
 */
export type CreateDentistRequestSchema = {
  /**
   * Pk
   */
  pk?: string;
  /**
   * Firstname
   */
  firstName?: string;
  /**
   * Middlename
   */
  middleName?: string | null;
  /**
   * Lastname
   */
  lastName?: string;
  /**
   * Professionaldesignation
   */
  professionalDesignation?: Array<ItemsEnum>;
};

/**
 * UpdateBasicDentistRequestSchema
 */
export type UpdateBasicDentistRequestSchema = {
  /**
   * Firstname
   */
  firstName?: string;
  /**
   * Middlename
   */
  middleName?: string | null;
  /**
   * Lastname
   */
  lastName?: string;
  /**
   * Professionaldesignation
   */
  professionalDesignation?: Array<ItemsEnum>;
};

/**
 * DentistInformationSchema
 */
export type DentistInformationSchema = {
  /**
   * Dentistid
   */
  dentistId: string;
  answers: DentistInformationUpdatedDict;
};

/**
 * DentistInformationUpdatedDict
 */
export type DentistInformationUpdatedDict = {
  /**
   * Firstname
   */
  firstName?: string;
  /**
   * Middlename
   */
  middleName?: string | null;
  /**
   * Lastname
   */
  lastName?: string;
  /**
   * Professionaldesignation
   */
  professionalDesignation?: Array<ItemsEnum>;
  numHoursPerWeek?: WeeklyPracticeHours | null;
  moonlightingReason?: MoonlightingReason | null;
  /**
   * Moonlightingreasondescription
   */
  moonlightingReasonDescription?: string | null;
  /**
   * Projectedresidencycompletiondate
   */
  projectedResidencyCompletionDate?: string | null;
  practiceSpecialty?: PracticeSpecialty | null;
  /**
   * Primarypracticelocation
   */
  primaryPracticeLocation?: string | null;
  yearsInPractice?: YearsPracticing | null;
  /**
   * Yearswithaspen
   */
  yearsWithAspen?: number | null;
  boardCertified?: YesNoEnum | null;
  /**
   * Dateofbirth
   */
  dateOfBirth?: string | null;
  /**
   * Datepcfpremiumreceived
   */
  datePcfPremiumReceived?: string | null;
  differentLimitDesired?: YesNoEnum | null;
  /**
   * Emailaddress
   */
  emailAddress?: string | null;
  /**
   * Inpcfcertificatenumber
   */
  inPcfCertificateNumber?: string | null;
  inPcfFundParticipation?: InpcfParticipation | null;
  /**
   * Inpcfproviderid
   */
  inPcfProviderId?: string | null;
  /**
   * Inpcfsurchargeamount
   */
  inPcfSurchargeAmount?: number | null;
  laPcfFundParticipation?: YesNoEnum | null;
  leaveOfAbsence?: LeaveOfAbsence | null;
  /**
   * Loastartdate
   */
  loaStartDate?: string | null;
  /**
   * Loanumberofdays
   */
  loaNumberOfDays?: number | null;
  memberOfSda?: YesNoEnum | null;
  /**
   * Nameofdentalschool
   */
  nameOfDentalSchool?: string | null;
  yearMonthGraduation?: YearMonth | null;
  firstTimePractice?: YesNoEnum | null;
  newDentistType?: NewDentistType | null;
  noseCoverage?: YesNoEnum | null;
  noseCoverageLiabilityLimits?: LimitsEnum | null;
  /**
   * Nosecoverageprioractsdate
   */
  noseCoveragePriorActsDate?: string | null;
  numYearsDuration?: DurationYears | null;
  optinForRiskNewsletter?: YesNoEnum | null;
  practiceProfile?: PracticeProfile | null;
  /**
   * Prioractsdate
   */
  priorActsDate?: string | null;
  professionalLiabilityLimit?: LimitsEnum | null;
  renumeration?: YesNoEnum | null;
  residencyCompleted?: YesNoEnum | null;
  riskManagementSeminar?: YesNoEnum | null;
  /**
   * Secondarypracticelocations
   */
  secondaryPracticeLocations?: Array<string>;
  /**
   * Volunteerservices
   */
  volunteerServices?: string | null;
  workScheduleAvailable?: YesNoEnum | null;
  /**
   * Yearofattendance
   */
  yearOfAttendance?: number | null;
  yearsWithoutClaim?: YearsNoClaims | null;
  reviewRequired?: YesNoEnum | null;
  agreedRepresentationsAndFraud?: YesNoEnum | null;
  /**
   * Signature
   */
  signature?: string | null;
  /**
   * Signaturedate
   */
  signatureDate?: string | null;
};

/**
 * TruthMDSearchRequestSchema
 *
 * Schema for TruthMD search request
 */
export type TruthMdSearchRequestSchema = {
  /**
   * Npi
   */
  npi?: number | null;
  /**
   * Licensenumber
   */
  licenseNumber?: string | null;
  /**
   * Licensestate
   */
  licenseState?: string | null;
};

/**
 * PracticeOwnerSchema
 *
 * Professional Liability Practice Owner
 */
export type PracticeOwnerSchema = {
  firstNameInsuredIsOwner?: YesNoEnum | null;
  insuredIsFirstTimePracticeOwner?: YesNoEnum | null;
  contractsWithProviders?: YesNoEnum | null;
  employeeDentistsInsured?: YesNoEnum | null;
  /**
   * Employees
   */
  employees?: Array<Employee>;
  employsDentists?: YesNoEnum | null;
  /**
   * Feebasedrevenue
   */
  feeBasedRevenue?: number | null;
  holdHarmlessClause?: HoldHarmlessClause | null;
  /**
   * Medicaid
   */
  medicaid?: number | null;
  /**
   * Medicare
   */
  medicare?: number | null;
  operateDentalLab?: YesNoEnum | null;
  outsideReferralsAccepted?: YesNoEnum | null;
  /**
   * Ownerdentists
   */
  ownerDentists?: Array<OwnerDentistNotInsured>;
  ownerDentistsInsured?: YesNoEnum | null;
  /**
   * Privateinsurance
   */
  privateInsurance?: number | null;
  proofOfInsurance?: YesNoEnum | null;
  radiologyServices?: YesNoEnum | null;
  /**
   * Servicesrenderedweekly
   */
  servicesRenderedWeekly?: number | null;
  writtenContracts?: YesNoEnum | null;
  /**
   * Authorizeddentist
   */
  authorizedDentist?: string | null;
  onFileProofOfInsurance?: YesNoEnum | null;
};

/**
 * ProfessionalLiabilityCoverageSectionRequestDict
 */
export type ProfessionalLiabilityCoverageSectionRequestDict = {
  consentType?: ConsentType | null;
  coverageBasis?: CoverageBasis | null;
  /**
   * Entityname
   */
  entityName?: string | null;
  entityType?: EntityType | null;
  limitsDesired?: LimitsEnum | null;
  missionOfMercyApplies?: YesNoEnum | null;
  civilRegulatoryProceed?: YesNoEnum | null;
  /**
   * Componentsocieties
   */
  componentSocieties?: Array<ComponentSociety>;
  componentSocietiesNeedScheduling?: YesNoEnum | null;
  defenseDeductibleDesired?: DefenseDeductibleDesired | null;
  /**
   * Entityprioracts
   */
  entityPriorActs?: string | null;
  /**
   * Largegroupexposuremodification
   */
  largeGroupExposureModification?: number | null;
  /**
   * Largegroupexposuremodificationexplanation
   */
  largeGroupExposureModificationExplanation?: string | null;
  /**
   * Largegroupproceduremix
   */
  largeGroupProcedureMix?: number | null;
  /**
   * Largegroupproceduremixexplanation
   */
  largeGroupProcedureMixExplanation?: string | null;
  /**
   * Largegroupunusualrisk
   */
  largeGroupUnusualRisk?: number | null;
  /**
   * Largegroupunusualriskexplanation
   */
  largeGroupUnusualRiskExplanation?: string | null;
  entitySharedLimitsType?: EntitySharedLimitsType | null;
  /**
   * Nummissionmercyall
   */
  numMissionMercyAll?: number | null;
  /**
   * Nummissionmercyhygienists
   */
  numMissionMercyHygienists?: number | null;
  /**
   * Missionofmercyevents
   */
  missionOfMercyEvents?: Array<MissionOfMercyEvent>;
  /**
   * Numconventions
   */
  numConventions?: number | null;
  /**
   * Numtestingboardexaminers
   */
  numTestingBoardExaminers?: number | null;
  optinIncreaseLimitsMatchCap?: YesNoEnum | null;
  /**
   * Policyflatadjustment
   */
  policyFlatAdjustment?: number | null;
  /**
   * Additionalinsured
   */
  additionalInsured?: Array<AdditionalInsured>;
  /**
   * Blackbagcoverage
   */
  blackBagCoverage?: Array<BlackBagCoverageDict>;
};

/**
 * ProfessionalLiabilityCoverageSectionRequestSchema
 */
export type ProfessionalLiabilityCoverageSectionRequestSchema = {
  answers: ProfessionalLiabilityCoverageSectionRequestDict;
};

/**
 * PolicyDetailsSchema
 *
 * Request body for a details write: an omitted field means "unchanged".
 */
export type PolicyDetailsSchema = {
  writingCompany?: WritingCompanyEnum | null;
  /**
   * Writingcompanyid
   */
  writingCompanyId?: string | null;
  /**
   * Writingcompanyname
   */
  writingCompanyName?: string | null;
  /**
   * Agency
   */
  agency?: string | null;
  /**
   * Associationcode
   */
  associationCode?: string | null;
  /**
   * Producer
   */
  producer: string | null;
  /**
   * Producername
   */
  producerName?: string | null;
  policyType: PolicyTypeEnum | null;
  /**
   * Rolloverexpiringpolicynumber
   */
  rolloverExpiringPolicyNumber?: string | null;
  /**
   * Rolloverexpiringpolicypremium
   */
  rolloverExpiringPolicyPremium?: number | null;
  /**
   * Prioraspenpolicynumber
   */
  priorAspenPolicyNumber?: string | null;
  quoteType?: QuoteTypeEnum | null;
  /**
   * Policyeffectivedate
   */
  policyEffectiveDate?: string | null;
  /**
   * Policyexpirationdate
   */
  policyExpirationDate?: string | null;
  /**
   * Insurancelinesdesired
   */
  insuranceLinesDesired?: Array<InsuranceLinesEnum> | null;
  plSubType?: PlSubTypeEnum | null;
  scheduleOnFile?: YesNoEnum | null;
  scheduleFile?: ScheduleFile | null;
  firstNamedInsuredType?: FirstNamedInsuredType | null;
  /**
   * Firstnamedinsureddentistid
   */
  firstNamedInsuredDentistId?: string | null;
  /**
   * Firstname
   */
  firstName?: string;
  /**
   * Middlename
   */
  middleName?: string | null;
  /**
   * Lastname
   */
  lastName?: string;
  /**
   * Professionaldesignation
   */
  professionalDesignation?: Array<ItemsEnum>;
  /**
   * Ownedentityid
   */
  ownedEntityId?: string | null;
  /**
   * Otherentitytype
   */
  otherEntityType?: string | null;
  /**
   * Entityname
   */
  entityName?: string | null;
  policyContractState?: UsStateEnum | null;
  mailingAddress?: UsAddress | null;
  billingAddress?: UsAddress | null;
  /**
   * Officephonenumber
   */
  officePhoneNumber?: string | null;
  /**
   * Cellphonenumber
   */
  cellPhoneNumber?: string | null;
  /**
   * Emailaddress
   */
  emailAddress?: string | null;
  /**
   * Billingcontactfirstname
   */
  billingContactFirstName?: string | null;
  /**
   * Billingcontactlastname
   */
  billingContactLastName?: string | null;
  /**
   * Billingcontactemail
   */
  billingContactEmail?: string | null;
  /**
   * Billingcontactphone
   */
  billingContactPhone?: string | null;
  /**
   * Practicewebsite
   */
  practiceWebsite?: string | null;
  electronicDeliveryAcceptance?: YesNoEnum | null;
  /**
   * Minimumearnedpremium
   */
  minimumEarnedPremium?: _0Enum | null;
  paymentPlan?: PolicyPaymentPlanEnum | null;
  /**
   * Brokercommissionoverride
   */
  brokerCommissionOverride?: number | null;
  overridePdf?: YesNoEnum | null;
  /**
   * Agencypk
   */
  agencyPk?: number | null;
  /**
   * Producerpk
   */
  producerPk?: number | null;
  applyAsicMinimumPremium?: YesNoEnum | null;
  /**
   * Applyoverridetopremium
   */
  applyOverrideToPremium?: boolean;
  initialTransactionSource?: SourceSystemEnum | null;
};

/**
 * UpdateBypassValidatorsRequest
 */
export type UpdateBypassValidatorsRequest = {
  /**
   * Bypassvalidators
   */
  bypassValidators: boolean;
};

/**
 * AddPropertyCoverageSchema
 */
export type AddPropertyCoverageSchema = {
  /**
   * Locations
   */
  locations?: Array<string> | null;
};

/**
 * DistanceToCoastSchema
 */
export type DistanceToCoastSchema = {
  /**
   * Distance
   */
  distance?: number | null;
  unit?: DistanceUnit | null;
};

/**
 * InformationSchema
 */
export type InformationSchema = {
  accountsReceivableCoverage?: AccountsReceivableCoverage | null;
  blanketDentalPracticePersonalPropertyDesired?: YesNoEnum | null;
  /**
   * Accountsreceivablelimit
   */
  accountsReceivableLimit?: number | null;
  appurtenantStructureDesired?: YesNoEnum | null;
  /**
   * Appurtenantstructurelimit
   */
  appurtenantStructureLimit?: number | null;
  /**
   * Appurtenantstructuredescription
   */
  appurtenantStructureDescription?: string | null;
  roofSurfactingLimitationsDesired?: YesNoEnum | null;
  electronicEquipSurgeProtectors?: YesNoEnum | null;
  equipmentBreakdownDeductible?: EquipmentBreakdownDeductible | null;
  basicEarthquakeLimits?: BasicEarthquakeLimits | null;
  /**
   * Basicfloodlimits
   */
  basicFloodLimits?: number | null;
  /**
   * Buildingallowablerange
   */
  buildingAllowableRange?: number | null;
  buildingCoverageDesired?: YesNoEnum | null;
  buildingInflationGuard?: BuildingInflationGuard | null;
  buildingLeasedToOthers?: YesNoEnum | null;
  /**
   * Buildinglimit
   */
  buildingLimit?: number | null;
  /**
   * Buildingreplacementcost
   */
  buildingReplacementCost?: number | null;
  contentsInflationGuard?: InflationGuard | null;
  /**
   * Contentslimit
   */
  contentsLimit?: number | null;
  demolitionIncreasedLimitDesired?: OrdinanceLimit | null;
  /**
   * Demolitionlimit
   */
  demolitionLimit?: number | null;
  earthquakeBuildingClass?: EarthquakeBuildingClassification | null;
  equipmentBreakdownCoverageDesired?: YesNoEnum | null;
  /**
   * Electronicequipmentlimit
   */
  electronicEquipmentLimit?: number | null;
  /**
   * Grossannualizedrevenue
   */
  grossAnnualizedRevenue?: number | null;
  /**
   * Higherlossassessmentlimit
   */
  higherLossAssessmentLimit?: number | null;
  practiceIncomeDesired?: YesNoEnum | null;
  incomeDocumentationReceived?: YesNoEnum | null;
  /**
   * Locationflatdeductible
   */
  locationFlatDeductible?: number | null;
  lossAssessment?: LossAssessment | null;
  mineSubsidenceDesired?: YesNoEnum | null;
  /**
   * Minesubsidencelimit
   */
  mineSubsidenceLimit?: number | null;
  namedStormDeductible?: NamedStormDeductible | null;
  /**
   * Numberofdaysopenperweek
   */
  numberOfDaysOpenPerWeek?: number | null;
  ordinanceIncreaseLimitDesired?: OrdinanceLimit | null;
  /**
   * Percentageleasedtoothers
   */
  percentageLeasedToOthers?: number | null;
  practiceIncomeWaitingPeriod?: PracticeIncomeWaitingPeriod | null;
  rentsCoverageDesired?: YesNoEnum | null;
  /**
   * Rentslimitofinsurance
   */
  rentsLimitOfInsurance?: number | null;
  /**
   * Valueddailylimitdays
   */
  valuedDailyLimitDays?: number | null;
  /**
   * Totalelectronicequiplimit
   */
  totalElectronicEquipLimit?: number | null;
  windhailCoverage?: WindHailCoverage | null;
  sewerBackupCoverage?: SewerBackupCoverage | null;
  /**
   * Totalsewerbackuplimit
   */
  totalSewerBackupLimit?: number | null;
  pollutionLimitCoverage?: StandardOrHigher | null;
  /**
   * Totalpollutionlimit
   */
  totalPollutionLimit?: number | null;
  floodCoverage?: FloodCoverage | null;
  /**
   * Totalfloodlimit
   */
  totalFloodLimit?: number | null;
  earthquakeCoverage?: EarthquakeCoverage | null;
  /**
   * Totalearthquakelimit
   */
  totalEarthquakeLimit?: number | null;
  /**
   * Totalsignslimit
   */
  totalSignsLimit?: number | null;
  lossAssessmentCoverage?: LossAssessment | null;
  /**
   * Totallossassessmentlimit
   */
  totalLossAssessmentLimit?: number | null;
  offPremCoverage?: OffPremCoverage | null;
  /**
   * Totaloffpremlimit
   */
  totalOffPremLimit?: number | null;
  signsCoverage?: StandardOrHigher | null;
  electronicEquipCoverage?: ElectronicEquipCoverage | null;
};

/**
 * RatingSchema
 */
export type RatingSchema = {
  automaticBuildingValve?: YesNoEnum | null;
  bcegs?: Bcegs | null;
  /**
   * Buildingfeatures
   */
  buildingFeatures?: number | null;
  /**
   * Buildingfeaturesexplanation
   */
  buildingFeaturesExplanation?: string | null;
  centralFireAlarm?: YesNoEnum | null;
  /**
   * Contentsflatadjustment
   */
  contentsFlatAdjustment?: number | null;
  /**
   * Buildingflatadjustment
   */
  buildingFlatAdjustment?: number | null;
  distanceToCoast?: DistanceToCoastSchema | null;
  /**
   * Earthquakeclass
   */
  earthquakeClass?: string | null;
  /**
   * Earthquakedistancetofault
   */
  earthquakeDistanceToFault?: string | null;
  /**
   * Earthquakeriskscore
   */
  earthquakeRiskScore?: string | null;
  /**
   * Floodriskrating
   */
  floodRiskRating?: string | null;
  /**
   * Floodriskscore
   */
  floodRiskScore?: string | null;
  /**
   * Floodzone
   */
  floodZone?: string | null;
  publicProtectionClass?: ProtectionClass | null;
  smokeDetectors?: SmokeDetectors | null;
  userSprinklerStatus?: YesNoEnum | null;
  userConstructionType?: ConstructionType | null;
  /**
   * Useryearbuilt
   */
  userYearBuilt?: number | null;
  /**
   * Userroofyear
   */
  userRoofYear?: number | null;
  veriskConstructionType?: ConstructionType | null;
  /**
   * Veriskyearbuilt
   */
  veriskYearBuilt?: number | null;
  veriskSprinklerStatus?: YesNoEnum | null;
  /**
   * Veriskroofyear
   */
  veriskRoofYear?: number | null;
  /**
   * Wildfireriskscore
   */
  wildfireRiskScore?: string | null;
  roofType?: RoofType | null;
  fortifiedCommercialCertification?: CommercialCertification | null;
  /**
   * Hailprobabilityriskscore
   */
  hailProbabilityRiskScore?: string | null;
  /**
   * Corelogicnonweatherriskscore
   */
  corelogicNonWeatherRiskScore?: number | null;
  /**
   * Corelogicstraightlinewindscore
   */
  corelogicStraightLineWindScore?: number | null;
  /**
   * Irpmlocation
   */
  irpmLocation?: number | null;
  /**
   * Irpmlocationexplanation
   */
  irpmLocationExplanation?: string | null;
  /**
   * Corelogicplumbingage
   */
  corelogicPlumbingAge?: number | null;
  /**
   * Corelogicelectricalage
   */
  corelogicElectricalAge?: number | null;
  /**
   * Roofage
   */
  roofAge?: number | null;
  /**
   * Irpmbuildingfeatures
   */
  irpmBuildingFeatures?: number | null;
  /**
   * Irpmbuildingfeaturesexplanation
   */
  irpmBuildingFeaturesExplanation?: string | null;
  /**
   * Irpmpremisesandequipment
   */
  irpmPremisesAndEquipment?: number | null;
  /**
   * Irpmpremisesandequipmentexplanation
   */
  irpmPremisesAndEquipmentExplanation?: string | null;
  irpmPremisesAndEquipmentExplanationV2?: PremisesAndEquipmentExplanation | null;
  /**
   * Irpmunderwritercreditsdebits
   */
  irpmUnderwriterCreditsDebits?: number | null;
  activatedWaterSensor?: YesNoEnum | null;
  /**
   * Crimeriskscore
   */
  crimeRiskScore?: number | null;
  /**
   * Irpmprotection
   */
  irpmProtection?: number | null;
  /**
   * Irpmprotectionexplanation
   */
  irpmProtectionExplanation?: string | null;
};

/**
 * UpdateLocationSchema
 */
export type UpdateLocationSchema = {
  rating?: RatingSchema | null;
  information?: InformationSchema | null;
};

/**
 * CommercialPropertyCoverageUpdatedDict
 */
export type CommercialPropertyCoverageUpdatedDict = {
  bundledPropertyEnhancementEndorsements?: BundledPropertyEnhancementEndorsement | null;
  employeeDishonestyCoverageDesired?: YesNoEnum | null;
  employeeDishonestyCoverage?: EmployeeDishonestyCoverage | null;
  employeeDishonestyCoverageChoice?: StandardOrHigher | null;
  floridaSinkholeCoverageDesired?: YesNoEnum | null;
  fungiCoverageDesired?: YesNoEnum | null;
  propertyClaim?: YesNoEnum | null;
  currentlyResidence?: YesNoEnum | null;
  mostlyVacant?: YesNoEnum | null;
  trailerHome?: YesNoEnum | null;
  increasedWelfareLimitsDesired?: YesNoEnum | null;
  /**
   * Increasedwelfarelimits
   */
  increasedWelfareLimits?: number | null;
};

/**
 * UpdateCoverageSchema
 */
export type UpdateCoverageSchema = {
  coverage: CommercialPropertyCoverageUpdatedDict;
};

/**
 * FieldValidationError
 */
export type FieldValidationError = {
  /**
   * Field
   */
  field: string;
  /**
   * Message
   */
  message: string;
  view: FormView;
  tab?: FormViewTab | null;
  /**
   * Object Id
   */
  object_id?: string | null;
  /**
   * Object Name
   */
  object_name?: string | null;
};

/**
 * FieldValidationErrors
 */
export type FieldValidationErrors = {
  /**
   * Errors
   */
  errors: Array<FieldValidationError>;
  /**
   * Status Message
   */
  status_message?: string | null;
  /**
   * Status
   */
  status?: 422;
};

/**
 * FormView
 *
 * Enum for each form view which is used in the BackEnd Validator.
 * The values of the enum are used as the URL path to the form view in the FrontEnd.
 */
export const FormView = {
  POLICY_DETAILS: 'policy-details',
  COMMON: 'common',
  PRACTICE_LOCATIONS: 'practice-locations',
  PROF_LIABILITY_COVERAGE: 'prof-liability-coverage',
  PROF_LIABILITY_DENTIST: 'prof-liability-dentist',
  PROF_LIABILITY_PRACTICE_OWNERS: 'prof-liability-practice-owners',
  OWNED_ENTITIES: 'owned-entities',
  EPLI: 'epli',
  GENERAL_LIABILITY: 'general-liability',
  ERISA_FIDUCIARY_AND_EMPLOYEE_BENEFITS:
    'erisa-fiduciary-and-employee-benefits',
  COMMERCIAL_PROPERTY_LOCATIONS: 'commercial-property-locations',
  COMMERCIAL_PROPERTY_COVERAGES: 'commercial-property-coverages',
  CYBER_LIABILITY: 'cyber-liability',
} as const;

/**
 * FormView
 *
 * Enum for each form view which is used in the BackEnd Validator.
 * The values of the enum are used as the URL path to the form view in the FrontEnd.
 */
export type FormView = (typeof FormView)[keyof typeof FormView];

/**
 * FormViewTab
 *
 * Enum for the tabs which is used in the BackEnd Validator.
 * Some form views have multiple tabs, and this enum is used to identify them.
 */
export const FormViewTab = {
  INSURED_DENTIST_INFORMATION: 'insuredDentistInformation',
  PROCEDURES_AND_ANESTHESIA: 'proceduresAndAnesthesia',
  UNDERWRITING_QUESTIONS: 'underwritingQuestions',
  ADDITIONAL_PRICING_DETAILS: 'additionalPricingDetails',
  TRUTH_MD: 'truthMD',
  DETAILS: 'details',
  UNDERWRITING_QUESTIONS2: 'underwritingQuestions',
  LOCATION_DETAILS: 'locationDetails',
  LOCATION_RATING: 'locationRating',
  FORMS: 'forms',
} as const;

/**
 * FormViewTab
 *
 * Enum for the tabs which is used in the BackEnd Validator.
 * Some form views have multiple tabs, and this enum is used to identify them.
 */
export type FormViewTab = (typeof FormViewTab)[keyof typeof FormViewTab];

/**
 * MissingRequiredFieldErrorTypedDict
 */
export type MissingRequiredFieldErrorTypedDict = {
  /**
   * Path
   */
  path: Array<string>;
  /**
   * Attribute
   */
  attribute: string;
  /**
   * Code
   */
  code: 'REQUIRED';
  /**
   * Message
   */
  message: string;
};

/**
 * MultipleMissingRequiredFieldErrorTypedDict
 */
export type MultipleMissingRequiredFieldErrorTypedDict = {
  /**
   * Errors
   */
  errors: Array<MissingRequiredFieldErrorTypedDict>;
  /**
   * Status
   */
  status: 400;
};

/**
 * FormulasForUI
 */
export type FormulasForUi = {
  /**
   * Subcoverage Key
   */
  subcoverage_key: string;
  /**
   * Subcoverage Display
   */
  subcoverage_display: string;
  level: PremiumFormulaLevelEnum;
  /**
   * Reference Id
   */
  reference_id: string;
  /**
   * Annual Premium
   */
  annual_premium: number;
  /**
   * Billed Premium
   */
  billed_premium: number;
  /**
   * Written Premium
   */
  written_premium: number;
  /**
   * Formula
   */
  formula: string;
  /**
   * Formula Text
   */
  formula_text: string;
  /**
   * Effective Date
   */
  effective_date: string;
  /**
   * Expiration Date
   */
  expiration_date: string;
  /**
   * Reference Id Sch Dentist
   */
  reference_id_sch_dentist?: string | null;
  grouping?: PremiumFormulaGroupingEnum;
  amount_type?: AmounttypeEnum;
  /**
   * Tax Reason
   */
  tax_reason?: string | null;
  /**
   * Annual Amount
   */
  annual_amount?: number;
  /**
   * Billed Amount
   */
  billed_amount?: number;
  /**
   * Written Amount
   */
  written_amount?: number;
  /**
   * Conflict
   */
  conflict?: Array<string>;
  /**
   * Proration
   */
  proration?: {
    [key: string]: unknown;
  } | null;
  /**
   * Limit Aggregate
   */
  limit_aggregate?: number | null;
  /**
   * Limit Occurence
   */
  limit_occurence?: number | null;
  /**
   * Deductible Type
   */
  deductible_type?: string | null;
  /**
   * Deductible
   */
  deductible?: number | null;
  /**
   * Formula Id
   */
  formula_id?: number | null;
};

/**
 * PremiumFormulaGroupingEnum
 */
export const PremiumFormulaGroupingEnum = {
  PROPERTY: 'Property',
  EPL_EPLI: 'EPL/EPLI',
  ERISA: 'ERISA',
  PROFESSIONAL_LIABILITY: 'Professional Liability',
  CYBER: 'Cyber',
  GENERAL_LIABILITY: 'General Liability',
  BLACK_BAG: 'Black Bag',
  POLICY: 'Policy',
  TAX: 'Tax',
  ENTITY: 'Entity',
} as const;

/**
 * PremiumFormulaGroupingEnum
 */
export type PremiumFormulaGroupingEnum =
  (typeof PremiumFormulaGroupingEnum)[keyof typeof PremiumFormulaGroupingEnum];

/**
 * PremiumFormulaLevelEnum
 */
export const PremiumFormulaLevelEnum = {
  POLICY: 'Policy',
  LOCATION: 'Location',
  ENTITY: 'Entity',
  DENTIST: 'Dentist',
  PROPERTY: 'Property',
  GENERAL_LIABILITY: 'General Liability',
  ADDITIONAL_INSURED: 'Additional Insured',
  ADDITIONAL_INSURED_PL: 'Additional Insured PL',
  ADDITIONAL_INSURED_GL: 'Additional Insured GL',
  MISSION_OF_MERCY_EVENT: 'Mission of Mercy Event',
} as const;

/**
 * PremiumFormulaLevelEnum
 */
export type PremiumFormulaLevelEnum =
  (typeof PremiumFormulaLevelEnum)[keyof typeof PremiumFormulaLevelEnum];

/**
 * OwnedEntityCreationSchema
 */
export type OwnedEntityCreationSchema = {
  /**
   * Id
   */
  id: string;
};

/**
 * OwnedEntityDetailsUpdatedDict
 */
export type OwnedEntityDetailsUpdatedDict = {
  /**
   * Entityname
   */
  entityName?: string | null;
  /**
   * Associateddba
   */
  associatedDba?: string | null;
  entityCoverage?: EntityCoverage | null;
  /**
   * Entityfein
   */
  entityFein?: string | null;
  stateOfDomicile?: UsStateEnum | null;
  /**
   * Dentistsschedule
   */
  dentistsSchedule?: Array<string>;
  firstNamedInsuredIndicator?: YesNoEnum | null;
  /**
   * Businesspurpose
   */
  businessPurpose?: string | null;
  /**
   * Prioractsdate
   */
  priorActsDate?: string | null;
  inPcfFundParticipation?: InpcfParticipation | null;
  /**
   * Inpcfproviderid
   */
  inPcfProviderId?: string | null;
  /**
   * Inpcfcertificatenumber
   */
  inPcfCertificateNumber?: string | null;
  /**
   * Datepcfpremiumreceived
   */
  datePcfPremiumReceived?: string | null;
  /**
   * Inpcfsurchargeamount
   */
  inPcfSurchargeAmount?: number | null;
};

/**
 * OwnedEntityQuestionsUpdatedDict
 */
export type OwnedEntityQuestionsUpdatedDict = {
  /**
   * Explanation
   */
  explanation?: string | null;
  majorityOwned?: YesNoNaEnum | null;
  solelyForDentistry?: YesNoEnum | null;
};

/**
 * OwnedEntityUpdateSchema
 */
export type OwnedEntityUpdateSchema = {
  details?: OwnedEntityDetailsUpdatedDict | null;
  questions?: OwnedEntityQuestionsUpdatedDict | null;
};

/**
 * GeneralLiabilityAdditionalInsuredRequest
 */
export type GeneralLiabilityAdditionalInsuredRequest = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Fallbackpk
   */
  fallbackPk?: string | null;
  typeOfContract?: TypeOfContract | null;
  /**
   * Entityname
   */
  entityName?: string | null;
  /**
   * Insuredlocation
   */
  insuredLocation?: string | null;
  /**
   * Description
   */
  description?: string | null;
  /**
   * Effectivedate
   */
  effectiveDate?: null;
  /**
   * Expirationdate
   */
  expirationDate?: null;
  entityAddress?: UsAddress | null;
  /**
   * Newentityaddress
   */
  newEntityAddress?: string | null;
};

/**
 * GeneralLiabilityRequestDict
 */
export type GeneralLiabilityRequestDict = {
  limitOfInsurance?: LimitsEnum | null;
  separateAggregate?: YesNoEnum | null;
  hiredAutoDamage?: YesNoEnum | null;
  fireWaterLegalLimit?: FireWaterLimit | null;
  losses?: YesNoEnum | null;
  /**
   * Locationidsglnotcharged
   */
  locationIdsGlNotCharged?: Array<string>;
  stopGapCoverageDesired?: YesNoEnum | null;
  stopGapLimit?: StopGapLimit | null;
  /**
   * Flatpremiumadjustment
   */
  flatPremiumAdjustment?: number | null;
  /**
   * Additionalinsured
   */
  additionalInsured?: Array<GeneralLiabilityAdditionalInsuredRequest>;
};

/**
 * GeneralLiabilityRequestSchema
 */
export type GeneralLiabilityRequestSchema = {
  answers: GeneralLiabilityRequestDict;
};

/**
 * EmploymentPracticesLiabilityRequestDict
 */
export type EmploymentPracticesLiabilityRequestDict = {
  epliCoverageType?: EpliCoverageType | null;
  /**
   * Dentistsschedule
   */
  dentistsSchedule?: Array<DentistSchedule>;
  /**
   * Entitiesschedule
   */
  entitiesSchedule?: Array<EntitySchedule>;
  /**
   * Epliprioractsdate
   */
  epliPriorActsDate?: string | null;
  /**
   * Numnondentistemployees
   */
  numNonDentistEmployees?: number | null;
  /**
   * Numindependentdentists
   */
  numIndependentDentists?: number | null;
  /**
   * Numemployeedentists
   */
  numEmployeeDentists?: number | null;
  /**
   * Numindependenthygienists
   */
  numIndependentHygienists?: number | null;
  limitOfInsurance?: LimitOfInsurance | null;
  deductible?: Deductible | null;
  sublimitedCoverageDesired?: YesNoEnum | null;
  /**
   * Negativeevents
   */
  negativeEvents?: Array<NegativeEvent> | null;
  /**
   * Negativeeventsexplanation
   */
  negativeEventsExplanation?: string | null;
  /**
   * Natureofoperations
   */
  natureOfOperations?: number | null;
  /**
   * Natureofworkforce
   */
  natureOfWorkforce?: number | null;
  /**
   * Salaries
   */
  salaries?: number | null;
  /**
   * Writtenprocedures
   */
  writtenProcedures?: number | null;
  /**
   * Electroniccommunicationpolicies
   */
  electronicCommunicationPolicies?: number | null;
  /**
   * Experienceratingvalue
   */
  experienceRatingValue?: number | null;
};

/**
 * EmploymentPracticesLiabilityRequestSchema
 */
export type EmploymentPracticesLiabilityRequestSchema = {
  answers: EmploymentPracticesLiabilityRequestDict;
};

/**
 * ERISAAndEmployeBenefitsRequestDict
 */
export type ErisaAndEmployeBenefitsRequestDict = {
  limitOfInsurance?: ErisaLimitOfInsurance | null;
  /**
   * Prioractsdate
   */
  priorActsDate?: string | null;
  /**
   * Totalemployees
   */
  totalEmployees?: number | null;
  anyLosses?: YesNoEnum | null;
};

/**
 * ERISAAndEmployeeBenefitsSchema
 */
export type ErisaAndEmployeeBenefitsSchema = {
  answers: ErisaAndEmployeBenefitsRequestDict;
};

/**
 * CyberLiabilityRequestDict
 */
export type CyberLiabilityRequestDict = {
  totalLimitOfInsurance?: LimitOfInsurance | null;
  /**
   * Numberofdentists
   */
  numberOfDentists?: number | null;
  /**
   * Retroactivedate
   */
  retroactiveDate?: string | null;
};

/**
 * CyberLiabilitySchema
 */
export type CyberLiabilitySchema = {
  answers: CyberLiabilityRequestDict;
};

/**
 * AgentAuthorityError
 */
export type AgentAuthorityError = {
  action: AuthorityActionsEnum;
  /**
   * Message
   */
  message: string;
  /**
   * Survivesnetnew
   */
  survivesNetNew?: boolean;
};

/**
 * AgentAuthorityResponse
 */
export type AgentAuthorityResponse = {
  /**
   * Issuequote
   */
  issueQuote: boolean;
  /**
   * Issuepolicy
   */
  issuePolicy: boolean;
  /**
   * Cansubmitmidterms
   */
  canSubmitMidterms: boolean;
  /**
   * Authorityerrors
   */
  authorityErrors?:
    | {
        [key in AuthorityActionsEnum]?: Array<AgentAuthorityError>;
      }
    | null;
  /**
   * Status
   */
  status?: number;
};

/**
 * AuthorityActionsEnum
 */
export const AuthorityActionsEnum = {
  ISSUE_QUOTE: 'issue_quote',
  ISSUE_POLICY: 'issue_policy',
  SUBMIT_MIDTERMS: 'submit_midterms',
} as const;

/**
 * AuthorityActionsEnum
 */
export type AuthorityActionsEnum =
  (typeof AuthorityActionsEnum)[keyof typeof AuthorityActionsEnum];

/**
 * CreateMidtermTransactionRequest
 */
export type CreateMidtermTransactionRequest = {
  /**
   * Effective Date
   */
  effective_date: string;
  transaction_type: TransactionType;
  metadata?: TransactionMetadataDict;
};

/**
 * TransactionMetadataDict
 *
 * Wire shape of `TransactionMetadata`, also sent to the rating engine.
 */
export type TransactionMetadataDict = {
  /**
   * Reason For Change
   */
  reason_for_change?: string | null;
  cancellation_reason?: CancellationReasonEnum | null;
  cancel_type?: CancelTypeEnum | null;
  /**
   * Notice Generation Date
   */
  notice_generation_date?: string | null;
  /**
   * Cancellation Process Date
   */
  cancellation_process_date?: string | null;
  /**
   * New Expiration Date
   */
  new_expiration_date?: string | null;
  direction?: ExpirationDateChangeDirection | null;
  convert_to_two_year_new_grad?: TermConversionEnum | null;
};

/**
 * ChangeExpirationDateMidtermRequest
 *
 * Request schema for the Change Expiration Date midterm.
 */
export type ChangeExpirationDateMidtermRequest = {
  /**
   * New Expiration Date
   */
  new_expiration_date: string;
  /**
   * Convert To Two Year New Grad
   */
  convert_to_two_year_new_grad?: boolean;
};

/**
 * ChangeEndorsementEffectiveDateRequest
 *
 * Request schema for changing the effective date of an in-progress endorsement.
 */
export type ChangeEndorsementEffectiveDateRequest = {
  /**
   * Effective Date
   */
  effective_date: string;
};

/**
 * SetReasonForChangeRequest
 */
export type SetReasonForChangeRequest = {
  /**
   * Reasonforchange
   */
  reasonForChange: string;
};

/**
 * MidtermPreviewResponse
 */
export type MidtermPreviewResponse = {
  /**
   * Canfinalizemidterm
   */
  canFinalizeMidterm: boolean;
  /**
   * Formulasforui
   */
  formulasForUi: Array<FormulasForUi>;
  /**
   * Reasonforchange
   */
  reasonForChange?: string | null;
};

/**
 * ReasonForChangePreviewResponse
 *
 * Auto-generated "Reason for Change" verbiage for a midterm endorsement (DC-3224).
 *
 * ``reason_for_change`` is the list of independently-renderable Aspen-spec phrases, in
 * diff order and de-duplicated. The frontend joins them (one per line) for the textarea;
 * an empty list means nothing in the diff maps to a phrase (or there is no diff).
 */
export type ReasonForChangePreviewResponse = {
  /**
   * Reasonforchange
   */
  reasonForChange: Array<string>;
};

/**
 * FinalizeMidtermChange
 */
export type FinalizeMidtermChange = {
  /**
   * Reasonforchange
   */
  reasonForChange?: string | null;
  /**
   * Shouldregeneratepolicydocs
   */
  shouldRegeneratePolicyDocs?: boolean;
};

/**
 * DentistUnderwritingQuestionsSchema
 */
export type DentistUnderwritingQuestionsSchema = {
  coveredByAnotherPolicy?: YesNoEnum | null;
  /**
   * Currentcarrier
   */
  currentCarrier?: string | null;
  hasAbsence?: YesNoEnum | null;
  hasMaintainedCoverage?: YesNoEnum | null;
  hasMalpracticeClaim?: YesNoEnum | null;
  hasPendingClaims?: YesNoEnum | null;
  hasReportedSituation?: YesNoNaEnum | null;
  /**
   * Negativeeventexplanation
   */
  negativeEventExplanation?: string | null;
  /**
   * Negativeevents
   */
  negativeEvents?: {
    [key in NegativeEvent]?: YesNoEnum | null;
  };
  /**
   * Whereservicesrendered
   */
  whereServicesRendered?: Array<RendersService>;
  /**
   * Yearscontinuouscoverage
   */
  yearsContinuousCoverage?: number | null;
  treatmentOfSleepApnea?: YesNoEnum | null;
};

/**
 * SpecialForms
 */
export const SpecialForms = {
  QUOTE_PROPOSAL: 'quote_proposal',
  POLICY_SPECIMEN: 'policy_specimen',
  PREMIUM_STATEMENT: 'premium_statement',
  POLICY_BUNDLE: 'policy_bundle',
} as const;

/**
 * SpecialForms
 */
export type SpecialForms = (typeof SpecialForms)[keyof typeof SpecialForms];

/**
 * ConditionalRenewalNoticeRequestSchema
 */
export type ConditionalRenewalNoticeRequestSchema = {
  /**
   * Conditions
   */
  conditions: string;
  /**
   * Display Premium
   */
  display_premium: boolean;
};

/**
 * RatingWorksheetEnum
 */
export const RatingWorksheetEnum = {
  PROPERTY_PREMIUM: 'PROPERTY_PREMIUM',
  PL_PREMIUM: 'PL_PREMIUM',
  OTHER_LIABILITY_PREMIUM: 'OTHER_LIABILITY_PREMIUM',
} as const;

/**
 * RatingWorksheetEnum
 */
export type RatingWorksheetEnum =
  (typeof RatingWorksheetEnum)[keyof typeof RatingWorksheetEnum];

/**
 * ERPWorksheetEnum
 */
export const ErpWorksheetEnum = { ERP_ESTIMATE: 'ERP_ESTIMATE' } as const;

/**
 * ERPWorksheetEnum
 */
export type ErpWorksheetEnum =
  (typeof ErpWorksheetEnum)[keyof typeof ErpWorksheetEnum];

/**
 * DownloadLookerDashboard
 *
 * Body of the loss-run PDF/CSV downloads (`documents/looker_dashboard_*`).
 *
 * `selected_terms` (DC-3671) lists the term (account) ids the report should
 * span. Empty means only the term in the URL, which is the pre-DC-3671
 * behavior; a non-empty list must be a subset of that policy's renewal chain
 * or the endpoint answers 403.
 */
export type DownloadLookerDashboard = {
  /**
   * With Reserves
   */
  with_reserves?: boolean;
  /**
   * With Claimant Name
   */
  with_claimant_name?: boolean;
  /**
   * Selected Dentists
   */
  selected_dentists?: Array<string>;
  loss_run_type?: LossRunType;
  /**
   * Exclude Notices Of Circumstance
   */
  exclude_notices_of_circumstance?: boolean;
  /**
   * Selected Terms
   */
  selected_terms?: Array<string>;
};

/**
 * LossRunType
 *
 * Which slice of the Looker claims report a loss-run download covers.
 *
 * Maps to the report's `handled_by` dimension: Counterpart-handled claims for
 * liability, Carrier-handled claims for property.
 */
export const LossRunType = {
  LIABILITY: 'liability',
  PROPERTY: 'property',
} as const;

/**
 * LossRunType
 *
 * Which slice of the Looker claims report a loss-run download covers.
 *
 * Maps to the report's `handled_by` dimension: Counterpart-handled claims for
 * liability, Carrier-handled claims for property.
 */
export type LossRunType = (typeof LossRunType)[keyof typeof LossRunType];

/**
 * FileDocumentSchema
 */
export type FileDocumentSchema = {
  /**
   * Transactionnumber
   */
  transactionNumber: number;
  status: TransactionStatus;
  /**
   * Effectivedate
   */
  effectiveDate: string | null;
  /**
   * Documentwarehouse
   */
  documentWarehouse: Array<FileDocument>;
};

/**
 * UpdateDocumentRequest
 */
export type UpdateDocumentRequest = {
  /**
   * Filename
   */
  filename: string;
  /**
   * Description
   */
  description: string;
  category: AttachedDocumentType;
  /**
   * Subcategory
   */
  subcategory: string;
};

/**
 * DocumentStatusResponse
 */
export type DocumentStatusResponse = {
  /**
   * Status
   */
  status: number;
  /**
   * Message
   */
  message?: string | null;
};

/**
 * UnderwriterNoteSchema
 */
export type UnderwriterNoteSchema = {
  /**
   * Createdbyemail
   */
  createdByEmail: string;
  /**
   * Id
   */
  id?: string | null;
  /**
   * Note
   */
  note?: string;
  /**
   * Source
   */
  source?: string;
  /**
   * Created At
   */
  createdAt: string;
};

/**
 * UWNotesSourceEnum
 */
export const UwNotesSourceEnum = {
  UW_NOTES_TAB: 'uw_notes_tab',
  FLAG_REVIEW: 'flag_review',
  REFERRAL: 'referral',
} as const;

/**
 * UWNotesSourceEnum
 */
export type UwNotesSourceEnum =
  (typeof UwNotesSourceEnum)[keyof typeof UwNotesSourceEnum];

/**
 * UnderwriterNoteRequest
 */
export type UnderwriterNoteRequest = {
  /**
   * Note
   */
  note: string;
  source?: UwNotesSourceEnum;
};

/**
 * PolicyPendingCancellationSchema
 */
export type PolicyPendingCancellationSchema = {
  /**
   * Notice Generation Date
   */
  notice_generation_date: string;
  /**
   * Cancellation Process Date
   */
  cancellation_process_date: string;
  cancellation_reason: CancellationReasonEnum;
  cancel_type: CancelTypeEnum;
  /**
   * Effective Date
   */
  effective_date: string;
};

/**
 * ObjectSummaryTypeEnum
 */
export const ObjectSummaryTypeEnum = {
  PRACTICE_LOCATIONS: 'practice_locations',
  DENTISTS: 'dentists',
  COMMERCIAL_PROPERTY_LOCATIONS: 'commercial_property_locations',
  OWNED_ENTITIES: 'owned_entities',
} as const;

/**
 * ObjectSummaryTypeEnum
 */
export type ObjectSummaryTypeEnum =
  (typeof ObjectSummaryTypeEnum)[keyof typeof ObjectSummaryTypeEnum];

/**
 * CPLocationFrontend
 */
export type CpLocationFrontend = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  address?: UsAddress | null;
  /**
   * Primary
   */
  primary: boolean;
  /**
   * Isdeleted
   */
  isDeleted: boolean;
  /**
   * Isexpired
   */
  isExpired: boolean;
};

/**
 * DentistFrontend
 */
export type DentistFrontend = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Name
   */
  name: string;
  /**
   * Isdeleted
   */
  isDeleted: boolean;
  /**
   * Isexpired
   */
  isExpired: boolean;
};

/**
 * OwnedEntityFrontend
 */
export type OwnedEntityFrontend = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Entityname
   */
  entityName?: string | null;
  /**
   * Isdeleted
   */
  isDeleted: boolean;
  /**
   * Isexpired
   */
  isExpired: boolean;
  /**
   * Isfirstnamedinsured
   */
  isFirstNamedInsured: boolean;
};

/**
 * PracticeLocationFrontend
 */
export type PracticeLocationFrontend = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  address?: UsAddress | null;
  /**
   * Primary
   */
  primary: boolean;
  /**
   * Isdeleted
   */
  isDeleted: boolean;
  /**
   * Isexpired
   */
  isExpired: boolean;
  /**
   * Googleplaceid
   */
  googlePlaceId?: string | null;
};

/**
 * ErrorDetailDict
 */
export type ErrorDetailDict = {
  /**
   * Detail
   */
  detail: string;
};

/**
 * ReferPolicyRequest
 *
 * Request body for the refer-policy endpoint.
 *
 * All fields are optional; a blank or whitespace-only note is treated as
 * no note and will not create an UnderwriterNote record.
 */
export type ReferPolicyRequest = {
  /**
   * Note
   */
  note?: string;
};

/**
 * TransactionSnapshotSchema
 */
export type TransactionSnapshotSchema = {
  /**
   * Transactionid
   */
  transactionId: string;
  /**
   * Transactionnumber
   */
  transactionNumber: number;
  /**
   * Sequencenumber
   */
  sequenceNumber: number;
  /**
   * Stage
   */
  stage: string;
  status: TransactionStatus;
  transactionType: TransactionType;
  /**
   * Effectivedate
   */
  effectiveDate: string | null;
  /**
   * Transactiondate
   */
  transactionDate: string;
  /**
   * Eventdate
   */
  eventDate: string;
  /**
   * Processeddate
   */
  processedDate?: string | null;
  /**
   * Statusmessage
   */
  statusMessage: string;
};

/**
 * TransactionDetailSchema
 */
export type TransactionDetailSchema = {
  /**
   * Transactionid
   */
  transactionId: string;
  /**
   * Transactionnumber
   */
  transactionNumber: number;
  /**
   * Sequencenumber
   */
  sequenceNumber: number;
  /**
   * Stage
   */
  stage: string;
  status: TransactionStatus;
  transactionType: TransactionType;
  /**
   * Effectivedate
   */
  effectiveDate: string | null;
  /**
   * Transactiondate
   */
  transactionDate: string;
  /**
   * Processeddate
   */
  processedDate?: string | null;
  /**
   * Statusmessage
   */
  statusMessage: string;
  /**
   * Assigneduser
   */
  assignedUser?: string | null;
  /**
   * Writtenamount
   */
  writtenAmount?: number | null;
  /**
   * Billedamount
   */
  billedAmount?: number | null;
  /**
   * Annualamount
   */
  annualAmount?: number | null;
  /**
   * Attachedforms
   */
  attachedForms?: Array<{
    [key: string]: unknown;
  }>;
};

/**
 * NonRenewalReasonEnum
 */
export const NonRenewalReasonEnum = {
  CLAIMS_FREQUENCY: 'claims_frequency',
  CLAIM_SEVERITY: 'claim_severity',
  CLAIMS_FREQUENCY_AND_SEVERITY: 'claims_frequency_and_severity',
  NATURE_OF_OPERATIONS: 'nature_of_operations',
  EXPOSURE_NO_LONGER_ACCEPTABLE: 'exposure_no_longer_acceptable',
  BOARD_ACTIONS: 'board_actions',
} as const;

/**
 * NonRenewalReasonEnum
 */
export type NonRenewalReasonEnum =
  (typeof NonRenewalReasonEnum)[keyof typeof NonRenewalReasonEnum];

/**
 * PolicyRenewalFlagSchema
 */
export type PolicyRenewalFlagSchema = {
  reasonForNonRenewal?: NonRenewalReasonEnum | null;
  /**
   * Note
   */
  note?: string | null;
};

/**
 * ChildPolicyData
 */
export type ChildPolicyData = {
  /**
   * Policyid
   */
  policyId: string;
  /**
   * Boundpolicynumber
   */
  boundPolicyNumber: string;
  /**
   * Isbound
   */
  isBound: boolean;
};

/**
 * TermData
 *
 * A single term in a policy renewal chain, as returned by the terms selector (DC-3253).
 */
export type TermData = {
  /**
   * Accountid
   */
  accountId: string;
  /**
   * Termnumber
   */
  termNumber: number;
  /**
   * Effectivedate
   */
  effectiveDate: string | null;
  /**
   * Expirationdate
   */
  expirationDate: string | null;
  lifecycle: LifecycleEnum;
  /**
   * Iscurrent
   */
  isCurrent: boolean;
};

/**
 * TermsData
 *
 * The renewal chain for GET /{account_id}/terms/, ordered most-recent-first.
 */
export type TermsData = {
  /**
   * Terms
   */
  terms: Array<TermData>;
};

/**
 * AttachedFormSchema
 */
export type AttachedFormSchema = {
  /**
   * Id
   */
  id: string;
  /**
   * Version Number
   */
  version_number: number;
  /**
   * Name
   */
  name: string;
  /**
   * Description
   */
  description?: string;
  /**
   * Attachment Description
   */
  attachment_description?: string;
  /**
   * Form Id
   */
  form_id: string;
  /**
   * Is Template
   */
  is_template: boolean;
  /**
   * Is Template Complete
   */
  is_template_complete: boolean;
  attached_by: AttachedByEnum;
  form_level: AllFormLevels;
  /**
   * Can Detach
   */
  can_detach: boolean;
  /**
   * Transaction Number
   */
  transaction_number: number;
  /**
   * Is Superseded
   */
  is_superseded: boolean;
  /**
   * Superseded By Transaction Number
   */
  superseded_by_transaction_number: number | null;
};

/**
 * FormsInputSchema
 */
export type FormsInputSchema = {
  /**
   * Document Id
   */
  document_id: string;
  /**
   * Version Number
   */
  version_number: number;
  /**
   * User Variables
   */
  user_variables?: {
    [key: string]: unknown;
  };
  /**
   * Object Id
   */
  object_id?: string | null;
  object_type?: ObjectTypeEnum;
};

/**
 * AvailableFormSchema
 */
export type AvailableFormSchema = {
  /**
   * Id
   */
  id: string;
  /**
   * Version Number
   */
  version_number: number;
  /**
   * Name
   */
  name: string;
  /**
   * Description
   */
  description?: string;
  /**
   * Attachment Description
   */
  attachment_description?: string;
  /**
   * Form Id
   */
  form_id: string;
  /**
   * Is Template
   */
  is_template: boolean;
  form_level: AllFormLevels;
  /**
   * Multiple Occurrence
   */
  multiple_occurrence: boolean;
};

/**
 * RenderFormsInputSchema
 */
export type RenderFormsInputSchema = {
  /**
   * Document Id
   */
  document_id: string;
  /**
   * Version Number
   */
  version_number: number;
  /**
   * User Variables
   */
  user_variables?: {
    [key: string]: unknown;
  };
  /**
   * Object Id
   */
  object_id?: string | null;
  object_type?: ObjectTypeEnum;
  /**
   * Sequence Id
   */
  sequence_id?: number | null;
};

/**
 * DefaultAnswerTypeEnum
 *
 * How a CMS question's ``default_answer`` should be interpreted when seeding.
 *
 * - ``FIXED_VALUE``: ``default_answer`` is a literal answer, used as-is.
 * - ``ACCOUNT_VALUE``: ``default_answer`` is a key resolved against the policy
 * account context (the same ``@`` source the ODT renderer uses).
 * - ``NO_DEFAULT``: the question has no default; nothing is seeded.
 */
export const DefaultAnswerTypeEnum = {
  FIXED_VALUE: 'FIXED_VALUE',
  ACCOUNT_VALUE: 'ACCOUNT_VALUE',
  NO_DEFAULT: 'NO_DEFAULT',
} as const;

/**
 * DefaultAnswerTypeEnum
 *
 * How a CMS question's ``default_answer`` should be interpreted when seeding.
 *
 * - ``FIXED_VALUE``: ``default_answer`` is a literal answer, used as-is.
 * - ``ACCOUNT_VALUE``: ``default_answer`` is a key resolved against the policy
 * account context (the same ``@`` source the ODT renderer uses).
 * - ``NO_DEFAULT``: the question has no default; nothing is seeded.
 */
export type DefaultAnswerTypeEnum =
  (typeof DefaultAnswerTypeEnum)[keyof typeof DefaultAnswerTypeEnum];

/**
 * FrontendQuestionSchema
 */
export type FrontendQuestionSchema = {
  /**
   * Question Key
   */
  question_key: string;
  /**
   * Question Label
   */
  question_label: string;
  /**
   * Required
   */
  required: boolean;
  /**
   * Read Only
   */
  read_only: boolean;
  question_type: QuestionTypeEnum;
  /**
   * Values
   */
  values: Array<{
    [key: string]: unknown;
  }>;
  /**
   * Default Answer
   */
  default_answer: string | null;
  default_answer_type?: DefaultAnswerTypeEnum;
  /**
   * Help Text
   */
  help_text: string | null;
  /**
   * Order
   */
  order?: number | null;
  /**
   * Answer
   */
  answer: unknown;
  /**
   * Sub Questions
   */
  sub_questions?: Array<FrontendQuestionSchema>;
};

/**
 * QuestionTypeEnum
 */
export const QuestionTypeEnum = {
  TEXT: 'TEXT',
  LONG_TEXT: 'LONG_TEXT',
  SELECT: 'SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
  CHECKBOX: 'CHECKBOX',
  CURRENCY: 'CURRENCY',
  TIME: 'TIME',
  ARRAY: 'ARRAY',
} as const;

/**
 * QuestionTypeEnum
 */
export type QuestionTypeEnum =
  (typeof QuestionTypeEnum)[keyof typeof QuestionTypeEnum];

/**
 * SaveQuestionsBody
 */
export type SaveQuestionsBody = {
  /**
   * User Variables
   */
  user_variables: {
    [key: string]: unknown;
  };
};

/**
 * BindingConditionsSchema
 */
export type BindingConditionsSchema = {
  /**
   * Createdbyemail
   */
  createdByEmail: string;
  /**
   * ID
   */
  id?: number | null;
  /**
   * Condition
   */
  condition?: string;
  /**
   * Created At
   */
  createdAt: string;
};

/**
 * BindingConditionRequest
 */
export type BindingConditionRequest = {
  /**
   * Condition
   */
  condition: string;
};

/**
 * TermConditionsSchema
 */
export type TermConditionsSchema = {
  /**
   * Createdbyemail
   */
  createdByEmail: string;
  /**
   * ID
   */
  id?: number | null;
  /**
   * Condition
   */
  condition?: string;
  /**
   * Pending Review
   */
  pendingReview?: boolean;
  /**
   * Created At
   */
  createdAt: string;
};

/**
 * TermConditionRequest
 */
export type TermConditionRequest = {
  /**
   * Condition
   */
  condition: string;
  /**
   * Pendingreview
   */
  pendingReview: boolean;
};

/**
 * PartialTermConditionRequest
 */
export type PartialTermConditionRequest = {
  /**
   * Condition
   */
  condition?: string | null;
  /**
   * Pendingreview
   */
  pendingReview?: boolean | null;
};

/**
 * ErpEligibleDatesResponse
 */
export type ErpEligibleDatesResponse = {
  /**
   * Eligibledates
   */
  eligibleDates: Array<string>;
};

/**
 * ERPEntityKind
 *
 * ERP Entity Kind
 */
export const ErpEntityKind = {
  DENTIST: 'dentist',
  OWNED_ENTITY: 'owned_entity',
  EPLI_STANDARD_COVERAGE: 'epli_standard_coverage',
  EPLI_ENHANCED_COVERAGE: 'epli_enhanced_coverage',
  ERISA_COVERAGE: 'erisa_coverage',
  CYBER_COVERAGE: 'cyber_coverage',
  ASSOCIATION_COVERAGE: 'association_coverage',
} as const;

/**
 * ERPEntityKind
 *
 * ERP Entity Kind
 */
export type ErpEntityKind = (typeof ErpEntityKind)[keyof typeof ErpEntityKind];

/**
 * ErpRow
 */
export type ErpRow = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Pk
   */
  pk: string;
  /**
   * Entitytype
   */
  entityType: ErpEntityKind | string;
  /**
   * Name
   */
  name: string;
  /**
   * Effectivedate
   */
  effectiveDate: string;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Erpestimateprice
   */
  erpEstimatePrice?: number | null;
  /**
   * Erpquoteissuedat
   */
  erpQuoteIssuedAt?: string | null;
  /**
   * Erpestimateasof
   */
  erpEstimateAsOf?: string | null;
  /**
   * Erpexpirationdate
   *
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: string | null;
};

/**
 * ErpSection
 */
export type ErpSection = {
  key: ErpSectionKind;
  /**
   * Entitytype
   */
  entityType: ErpEntityKind | string;
  /**
   * Hascivilregulatoryerp
   */
  hasCivilRegulatoryErp: boolean;
  /**
   * Erptypeoptions
   */
  erpTypeOptions: Array<SelectOption>;
  /**
   * Erpdurationoptions
   */
  erpDurationOptions: Array<SelectOption>;
  /**
   * Rows
   */
  rows: Array<ErpRow>;
  /**
   * Title
   *
   * Return the readable title for this ERP section.
   */
  readonly title: string;
};

/**
 * ErpSectionKind
 *
 * ERP Section Kind
 */
export const ErpSectionKind = {
  PL_ERP: 'pl_erp',
  ENTITY_ERP: 'entity_erp',
  EPLI_STANDARD: 'epli_standard',
  EPLI_ENHANCED: 'epli_enhanced',
  ERISA: 'erisa',
  CYBER: 'cyber',
  ASSOCIATION_ERP: 'association_erp',
} as const;

/**
 * ErpSectionKind
 *
 * ERP Section Kind
 */
export type ErpSectionKind =
  (typeof ErpSectionKind)[keyof typeof ErpSectionKind];

/**
 * SelectOption
 */
export type SelectOption = {
  /**
   * Value
   */
  value: string;
  /**
   * Label
   */
  label: string;
};

/**
 * ErpStartRequest
 */
export type ErpStartRequest = {
  /**
   * Effectivedate
   */
  effectiveDate: string;
};

/**
 * ErpSaveResponse
 *
 * The updated ERP sections and rating warnings returned after saving.
 */
export type ErpSaveResponse = {
  /**
   * Sections
   */
  sections: Array<ErpSection>;
  /**
   * Warnings
   */
  warnings?: Array<ErpWarning>;
};

/**
 * ErpWarning
 *
 * A rating-engine warning normalized for ERP API consumers.
 */
export type ErpWarning = {
  /**
   * Key
   */
  key: string;
  /**
   * Message
   */
  message: string;
};

/**
 * ErpSaveRequest
 */
export type ErpSaveRequest = {
  /**
   * Sections
   */
  sections: Array<ErpSaveSectionRequest>;
};

/**
 * ErpSaveRowRequest
 */
export type ErpSaveRowRequest = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Pk
   */
  pk: string;
  entityType: ErpEntityKind;
};

/**
 * ErpSaveSectionRequest
 */
export type ErpSaveSectionRequest = {
  key: ErpSectionKind;
  /**
   * Rows
   */
  rows: Array<ErpSaveRowRequest>;
};

/**
 * CopyPolicyResponse
 */
export type CopyPolicyResponse = {
  /**
   * Newpolicyid
   */
  newPolicyId: string;
  /**
   * Policynumber
   */
  policyNumber: string | null;
  /**
   * Quotenumber
   */
  quoteNumber: string;
};

/**
 * TokenSchema
 */
export type TokenSchema = {
  /**
   * Token
   */
  token: string;
};

/**
 * Message
 */
export type Message = {
  /**
   * Message
   */
  message: string;
};

/**
 * BulkPolicyResponse
 */
export type BulkPolicyResponse = {
  /**
   * Records
   */
  records: Array<PolicyDataResponse>;
  /**
   * Errors
   */
  errors: Array<[string, string]>;
};

/**
 * PolicyDataResponse
 */
export type PolicyDataResponse = {
  /**
   * Mailing City
   */
  mailing_city: string | null;
  /**
   * Mailing Zip
   */
  mailing_zip: string | null;
  mailing_state: UsStateEnum | null;
  /**
   * Mailing Address
   */
  mailing_address: string | null;
  /**
   * Policy Number
   */
  policy_number: string | null;
};

/**
 * OneSchemaColumn
 *
 * OneSchemaColumn(*, sheet_column_name: str, template_column_name: str, template_column_key: str)
 */
export type OneSchemaColumn = {
  /**
   * Sheet Column Name
   */
  sheet_column_name: string;
  /**
   * Template Column Name
   */
  template_column_name: string;
  /**
   * Template Column Key
   */
  template_column_key: string;
};

/**
 * OneSchemaPolicyRequest
 */
export type OneSchemaPolicyRequest = {
  /**
   * Embed Id
   */
  embed_id: number;
  template_key?: TemplateKeyEnum;
  /**
   * Workspace Id
   */
  workspace_id: number;
  /**
   * Sheet Id
   */
  sheet_id: number;
  sheet_metadata?: OneSchemaSheetMetadata | null;
  /**
   * Columns
   */
  columns: Array<OneSchemaColumn>;
  /**
   * Count
   */
  count: number;
  /**
   * Records
   */
  records: Array<PolicyData>;
  /**
   * Error Records
   */
  error_records: Array<unknown>;
};

/**
 * OneSchemaSheetMetadata
 *
 * OneSchemaSheetMetadata(*, original_file_name: str | None = None, original_sheet_name: str | None = None)
 */
export type OneSchemaSheetMetadata = {
  /**
   * Original File Name
   */
  original_file_name?: string | null;
  /**
   * Original Sheet Name
   */
  original_sheet_name?: string | null;
};

/**
 * PolicyData
 */
export type PolicyData = {
  /**
   * Agency Name
   */
  agency_name: string;
  /**
   * Policy Number
   */
  policy_number?: string | null;
  /**
   * Agency Id
   */
  agency_id: string;
  /**
   * Policy Expiration Date
   */
  policy_expiration_date: string;
  policy_type: PolicyTypeEnum2;
  policy_state: UsStateEnum;
  /**
   * Carrier
   */
  carrier: 'Aspen American Insurance Company';
  /**
   * First Named Insured
   */
  first_named_insured: string;
  first_named_insured_type: FirstNamedInsuredTypeEnum;
  /**
   * Mailing Address
   */
  mailing_address?: string | null;
  /**
   * Mailing City
   */
  mailing_city?: string | null;
  mailing_state?: UsStateEnum | null;
  /**
   * Mailing Zip
   */
  mailing_zip?: string | null;
  gl_limits: LimitsEnum | null;
  erisa: YesNoEnum | null;
  epl_epli: EplEpliEnum;
  /**
   * Number Employees
   */
  number_employees: number | null;
  separate_aggregate?: YesNoEnum | null;
  /**
   * Hiredauto Occurrence Limit
   */
  hiredauto_occurrence_limit?: string | null;
  hired_auto_damage?: YesNoEnum | null;
  /**
   * Fungi Occurrence Limit
   */
  fungi_occurrence_limit?: string | null;
  fungi_coverage_desired?: YesNoEnum | null;
  /**
   * Epli Occurrence Limit
   */
  epli_occurrence_limit?: string | null;
  /**
   * Epli Deductible
   */
  epli_deductible?: string | null;
  /**
   * Epli Onelimit Occurrence Limit
   */
  epli_onelimit_occurrence_limit?: string | null;
  /**
   * Epli Prior Acts Date
   */
  epli_prior_acts_date: string | null;
  /**
   * Erisa Occurrence Limit
   */
  erisa_occurrence_limit?: _0Enum2 | null;
  faculty_policy_indicator?: YesNoEnum | null;
  volunteer_policy_indicator?: YesNoEnum | null;
  /**
   * Pl Sub Type
   */
  pl_sub_type?: _0Enum3 | null;
  renewal_indicator?: YesNoEnum | null;
  /**
   * Pl Coverage Type
   */
  pl_coverage_type?: _0Enum4 | null;
};

/**
 * BulkDentistResponse
 */
export type BulkDentistResponse = {
  /**
   * Records
   */
  records: Array<DentistResponse>;
  /**
   * Errors
   */
  errors: Array<[string, string, string]>;
};

/**
 * DentistResponse
 */
export type DentistResponse = {
  /**
   * Policy Number
   */
  policy_number: string;
  /**
   * First Name
   */
  first_name: string;
  /**
   * Middle Name
   */
  middle_name: string;
  /**
   * Last Name
   */
  last_name: string;
  /**
   * Designation
   */
  designation: Array<ItemsEnum>;
  /**
   * Email Address
   */
  email_address: string;
};

/**
 * DentistData
 */
export type DentistData = {
  /**
   * Policy Number
   */
  policy_number?: string | null;
  /**
   * Quote Number
   */
  quote_number?: string | null;
  /**
   * Carrier
   */
  carrier: 'Aspen American Insurance Company';
  /**
   * Agency
   */
  agency: string;
  /**
   * Agency Id
   */
  agency_id: string;
  policy_state: UsStateEnum;
  /**
   * Policy Expiration Date
   */
  policy_expiration_date: string;
  optin_increase_limits_match_cap: YesNoEnum;
  policy_type: PolicyTypeEnum2;
  /**
   * First Name
   */
  first_name: string;
  /**
   * Middle Name
   */
  middle_name: string;
  /**
   * Last Name
   */
  last_name: string;
  /**
   * Designation
   */
  designation: Array<ItemsEnum>;
  first_named_insured_flag: YesNoEnum;
  /**
   * First Named Insured
   */
  first_named_insured: string;
  first_named_insured_type: FirstNamedInsuredTypeEnum;
  /**
   * Total Of Active Insureds On Policy
   */
  total_of_active_insureds_on_policy: number;
  /**
   * Practice Address
   */
  practice_address: string;
  /**
   * Practice Address 2
   */
  practice_address_2: string;
  practice_state: UsStateEnum;
  /**
   * Practice City
   */
  practice_city: string;
  /**
   * Practice Zip
   */
  practice_zip: string;
  /**
   * Email Address
   */
  email_address: string;
  /**
   * Practice County
   */
  practice_county: string;
  /**
   * Derived Practice County
   */
  derived_practice_county: string;
  /**
   * Years Practice
   */
  years_practice: number;
  /**
   * Derived Years In Practice
   */
  derived_years_in_practice: number;
  pt_ft: PtFtEnum;
  limits: LimitsEnum | null;
  /**
   * Prior Acts Date
   */
  prior_acts_date: string | null;
  /**
   * Epl Prior Acts Date
   */
  epl_prior_acts_date: string | null;
  /**
   * Epli Prior Acts Date
   */
  epli_prior_acts_date: string | null;
  practice_speciality: PracticeSpecialty | null;
  cosmetic_dermal: YesNoEnum;
  deep_sedation: DeepSedationEnum;
  sda_member: YesNoEnum;
  derived_pl_subtype: _0Enum3;
  /**
   * Risk Management Date
   */
  risk_management_date: string | null;
  rm_duration: RmDurationEnum;
  /**
   * Years Claims Free
   */
  years_claims_free: number | null;
  /**
   * Derived Years Claims Free
   */
  derived_years_claims_free: number | null;
  /**
   * Total Credits
   */
  total_credits: number;
  rolling_debit: RollingDebitEnum;
  /**
   * Years With Cna
   */
  years_with_cna: number;
  /**
   * Derived Years Cna
   */
  derived_years_cna: number;
  /**
   * Date Of Birth
   */
  date_of_birth: string;
  tmj: YesNoEnum;
  implant_placement: YesNoEnum;
  partially_impacted: YesNoEnum;
  fully_impacted: YesNoEnum;
  mini_implants: YesNoEnum;
  molar_endodontics: YesNoEnum;
  derived_claims_closed_in_last_five_years: YesNoEnum | null;
  derived_num_years_since_last_claim: DerivedNumYearsSinceLastClaimEnum;
  renewal_indicator?: YesNoEnum | null;
};

/**
 * OneSchemaDentistRequest
 */
export type OneSchemaDentistRequest = {
  /**
   * Embed Id
   */
  embed_id: number;
  template_key?: TemplateKeyEnum;
  /**
   * Workspace Id
   */
  workspace_id: number;
  /**
   * Sheet Id
   */
  sheet_id: number;
  sheet_metadata?: OneSchemaSheetMetadata | null;
  /**
   * Columns
   */
  columns: Array<OneSchemaColumn>;
  /**
   * Count
   */
  count: number;
  /**
   * Records
   */
  records: Array<DentistData>;
  /**
   * Error Records
   */
  error_records: Array<unknown>;
};

/**
 * BulkPropertyResponse
 */
export type BulkPropertyResponse = {
  /**
   * Records
   */
  records: Array<PropertyResponse>;
  /**
   * Errors
   */
  errors: Array<[string, string, string]>;
};

/**
 * PropertyResponse
 */
export type PropertyResponse = {
  /**
   * Policy Number
   */
  policy_number: string;
  /**
   * Location Address
   */
  location_address: string;
  /**
   * Location City
   */
  location_city: string;
  /**
   * Location County
   */
  location_county: string;
  location_state: UsStateEnum;
  /**
   * Location Zip
   */
  location_zip: string;
};

/**
 * OneSchemaPropertyRequest
 */
export type OneSchemaPropertyRequest = {
  /**
   * Embed Id
   */
  embed_id: number;
  template_key?: TemplateKeyEnum;
  /**
   * Workspace Id
   */
  workspace_id: number;
  /**
   * Sheet Id
   */
  sheet_id: number;
  sheet_metadata?: OneSchemaSheetMetadata | null;
  /**
   * Columns
   */
  columns: Array<OneSchemaColumn>;
  /**
   * Count
   */
  count: number;
  /**
   * Records
   */
  records: Array<PropertyData>;
  /**
   * Error Records
   */
  error_records: Array<unknown>;
};

/**
 * PropertyData
 */
export type PropertyData = {
  /**
   * Policy Number
   */
  policy_number?: string | null;
  /**
   * Quote Number
   */
  quote_number?: string | null;
  /**
   * Carrier
   */
  carrier: 'Aspen American Insurance Company';
  /**
   * Agency
   */
  agency: string;
  /**
   * Agency Id
   */
  agency_id: string;
  policy_state: UsStateEnum;
  /**
   * Policy Expiration Date
   */
  policy_expiration_date: string;
  /**
   * First Named Insured
   */
  first_named_insured: string;
  first_named_insured_type: FirstNamedInsuredTypeEnum;
  /**
   * Location Address
   */
  location_address: string;
  /**
   * Practice Address 2
   */
  practice_address_2?: string | null;
  /**
   * Location City
   */
  location_city: string;
  location_state: UsStateEnum;
  /**
   * Location Zip
   */
  location_zip: string;
  /**
   * Location County
   */
  location_county: string;
  /**
   * Derived County
   */
  derived_county: string;
  /**
   * Blanket Limit
   */
  blanket_limit: number;
  /**
   * Accounts Receivable Limit
   */
  accounts_receivable_limit: number;
  property_dedbl: PropertyDedblEnum;
  equipment_breakdown: YesNoEnum;
  windstorm_exclusion: YesNoEnum;
  building_coverage: YesNoEnum;
  /**
   * Building Limit
   */
  building_limit: number;
  /**
   * Valued Daily Limit
   */
  valued_daily_limit: number;
  /**
   * Valued Daily Days
   */
  valued_daily_days: number;
  waiting_period: WaitingPeriodEnum;
  financials_received_yn: YesNoEnum;
  /**
   * Flood Limit
   */
  flood_limit: number;
  wind_deductible: WindDeductibleEnum;
  construction_type: ConstructionTypeEnum;
  sprinkler: YesNoEnum;
  fire_alarm: FireAlarmEnum;
  smoke_alarm: FireAlarmEnum;
  automatic_valve: YesNoEnum;
  /**
   * Irpm
   */
  irpm: number;
  /**
   * Derived Building Limit
   */
  derived_building_limit: number;
  /**
   * Derived Contents Limit
   */
  derived_contents_limit: number;
  /**
   * Building Inflation Guard
   */
  building_inflation_guard?: _0Enum5 | null;
  /**
   * Contents Inflation Guard
   */
  contents_inflation_guard?: _0Enum5 | null;
  earthquake_indicator?: YesNoEnum | null;
  /**
   * Earthquake Coverage
   */
  earthquake_coverage?: _0Enum6 | null;
  /**
   * Total Earthquake Limit
   */
  total_earthquake_limit?: string | null;
  /**
   * Earthquake Limit
   */
  earthquake_limit?: number | null;
  flood_indicator?: YesNoEnum | null;
  /**
   * Flood Coverage
   */
  flood_coverage?: _0Enum6 | null;
  /**
   * Total Flood Limit
   */
  total_flood_limit?: string | null;
  electronic_equip_surge_protectors?: YesNoEnum | null;
  /**
   * Total Electronic Equip Limit
   */
  total_electronic_equip_limit?: number | null;
  /**
   * Electronic Equip Coverage
   */
  electronic_equip_coverage?: _0Enum7 | null;
  /**
   * Flood Zone
   */
  flood_zone?: string | null;
  /**
   * Flood Risk Score
   */
  flood_risk_score?: string | null;
  /**
   * Earthquake Risk Score
   */
  earthquake_risk_score?: string | null;
  /**
   * Sewer Limit
   */
  sewer_limit?: string | null;
  /**
   * Sewer Backup Coverage
   */
  sewer_backup_coverage?: _0Enum7 | null;
  /**
   * Total Sewer Backup Limit
   */
  total_sewer_backup_limit?: string | null;
  /**
   * Rents Limit
   */
  rents_limit?: string | null;
  building_leased_to_others?: YesNoEnum | null;
  rents_coverage_desired?: YesNoEnum | null;
  /**
   * Rents Limit Of Insurance
   */
  rents_limit_of_insurance?: string | null;
  /**
   * Building Leased To Others Limit
   */
  building_leased_to_others_limit?: string | null;
  /**
   * Building Leased To Others Coverage
   */
  building_leased_to_others_coverage?: _0Enum7 | null;
  /**
   * Signs Limit
   */
  signs_limit?: string | null;
  /**
   * Signs Coverage
   */
  signs_coverage?: _0Enum7 | null;
  /**
   * Total Signs Limit
   */
  total_signs_limit?: string | null;
  /**
   * Propertyop Limit
   */
  propertyop_limit?: string | null;
  /**
   * Off Prem Coverage
   */
  off_prem_coverage?: _0Enum8 | null;
  /**
   * Total Off Prem Limit
   */
  total_off_prem_limit?: string | null;
  loss_assessment_coverage?: LossAssessmentCoverageEnum;
  /**
   * Total Loss Assessment Limit
   */
  total_loss_assessment_limit?: string | null;
  /**
   * User Year Built
   */
  user_year_built?: number | null;
  renewal_indicator?: YesNoEnum | null;
};

/**
 * WritingCompanySchema
 *
 * Schema for Writing Company
 */
export type WritingCompanySchema = {
  /**
   * Uuid
   */
  uuid?: string;
  /**
   * Name
   */
  name: string;
  /**
   * Short Name
   */
  shortName: string;
  /**
   * Minimum Earned Premium
   */
  minimumEarnedPremium?: string;
};

/**
 * ValidatedAgencyResponse
 *
 * Schema for the validated agency response.
 */
export type ValidatedAgencyResponse = {
  /**
   * Agencyuuid
   */
  agencyUuid: string;
  /**
   * Agencyname
   */
  agencyName: string;
  /**
   * Agencyoperatingstates
   */
  agencyOperatingStates: Array<UsStateEnum>;
  /**
   * Firstname
   */
  firstName: string;
  /**
   * Lastname
   */
  lastName: string;
  /**
   * Email
   */
  email: string;
  /**
   * Phone
   */
  phone: string | null;
};

/**
 * ValidateAgencyRequest
 *
 * Schema for validating the agency.
 */
export type ValidateAgencyRequest = {
  /**
   * Agencyuuid
   */
  agencyUuid: string | null;
  practiceState: UsStateEnum | null;
};

/**
 * ValidatedAssociationCodeResponse
 */
export type ValidatedAssociationCodeResponse = {
  /**
   * Agencyuuid
   */
  agencyUuid: string;
  /**
   * Agencyname
   */
  agencyName: string;
  /**
   * Agencyoperatingstates
   */
  agencyOperatingStates: Array<UsStateEnum>;
  /**
   * Firstname
   */
  firstName: string;
  /**
   * Lastname
   */
  lastName: string;
  /**
   * Email
   */
  email: string;
  /**
   * Phone
   */
  phone: string | null;
  /**
   * Code
   */
  code: string;
};

/**
 * AssociationCodeValidationMessage
 */
export type AssociationCodeValidationMessage = {
  /**
   * Message
   */
  message: string;
};

/**
 * ValidateAssociationCodeRequest
 */
export type ValidateAssociationCodeRequest = {
  /**
   * Agencyuuid
   */
  agencyUuid: string | null;
  practiceState: UsStateEnum | null;
  /**
   * Code
   */
  code: string | null;
};

/**
 * AnswersResponse
 */
export type AnswersResponse = {
  /**
   * Accountid
   */
  accountId: string;
  /**
   * Quotenumber
   */
  quoteNumber: string;
  /**
   * Boundpolicynumber
   */
  boundPolicyNumber: string;
  status: TransactionStatus;
  /**
   * Transactiondate
   */
  transactionDate: string;
  /**
   * Effectivedate
   */
  effectiveDate: string | null;
  pages: PagesResponse;
  /**
   * Paymentbypassed
   */
  paymentBypassed?: boolean;
};

/**
 * CoverageQuestions
 *
 * Schema for the second page of the form.
 */
export type CoverageQuestions = {
  /**
   * Policyeffectivedate
   */
  policyEffectiveDate: string;
  coverageBasis: CoverageBasis;
  /**
   * Prioractsdate
   */
  priorActsDate: string | null;
  limitsDesired: LimitsEnum;
};

/**
 * PagesResponse
 */
export type PagesResponse = {
  yourInformation: YourInformation;
  coverageQuestions?: CoverageQuestions | null;
  representationsAndFraud?: RepresentationsAndFraud | null;
  summary?: Summary | null;
  payment?: Payment | null;
};

/**
 * Payment
 */
export type Payment = {
  /**
   * Available
   */
  available: boolean;
  paymentData: PaymentData | null;
};

/**
 * PaymentData
 *
 * Schema for the pay and issue coverage page.
 */
export type PaymentData = {
  /**
   * Amount
   */
  amount: number;
  /**
   * Checkouturl
   */
  checkoutUrl: string;
  /**
   * Paidat
   */
  paidAt: string | null;
};

/**
 * RepresentationsAndFraud
 */
export type RepresentationsAndFraud = {
  agreedRepresentationsAndFraud: YesNoEnum;
  /**
   * Signature
   */
  signature: string;
  /**
   * Signaturedate
   */
  signatureDate: string;
};

/**
 * Summary
 *
 * Schema for the summary page.
 */
export type Summary = {
  /**
   * Coverageeffectivedate
   */
  coverageEffectiveDate: string;
  coverageBasis: CoverageBasis;
  /**
   * Prioractsdate
   */
  priorActsDate: string;
  limitsDesired: LimitsEnum;
  /**
   * Premium
   */
  premium: number;
  /**
   * Taxes
   */
  taxes: number;
  /**
   * Total
   */
  total: number;
};

/**
 * YourInformation
 */
export type YourInformation = {
  /**
   * Agencyuuid
   */
  agencyUuid: string;
  /**
   * Associationcode
   */
  associationCode?: string | null;
  policyContractState: UsStateEnum;
  /**
   * Firstname
   */
  firstName: string;
  /**
   * Middlename
   */
  middleName: string | null;
  /**
   * Lastname
   */
  lastName: string;
  /**
   * Professionaldesignation
   */
  professionalDesignation: Array<ItemsEnum>;
  /**
   * Dateofbirth
   */
  dateOfBirth: string | null;
  /**
   * Emailaddress
   */
  emailAddress: string;
  /**
   * Postgraduationemail
   */
  postGraduationEmail: string | null;
  /**
   * Cellphonenumber
   */
  cellPhoneNumber: string;
  mailingAddress: UsAddress;
  memberOfSda: YesNoEnum;
  /**
   * Nameofdentalschool
   */
  nameOfDentalSchool: string | null;
  yearMonthGraduation: YearMonth;
  practiceSpecialty: PracticeSpecialty;
  primaryPracticeAddress: UsAddress;
  firstTimePractice: YesNoEnum;
};

/**
 * AssociationCodeValidationError
 */
export type AssociationCodeValidationError = {
  /**
   * Associationcode
   */
  associationCode: Array<string>;
  /**
   * Message
   */
  message: string;
};

/**
 * AnswersRequest
 */
export type AnswersRequest = {
  /**
   * Accountid
   */
  accountId: string | null;
  pages: Pages;
};

/**
 * Pages
 */
export type Pages = {
  yourInformation: YourInformation;
  coverageQuestions?: CoverageQuestions | null;
  representationsAndFraud?: RepresentationsAndFraud | null;
};

/**
 * _MFAVerifyResponse
 */
export type MfaVerifyResponse = {
  /**
   * Status
   */
  status: number;
  /**
   * Message
   */
  message: string;
};

/**
 * MFAVerifySchema
 */
export type MfaVerifySchema = {
  /**
   * Token
   */
  token: string;
  /**
   * User Id
   */
  user_id: number;
};

/**
 * AssistantConfigResponse
 */
export type AssistantConfigResponse = {
  /**
   * Enabled
   */
  enabled: boolean;
};

/**
 * ChatResponse
 */
export type ChatResponse = {
  /**
   * Response
   */
  response: string;
  /**
   * Interaction Id
   */
  interaction_id: number;
};

/**
 * ChatRequest
 */
export type ChatRequest = {
  /**
   * Messages
   */
  messages: Array<MessageSchema>;
  /**
   * Currenturl
   */
  currentUrl?: string | null;
};

/**
 * MessageSchema
 */
export type MessageSchema = {
  role: RoleEnum;
  /**
   * Content
   */
  content: string;
};

/**
 * FeedbackRequest
 */
export type FeedbackRequest = {
  /**
   * Feedback
   */
  feedback: number;
};

/**
 * Response
 */
export const ResponseEnum = {
  READ: 'READ',
  WRITE: 'WRITE',
  UNAUTHORIZED: 'UNAUTHORIZED',
} as const;

/**
 * Response
 */
export type ResponseEnum = (typeof ResponseEnum)[keyof typeof ResponseEnum];

/**
 * Amounttype
 */
export const AmounttypeEnum = { PREMIUM: 'premium', TAX: 'tax' } as const;

/**
 * Amounttype
 */
export type AmounttypeEnum =
  (typeof AmounttypeEnum)[keyof typeof AmounttypeEnum];

export const ItemsEnum = {
  BDS: 'BDS',
  DDS: 'DDS',
  DMD: 'DMD',
  MD: 'MD',
  MS: 'MS',
  MSD: 'MSD',
  DDM: 'DDM',
} as const;

export type ItemsEnum = (typeof ItemsEnum)[keyof typeof ItemsEnum];

export const _0Enum = {
  '0%': '0%',
  '25%': '25%',
  '50%': '50%',
  '100%': '100%',
} as const;

export type _0Enum = (typeof _0Enum)[keyof typeof _0Enum];

/**
 * Lifecycle
 */
export const LifecycleEnum = {
  CURRENT: 'current',
  EXPIRED: 'expired',
  RENEWAL_UPCOMING: 'renewal_upcoming',
} as const;

/**
 * Lifecycle
 */
export type LifecycleEnum = (typeof LifecycleEnum)[keyof typeof LifecycleEnum];

/**
 * Attached By
 */
export const AttachedByEnum = { SYSTEM: 'system', USER: 'user' } as const;

/**
 * Attached By
 */
export type AttachedByEnum =
  (typeof AttachedByEnum)[keyof typeof AttachedByEnum];

/**
 * Object Type
 */
export const ObjectTypeEnum = {
  POLICY: 'POLICY',
  DENTIST: 'DENTIST',
  LOCATION: 'LOCATION',
  ENTITY: 'ENTITY',
} as const;

/**
 * Object Type
 */
export type ObjectTypeEnum =
  (typeof ObjectTypeEnum)[keyof typeof ObjectTypeEnum];

/**
 * Template Key
 */
export const TemplateKeyEnum = {
  POLICY_RENEWAL_V1: 'policy_renewal_v1',
  DENTIST_RENEWAL_V1: 'dentist_renewal_v1',
  PROPERTY_RENEWAL_V1: 'property_renewal_v1',
} as const;

/**
 * Template Key
 */
export type TemplateKeyEnum =
  (typeof TemplateKeyEnum)[keyof typeof TemplateKeyEnum];

/**
 * Policy Type
 */
export const PolicyTypeEnum2 = {
  MONOLINE_PL_GL: 'Monoline (PL/GL)',
  PROFESSIONAL_LIABILITY_ONLY: 'Professional Liability Only',
  PACKAGE_PL_GL_PROPERTY: 'Package (PL/GL/Property)',
  PROPERTY_WITH_GL: 'Property with GL',
} as const;

/**
 * Policy Type
 */
export type PolicyTypeEnum2 =
  (typeof PolicyTypeEnum2)[keyof typeof PolicyTypeEnum2];

/**
 * First Named Insured Type
 */
export const FirstNamedInsuredTypeEnum = {
  PARTNERSHIP: 'Partnership',
  CORPORATION: 'CORPORATION',
  INDIVIDUAL: 'INDIVIDUAL',
  PC_PA: 'PC/PA',
  LLC: 'LLC',
  MULTI_INDIVIDUAL: 'MULTI INDIVIDUAL',
} as const;

/**
 * First Named Insured Type
 */
export type FirstNamedInsuredTypeEnum =
  (typeof FirstNamedInsuredTypeEnum)[keyof typeof FirstNamedInsuredTypeEnum];

/**
 * Epl Epli
 */
export const EplEpliEnum = {
  EPL_DEFENSE_COVERAGE_ONLY: 'EPL - Defense Coverage Only',
  'EPLI_DEFENSE &_INDEMNITY_ENHANCED_2019_FORM':
    'EPLI - Defense & Indemnity enhanced 2019 form',
  EPLI_ALL_SHARE_ONE_LIMIT: 'EPLI - All share one limit',
  NOT_APPLICABLE: 'Not Applicable',
  NA: 'NA',
} as const;

/**
 * Epl Epli
 */
export type EplEpliEnum = (typeof EplEpliEnum)[keyof typeof EplEpliEnum];

export const _0Enum2 = {
  25000: '25000',
  100000: '100000',
  101000: '101000',
  250000: '250000',
  500000: '500000',
  750000: '750000',
  1000000: '1000000',
} as const;

export type _0Enum2 = (typeof _0Enum2)[keyof typeof _0Enum2];

export const _0Enum3 = {
  NON_LARGE_GROUP: 'Non Large Group',
  LARGE_GROUP: 'Large Group',
  FACULTY: 'Faculty',
  VOLUNTEER: 'Volunteer',
  MOONLIGHTING: 'Moonlighting',
} as const;

export type _0Enum3 = (typeof _0Enum3)[keyof typeof _0Enum3];

export const _0Enum4 = {
  CLAIMS_MADE: 'Claims Made',
  OCCURRENCE: 'Occurrence',
} as const;

export type _0Enum4 = (typeof _0Enum4)[keyof typeof _0Enum4];

/**
 * Pt Ft
 */
export const PtFtEnum = {
  FULL_TIME: 'Full Time',
  PART_TIME: 'Part Time',
  MOONLIGHTING: 'Moonlighting',
} as const;

/**
 * Pt Ft
 */
export type PtFtEnum = (typeof PtFtEnum)[keyof typeof PtFtEnum];

/**
 * Deep Sedation
 */
export const DeepSedationEnum = {
  NO: 'No',
  'YES,_ADMIN_IN_OFFICE_BY_ANOTHER_DENTIST_ANESTHESIOLOGIST_CRNA_CLASS_1':
    'Yes, Admin. in Office by another Dentist/Anesthesiologist/CRNA (Class 1)',
  'YES,_ADMINISTERED_IN_A_HOSPITAL_CLASS_1':
    'Yes, Administered in a Hospital (Class 1)',
  'YES,_ADMINISTERED_IN_THE_OFFICE_BY_THE_NAMED_INSURED_CLASS_3':
    'Yes, Administered in the Office by the Named Insured (Class 3)',
} as const;

/**
 * Deep Sedation
 */
export type DeepSedationEnum =
  (typeof DeepSedationEnum)[keyof typeof DeepSedationEnum];

/**
 * Rm Duration
 */
export const RmDurationEnum = {
  '3_YEARS': '3 Years',
  '2_YEARS': '2 Years',
  '1_YEAR': '1 Year',
  N_A: 'N/A',
} as const;

/**
 * Rm Duration
 */
export type RmDurationEnum =
  (typeof RmDurationEnum)[keyof typeof RmDurationEnum];

/**
 * Rolling Debit
 */
export const RollingDebitEnum = {
  25: '25',
  20: '20',
  15: '15',
  10: '10',
  5: '5',
  0: '0',
} as const;

/**
 * Rolling Debit
 */
export type RollingDebitEnum =
  (typeof RollingDebitEnum)[keyof typeof RollingDebitEnum];

/**
 * Derived Num Years Since Last Claim
 */
export const DerivedNumYearsSinceLastClaimEnum = {
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  N_A: 'N/A',
} as const;

/**
 * Derived Num Years Since Last Claim
 */
export type DerivedNumYearsSinceLastClaimEnum =
  (typeof DerivedNumYearsSinceLastClaimEnum)[keyof typeof DerivedNumYearsSinceLastClaimEnum];

/**
 * Property Dedbl
 */
export const PropertyDedblEnum = {
  $500: '$500',
  '$1,000': '$1,000',
  '$2,500': '$2,500',
  '$5,000': '$5,000',
  '$10,000': '$10,000',
} as const;

/**
 * Property Dedbl
 */
export type PropertyDedblEnum =
  (typeof PropertyDedblEnum)[keyof typeof PropertyDedblEnum];

/**
 * Waiting Period
 */
export const WaitingPeriodEnum = {
  '0_HOURS_0_DAY': '0 hours (0 day)',
  '24_HOURS_1_DAY': '24 hours (1 day)',
  '48_HOURS_2_DAYS': '48 hours (2 days)',
  '72_HOURS_3_DAYS': '72 hours (3 days)',
  '96_HOURS_4_DAYS': '96 hours (4 days)',
} as const;

/**
 * Waiting Period
 */
export type WaitingPeriodEnum =
  (typeof WaitingPeriodEnum)[keyof typeof WaitingPeriodEnum];

/**
 * Wind Deductible
 */
export const WindDeductibleEnum = {
  N_A: 'N/A',
  '1%': '1%',
  '2%': '2%',
  '5%': '5%',
  1: '1',
  2: '2',
  5: '5',
} as const;

/**
 * Wind Deductible
 */
export type WindDeductibleEnum =
  (typeof WindDeductibleEnum)[keyof typeof WindDeductibleEnum];

/**
 * Construction Type
 */
export const ConstructionTypeEnum = {
  JOISTED_MASONRY: 'Joisted Masonry',
  FRAME: 'Frame',
  FIRE_RESISTIVE: 'Fire Resistive',
  MASONRY_NON_COMBUSTIBLE: 'Masonry Non-Combustible',
  NON_COMBUSTIBLE: 'Non-Combustible',
  MODIFIED_FIRE_RESISTIVE: 'Modified Fire Resistive',
} as const;

/**
 * Construction Type
 */
export type ConstructionTypeEnum =
  (typeof ConstructionTypeEnum)[keyof typeof ConstructionTypeEnum];

/**
 * Fire Alarm
 */
export const FireAlarmEnum = {
  CENTRAL: 'Central',
  LOCAL: 'Local',
  NONE: 'None',
} as const;

/**
 * Fire Alarm
 */
export type FireAlarmEnum = (typeof FireAlarmEnum)[keyof typeof FireAlarmEnum];

export const _0Enum5 = {
  '0_3': '0.3',
  '0_4': '0.4',
  '0_5': '0.5',
  '1_0': '1.0',
  '1_5': '1.5',
  '2_0': '2.0',
  '2_5': '2.5',
  '3_0': '3.0',
  '3_5': '3.5',
  '4_0': '4.0',
  '4_5': '4.5',
  '5_0': '5.0',
  N_A: 'N/A',
} as const;

export type _0Enum5 = (typeof _0Enum5)[keyof typeof _0Enum5];

export const _0Enum6 = {
  STANDARD: 'STANDARD',
  HIGHER: 'HIGHER',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
} as const;

export type _0Enum6 = (typeof _0Enum6)[keyof typeof _0Enum6];

export const _0Enum7 = { HIGHER: 'HIGHER', STANDARD: 'STANDARD' } as const;

export type _0Enum7 = (typeof _0Enum7)[keyof typeof _0Enum7];

export const _0Enum8 = {
  HIGHER: 'HIGHER',
  STANDARD: 'STANDARD',
  NONE: 'NONE',
} as const;

export type _0Enum8 = (typeof _0Enum8)[keyof typeof _0Enum8];

/**
 * Loss Assessment Coverage
 */
export const LossAssessmentCoverageEnum = {
  HIGHER: 'HIGHER',
  NO: 'No',
  1000: '1000',
  5000: '5000',
  10000: '10000',
  25000: '25000',
  50000: '50000',
  100000: '100000',
} as const;

/**
 * Loss Assessment Coverage
 */
export type LossAssessmentCoverageEnum =
  (typeof LossAssessmentCoverageEnum)[keyof typeof LossAssessmentCoverageEnum];

/**
 * Role
 */
export const RoleEnum = { USER: 'user', ASSISTANT: 'assistant' } as const;

/**
 * Role
 */
export type RoleEnum = (typeof RoleEnum)[keyof typeof RoleEnum];

/**
 * AdditionalInsured
 *
 * Additional Insured
 */
export type AdditionalInsuredWritable = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Pk
   */
  pk: string;
  /**
   * Entityname
   */
  entityName?: string | null;
  entityDba?: YesNoEnum | null;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
};

export type AllFormLevelsWritable =
  | PolicyFormLevels
  | LocationFormLevels
  | PracticeLocationFormLevels
  | DentistFormLevels
  | EntityFormLevels
  | CyberLiabilityFormLevels
  | GlAdditionalInsuredFormLevels
  | PlAdditionalInsuredFormLevels
  | MissionOfMercyEventFormLevels;

/**
 * CommercialProperty
 *
 * Schema with Fields required to rate Professional Liability
 */
export type CommercialPropertyWritable = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  /**
   * Locations
   */
  locations?: Array<LocationWritable>;
  coverage?: Coverage;
  coveragePart?: CoveragePart;
  veriskRawResponse?: VeriskBusinessOwnerResponse | null;
  corelogicRawResponse?: CoreLogicAllApiResponses | null;
};

/**
 * CyberLiability
 */
export type CyberLiabilityWritable = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  totalLimitOfInsurance?: LimitOfInsurance | null;
  /**
   * Numberofdentists
   */
  numberOfDentists?: number | null;
  /**
   * Retroactivedate
   */
  retroactiveDate?: string | null;
  deductible?: Deductible;
  /**
   * Sublimitofliability
   */
  sublimitOfLiability?: number;
  coverageBasis?: CoverageBasis;
  coveragePart?: CoveragePart;
};

/**
 * Dentist
 *
 * Generic Dentist
 */
export type DentistWritable = {
  /**
   * Pk
   */
  pk?: string;
  information?: DentistInformationWritable;
  additionalPricing?: DentistAdditionalPricing;
  procedures?: DentistProcedures;
  underwritingQuestions?: DentistUnderwritingQuestions;
  /**
   * Ratedprice
   */
  ratedPrice?: number | null;
  /**
   * Finalratedclassification
   */
  finalRatedClassification?: string | null;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
  /**
   * Premiums
   */
  premiums?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  /**
   * Taxes
   */
  taxes?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  /**
   * Premiumdetail
   */
  premiumDetail?: {
    [key: string]: unknown;
  };
  /**
   * Erpquotesnapshot
   */
  erpQuoteSnapshot?: {
    [key: string]: unknown;
  } | null;
};

/**
 * DentistInformation
 */
export type DentistInformationWritable = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Dentistid
   */
  dentistId: string;
  /**
   * Firstname
   */
  firstName?: string;
  /**
   * Middlename
   */
  middleName?: string | null;
  /**
   * Lastname
   */
  lastName?: string;
  /**
   * Professionaldesignation
   */
  professionalDesignation?: Array<ItemsEnum>;
  numHoursPerWeek?: WeeklyPracticeHours | null;
  moonlightingReason?: MoonlightingReason | null;
  /**
   * Moonlightingreasondescription
   */
  moonlightingReasonDescription?: string | null;
  /**
   * Projectedresidencycompletiondate
   */
  projectedResidencyCompletionDate?: string | null;
  practiceSpecialty?: PracticeSpecialty | null;
  /**
   * Primarypracticelocation
   */
  primaryPracticeLocation?: string | null;
  yearsInPractice?: YearsPracticing | null;
  /**
   * Yearswithaspen
   */
  yearsWithAspen?: number | null;
  boardCertified?: YesNoEnum | null;
  /**
   * Dateofbirth
   */
  dateOfBirth?: string | null;
  /**
   * Datepcfpremiumreceived
   */
  datePcfPremiumReceived?: string | null;
  differentLimitDesired?: YesNoEnum | null;
  /**
   * Emailaddress
   */
  emailAddress?: string | null;
  /**
   * Inpcfcertificatenumber
   */
  inPcfCertificateNumber?: string | null;
  inPcfFundParticipation?: InpcfParticipation | null;
  /**
   * Inpcfproviderid
   */
  inPcfProviderId?: string | null;
  /**
   * Inpcfsurchargeamount
   */
  inPcfSurchargeAmount?: number | null;
  laPcfFundParticipation?: YesNoEnum | null;
  leaveOfAbsence?: LeaveOfAbsence | null;
  /**
   * Loastartdate
   */
  loaStartDate?: string | null;
  /**
   * Loasetontransactionnumber
   */
  loaSetOnTransactionNumber?: number | null;
  /**
   * Loanumberofdays
   */
  loaNumberOfDays?: number | null;
  memberOfSda?: YesNoEnum | null;
  /**
   * Nameofdentalschool
   */
  nameOfDentalSchool?: string | null;
  yearMonthGraduation?: YearMonth | null;
  firstTimePractice?: YesNoEnum | null;
  newDentistType?: NewDentistType | null;
  noseCoverage?: YesNoEnum | null;
  noseCoverageLiabilityLimits?: LimitsEnum | null;
  /**
   * Nosecoverageprioractsdate
   */
  noseCoveragePriorActsDate?: string | null;
  numYearsDuration?: DurationYears | null;
  optinForRiskNewsletter?: YesNoEnum | null;
  practiceProfile?: PracticeProfile | null;
  /**
   * Prioractsdate
   */
  priorActsDate?: string | null;
  professionalLiabilityLimit?: LimitsEnum | null;
  renumeration?: YesNoEnum | null;
  residencyCompleted?: YesNoEnum | null;
  riskManagementSeminar?: YesNoEnum | null;
  /**
   * Secondarypracticelocations
   */
  secondaryPracticeLocations?: Array<string>;
  /**
   * Volunteerservices
   */
  volunteerServices?: string | null;
  workScheduleAvailable?: YesNoEnum | null;
  /**
   * Yearofattendance
   */
  yearOfAttendance?: number | null;
  yearsWithoutClaim?: YearsNoClaims | null;
  reviewRequired?: YesNoEnum | null;
  agreedRepresentationsAndFraud?: YesNoEnum | null;
  /**
   * Signature
   */
  signature?: string | null;
  /**
   * Signaturedate
   */
  signatureDate?: string | null;
  truthmd?: TruthMdData | null;
};

/**
 * ERISAAndEmployeeBenefits
 */
export type ErisaAndEmployeeBenefitsWritable = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  limitOfInsurance?: ErisaLimitOfInsurance | null;
  /**
   * Prioractsdate
   */
  priorActsDate?: string | null;
  /**
   * Totalemployees
   */
  totalEmployees?: number | null;
  anyLosses?: YesNoEnum | null;
  coveragePart?: CoveragePart;
};

/**
 * EmploymentPracticesLiability
 */
export type EmploymentPracticesLiabilityWritable = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  epliCoverageType?: EpliCoverageType | null;
  /**
   * Dentistsschedule
   */
  dentistsSchedule?: Array<DentistSchedule>;
  /**
   * Entitiesschedule
   */
  entitiesSchedule?: Array<EntitySchedule>;
  /**
   * Epliprioractsdate
   */
  epliPriorActsDate?: string | null;
  /**
   * Numnondentistemployees
   */
  numNonDentistEmployees?: number | null;
  /**
   * Numindependentdentists
   */
  numIndependentDentists?: number | null;
  /**
   * Numemployeedentists
   */
  numEmployeeDentists?: number | null;
  /**
   * Numindependenthygienists
   */
  numIndependentHygienists?: number | null;
  limitOfInsurance?: LimitOfInsurance | null;
  deductible?: Deductible | null;
  sublimitedCoverageDesired?: YesNoEnum | null;
  /**
   * Negativeevents
   */
  negativeEvents?: Array<GlacierPolicyDomainTypeDictsNegativeEvent> | null;
  /**
   * Negativeeventsexplanation
   */
  negativeEventsExplanation?: string | null;
  /**
   * Natureofoperations
   */
  natureOfOperations?: number | null;
  /**
   * Natureofworkforce
   */
  natureOfWorkforce?: number | null;
  /**
   * Salaries
   */
  salaries?: number | null;
  /**
   * Writtenprocedures
   */
  writtenProcedures?: number | null;
  /**
   * Electroniccommunicationpolicies
   */
  electronicCommunicationPolicies?: number | null;
  /**
   * Experienceratingvalue
   */
  experienceRatingValue?: number | null;
  coveragePart?: CoveragePart;
};

/**
 * FileDocument
 */
export type FileDocumentWritable = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Name
   */
  name: string;
  createdBy: UserObject | null;
  replacedBy?: UserObject | null;
  /**
   * Createdat
   */
  createdAt: string;
  /**
   * Lastreplacedat
   */
  lastReplacedAt?: string | null;
  /**
   * Createdattransaction
   */
  createdAtTransaction: number;
  documentType: AttachedDocumentType;
  /**
   * Systemgenerated
   */
  systemGenerated: boolean;
  /**
   * Originalsequencenumber
   */
  originalSequenceNumber: number;
  /**
   * Description
   */
  description?: string;
  /**
   * Subcategory
   */
  subcategory?: string;
  /**
   * Filehistory
   */
  fileHistory?: Array<FileDocumentHistory>;
};

/**
 * GeneralLiability
 */
export type GeneralLiabilityWritable = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  limitOfInsurance?: LimitsEnum | null;
  separateAggregate?: YesNoEnum | null;
  hiredAutoDamage?: YesNoEnum | null;
  fireWaterLegalLimit?: FireWaterLimit | null;
  losses?: YesNoEnum | null;
  /**
   * Locationidsglnotcharged
   */
  locationIdsGlNotCharged?: Array<string>;
  stopGapCoverageDesired?: YesNoEnum | null;
  stopGapLimit?: StopGapLimit | null;
  /**
   * Additionalinsured
   */
  additionalInsured?: Array<GeneralLiabilityAdditionalInsuredWritable>;
  /**
   * Flatpremiumadjustment
   */
  flatPremiumAdjustment?: number | null;
  coveragePart?: CoveragePart;
};

/**
 * GeneralLiabilityAdditionalInsured
 */
export type GeneralLiabilityAdditionalInsuredWritable = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Pk
   */
  pk: string;
  /**
   * Fallbackpk
   */
  fallbackPk?: string | null;
  typeOfContract?: TypeOfContract | null;
  /**
   * Entityname
   */
  entityName?: string | null;
  entityAddress?: UsAddress | null;
  /**
   * Newentityaddress
   */
  newEntityAddress?: string | null;
  /**
   * Insuredlocation
   */
  insuredLocation?: string | null;
  /**
   * Description
   */
  description?: string | null;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
};

/**
 * Location
 */
export type LocationWritable = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Pk
   */
  pk?: string;
  information?: Information;
  rating?: Rating;
  /**
   * Ratedprice
   */
  ratedPrice?: number;
  /**
   * Premiumdetail
   */
  premiumDetail?: {
    [key: string]: unknown;
  };
};

/**
 * MissionOfMercyEvent
 *
 * Mission of Mercy
 */
export type MissionOfMercyEventWritable = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Eventbeginningdate
   */
  eventBeginningDate?: string | null;
  /**
   * Eventenddate
   */
  eventEndDate?: string | null;
  /**
   * Eventname
   */
  eventName?: string | null;
  eventType?: MissionOfMercyEventType | null;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
};

/**
 * OwnedEntity
 */
export type OwnedEntityWritable = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Pk
   */
  pk?: string;
  details?: Details;
  questions?: Questions;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
  /**
   * Premiums
   */
  premiums?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  /**
   * Taxes
   */
  taxes?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  /**
   * Premiumdetail
   */
  premiumDetail?: {
    [key: string]: unknown;
  };
};

/**
 * Policy
 */
export type PolicyWritable = {
  /**
   * Pk
   */
  pk?: string;
  /**
   * Policynumber
   */
  policyNumber?: string;
  /**
   * Boundpolicynumber
   */
  boundPolicyNumber?: string;
  /**
   * Sequencenumber
   */
  sequenceNumber?: number;
  /**
   * Isissued
   */
  isIssued?: boolean;
  /**
   * Bypassvalidators
   */
  bypassValidators?: boolean;
  producer?: UserObject | null;
  underwriter?: UserObject | null;
  assignedTo?: UserObject | null;
  referredBy?: UserObject | null;
  /**
   * Transactions
   */
  transactions?: Array<Transaction>;
  /**
   * Documentwarehouse
   */
  documentWarehouse?: Array<FileDocumentWritable>;
  /**
   * Additionalmessage
   */
  additionalMessage?: string;
  /**
   * Parentpolicyid
   */
  parentPolicyId?: string | null;
  /**
   * Parentsequencenumber
   */
  parentSequenceNumber?: number | null;
  /**
   * Policyholderid
   */
  policyholderId?: string | null;
  /**
   * Baselineexpirationdate
   */
  baselineExpirationDate?: string | null;
  renewalFlag?: RenewalFlagEnum | null;
  /**
   * Reasonfornonrenewal
   */
  reasonForNonRenewal?: string | null;
  policyStatus?: PolicyStatus;
  /**
   * Deletedat
   */
  deletedAt?: string | null;
  deletedBy?: UserObject | null;
  /**
   * Deletionreason
   */
  deletionReason?: string | null;
};

/**
 * PolicyDetails
 *
 * Aggregate detail state; these defaults seed a new policy, not later writes.
 */
export type PolicyDetailsWritable = {
  writingCompany?: WritingCompanyEnum | null;
  /**
   * Writingcompanyid
   */
  writingCompanyId?: string | null;
  /**
   * Writingcompanyname
   */
  writingCompanyName?: string | null;
  /**
   * Agency
   */
  agency?: string | null;
  /**
   * Associationcode
   */
  associationCode?: string | null;
  /**
   * Producer
   */
  producer?: string | null;
  /**
   * Producername
   */
  producerName?: string | null;
  policyType?: PolicyTypeEnum | null;
  /**
   * Rolloverexpiringpolicynumber
   */
  rolloverExpiringPolicyNumber?: string | null;
  /**
   * Rolloverexpiringpolicypremium
   */
  rolloverExpiringPolicyPremium?: number | null;
  /**
   * Prioraspenpolicynumber
   */
  priorAspenPolicyNumber?: string | null;
  quoteType?: QuoteTypeEnum | null;
  /**
   * Policyeffectivedate
   */
  policyEffectiveDate?: string | null;
  /**
   * Policyexpirationdate
   */
  policyExpirationDate?: string | null;
  /**
   * Policycancellationdate
   */
  policyCancellationDate?: string | null;
  /**
   * Insurancelinesdesired
   */
  insuranceLinesDesired?: Array<InsuranceLinesEnum>;
  plSubType?: PlSubTypeEnum | null;
  scheduleOnFile?: YesNoEnum | null;
  scheduleFile?: ScheduleFile | null;
  firstNamedInsuredType?: FirstNamedInsuredType | null;
  /**
   * Ownedentityid
   */
  ownedEntityId?: string | null;
  /**
   * Otherentitytype
   */
  otherEntityType?: string | null;
  /**
   * Entityname
   */
  entityName?: string | null;
  /**
   * Firstname
   */
  firstName?: string | null;
  /**
   * Middlename
   */
  middleName?: string | null;
  /**
   * Lastname
   */
  lastName?: string | null;
  /**
   * Professionaldesignation
   */
  professionalDesignation?: Array<ItemsEnum>;
  /**
   * Firstnamedinsureddentistid
   */
  firstNamedInsuredDentistId?: string | null;
  policyContractState?: UsStateEnum | null;
  mailingAddress?: UsAddress | null;
  billingAddress?: UsAddress | null;
  /**
   * Officephonenumber
   */
  officePhoneNumber?: string | null;
  /**
   * Cellphonenumber
   */
  cellPhoneNumber?: string | null;
  /**
   * Billingcontactfirstname
   */
  billingContactFirstName?: string | null;
  /**
   * Billingcontactlastname
   */
  billingContactLastName?: string | null;
  /**
   * Billingcontactemail
   */
  billingContactEmail?: string | null;
  /**
   * Billingcontactphone
   */
  billingContactPhone?: string | null;
  /**
   * Emailaddress
   */
  emailAddress?: string | null;
  /**
   * Practicewebsite
   */
  practiceWebsite?: string | null;
  electronicDeliveryAcceptance?: YesNoEnum | null;
  /**
   * Minimumearnedpremium
   */
  minimumEarnedPremium?: _0Enum | null;
  paymentPlan?: PolicyPaymentPlanEnum | null;
  /**
   * Brokercommissionoverride
   */
  brokerCommissionOverride?: number | null;
  overridePdf?: YesNoEnum | null;
  /**
   * Agencypk
   */
  agencyPk?: number | null;
  /**
   * Producerpk
   */
  producerPk?: number | null;
  initialTransactionSource?: SourceSystemEnum | null;
  /**
   * Lastquotedat
   */
  lastQuotedAt?: string | null;
  /**
   * Applyoverridetopremium
   */
  applyOverrideToPremium?: boolean;
  applyAsicMinimumPremium?: YesNoEnum | null;
};

/**
 * PracticeLocation
 */
export type PracticeLocationWritable = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Pk
   */
  pk: string;
  address: UsAddress | null;
  /**
   * Sequencenumber
   */
  sequenceNumber: number;
  /**
   * Latitude
   */
  latitude?: number | null;
  /**
   * Longitude
   */
  longitude?: number | null;
  /**
   * Primary
   */
  primary?: boolean;
  /**
   * Attachedforms
   */
  attachedForms?: Array<AttachedForm>;
  /**
   * Premiums
   */
  premiums?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  /**
   * Taxes
   */
  taxes?: {
    [key in InsuranceLinesEnum]?: CoverageAmount;
  };
  blackBagCoverage?: BlackBagCoverage | null;
  /**
   * Googleplaceid
   */
  googlePlaceId?: string | null;
};

/**
 * PracticeOwner
 */
export type PracticeOwnerWritable = {
  firstNameInsuredIsOwner?: YesNoEnum | null;
  insuredIsFirstTimePracticeOwner?: YesNoEnum | null;
  contractsWithProviders?: YesNoEnum | null;
  employeeDentistsInsured?: YesNoEnum | null;
  /**
   * Employees
   */
  employees?: Array<Employee>;
  employsDentists?: YesNoEnum | null;
  /**
   * Feebasedrevenue
   */
  feeBasedRevenue?: number | null;
  holdHarmlessClause?: HoldHarmlessClause | null;
  /**
   * Medicaid
   */
  medicaid?: number | null;
  /**
   * Medicare
   */
  medicare?: number | null;
  operateDentalLab?: YesNoEnum | null;
  outsideReferralsAccepted?: YesNoEnum | null;
  /**
   * Ownerdentists
   */
  ownerDentists?: Array<OwnerDentistNotInsured>;
  ownerDentistsInsured?: YesNoEnum | null;
  /**
   * Privateinsurance
   */
  privateInsurance?: number | null;
  proofOfInsurance?: YesNoEnum | null;
  radiologyServices?: YesNoEnum | null;
  /**
   * Servicesrenderedweekly
   */
  servicesRenderedWeekly?: number | null;
  writtenContracts?: YesNoEnum | null;
  /**
   * Authorizeddentist
   */
  authorizedDentist?: string | null;
  onFileProofOfInsurance?: YesNoEnum | null;
};

/**
 * ProfessionalLiability
 *
 * Schema with Fields required to rate Professional Liability
 */
export type ProfessionalLiabilityWritable = {
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  insuranceLineKey?: InsuranceLinesEnum | null;
  coverage?: ProfessionalLiabilityCoverageSectionWritable;
  practiceOwners?: PracticeOwnerWritable;
  coveragePart?: CoveragePart;
  /**
   * Plwasremovedontransactionid
   */
  plWasRemovedOnTransactionId?: number | null;
};

/**
 * ProfessionalLiabilityCoverageSection
 *
 * Represents the Coverage Section
 */
export type ProfessionalLiabilityCoverageSectionWritable = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  consentType?: ConsentType | null;
  coverageBasis?: CoverageBasis | null;
  /**
   * Entityname
   */
  entityName?: string | null;
  entityType?: EntityType | null;
  limitsDesired?: LimitsEnum | null;
  missionOfMercyApplies?: YesNoEnum | null;
  civilRegulatoryProceed?: YesNoEnum | null;
  /**
   * Componentsocieties
   */
  componentSocieties?: Array<ComponentSociety>;
  componentSocietiesNeedScheduling?: YesNoEnum | null;
  defenseDeductibleDesired?: DefenseDeductibleDesired | null;
  /**
   * Entityprioracts
   */
  entityPriorActs?: string | null;
  /**
   * Largegroupexposuremodification
   */
  largeGroupExposureModification?: number | null;
  /**
   * Largegroupexposuremodificationexplanation
   */
  largeGroupExposureModificationExplanation?: string | null;
  /**
   * Largegroupproceduremix
   */
  largeGroupProcedureMix?: number | null;
  /**
   * Largegroupproceduremixexplanation
   */
  largeGroupProcedureMixExplanation?: string | null;
  /**
   * Largegroupunusualrisk
   */
  largeGroupUnusualRisk?: number | null;
  /**
   * Largegroupunusualriskexplanation
   */
  largeGroupUnusualRiskExplanation?: string | null;
  entitySharedLimitsType?: EntitySharedLimitsType | null;
  /**
   * Nummissionmercyall
   */
  numMissionMercyAll?: number | null;
  /**
   * Nummissionmercyhygienists
   */
  numMissionMercyHygienists?: number | null;
  /**
   * Missionofmercyevents
   */
  missionOfMercyEvents?: Array<MissionOfMercyEventWritable>;
  /**
   * Numconventions
   */
  numConventions?: number | null;
  /**
   * Numtestingboardexaminers
   */
  numTestingBoardExaminers?: number | null;
  optinIncreaseLimitsMatchCap?: YesNoEnum | null;
  /**
   * Policyflatadjustment
   */
  policyFlatAdjustment?: number | null;
  /**
   * Additionalinsured
   */
  additionalInsured?: Array<AdditionalInsuredWritable>;
  /**
   * Carriercommissionoverride
   */
  carrierCommissionOverride?: number | null;
  /**
   * Brokercommissionoverride
   */
  brokerCommissionOverride?: number | null;
  /**
   * Blackbagcoverage
   */
  blackBagCoverage?: Array<BlackBagCoverageDict>;
};

/**
 * FastPolicy
 */
export type FastPolicyWritable = {
  /**
   * Pk
   */
  pk?: string;
  /**
   * Policynumber
   */
  policyNumber?: string;
  /**
   * Boundpolicynumber
   */
  boundPolicyNumber?: string;
  /**
   * Sequencenumber
   */
  sequenceNumber?: number;
  /**
   * Isissued
   */
  isIssued?: boolean;
  /**
   * Bypassvalidators
   */
  bypassValidators?: boolean;
  producer?: UserObject | null;
  underwriter?: UserObject | null;
  assignedTo?: UserObject | null;
  referredBy?: UserObject | null;
  /**
   * Transactions
   */
  transactions?: Array<Transaction>;
  /**
   * Documentwarehouse
   */
  documentWarehouse?: Array<FileDocumentWritable>;
  /**
   * Additionalmessage
   */
  additionalMessage?: string;
  /**
   * Parentpolicyid
   */
  parentPolicyId?: string | null;
  /**
   * Parentsequencenumber
   */
  parentSequenceNumber?: number | null;
  /**
   * Policyholderid
   */
  policyholderId?: string | null;
  /**
   * Baselineexpirationdate
   */
  baselineExpirationDate?: string | null;
  renewalFlag?: RenewalFlagEnum | null;
  /**
   * Reasonfornonrenewal
   */
  reasonForNonRenewal?: string | null;
  policyStatus?: PolicyStatus;
  /**
   * Deletedat
   */
  deletedAt?: string | null;
  deletedBy?: UserObject | null;
  /**
   * Deletionreason
   */
  deletionReason?: string | null;
};

/**
 * DentistSummary
 */
export type DentistSummaryWritable = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Name
   */
  name?: string;
};

/**
 * OwnedEntitySummary
 */
export type OwnedEntitySummaryWritable = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  /**
   * Entityname
   */
  entityName?: string | null;
};

/**
 * PolicyWithSummaries
 */
export type PolicyWithSummariesWritable = {
  /**
   * Pk
   */
  pk: string;
  details: PolicyDetailsWritable;
  professionalLiability?: ProfessionalLiabilityWritable;
  /**
   * Locations
   */
  locations?: Array<PracticeLocationSummaryWritable>;
  /**
   * Dentistssummary
   */
  dentistsSummary?: Array<DentistSummaryWritable>;
  /**
   * Ownedentitiessummary
   */
  ownedEntitiesSummary?: Array<OwnedEntitySummaryWritable>;
};

/**
 * PracticeLocationSummary
 */
export type PracticeLocationSummaryWritable = {
  /**
   * Pk
   */
  pk: string;
  /**
   * Effectivedate
   */
  effectiveDate?: string | null;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Createdontransactionnumber
   */
  createdOnTransactionNumber?: number | null;
  /**
   * Deletedontransactionnumber
   */
  deletedOnTransactionNumber?: number | null;
  /**
   * Isexpired
   */
  isExpired?: boolean;
  address?: UsAddress | null;
  /**
   * Primary
   */
  primary?: boolean;
  blackBagCoverage?: BlackBagCoverage | null;
};

/**
 * ProfessionalLiabilityCoverageSectionRequestDict
 */
export type ProfessionalLiabilityCoverageSectionRequestDictWritable = {
  consentType?: ConsentType | null;
  coverageBasis?: CoverageBasis | null;
  /**
   * Entityname
   */
  entityName?: string | null;
  entityType?: EntityType | null;
  limitsDesired?: LimitsEnum | null;
  missionOfMercyApplies?: YesNoEnum | null;
  civilRegulatoryProceed?: YesNoEnum | null;
  /**
   * Componentsocieties
   */
  componentSocieties?: Array<ComponentSociety>;
  componentSocietiesNeedScheduling?: YesNoEnum | null;
  defenseDeductibleDesired?: DefenseDeductibleDesired | null;
  /**
   * Entityprioracts
   */
  entityPriorActs?: string | null;
  /**
   * Largegroupexposuremodification
   */
  largeGroupExposureModification?: number | null;
  /**
   * Largegroupexposuremodificationexplanation
   */
  largeGroupExposureModificationExplanation?: string | null;
  /**
   * Largegroupproceduremix
   */
  largeGroupProcedureMix?: number | null;
  /**
   * Largegroupproceduremixexplanation
   */
  largeGroupProcedureMixExplanation?: string | null;
  /**
   * Largegroupunusualrisk
   */
  largeGroupUnusualRisk?: number | null;
  /**
   * Largegroupunusualriskexplanation
   */
  largeGroupUnusualRiskExplanation?: string | null;
  entitySharedLimitsType?: EntitySharedLimitsType | null;
  /**
   * Nummissionmercyall
   */
  numMissionMercyAll?: number | null;
  /**
   * Nummissionmercyhygienists
   */
  numMissionMercyHygienists?: number | null;
  /**
   * Missionofmercyevents
   */
  missionOfMercyEvents?: Array<MissionOfMercyEventWritable>;
  /**
   * Numconventions
   */
  numConventions?: number | null;
  /**
   * Numtestingboardexaminers
   */
  numTestingBoardExaminers?: number | null;
  optinIncreaseLimitsMatchCap?: YesNoEnum | null;
  /**
   * Policyflatadjustment
   */
  policyFlatAdjustment?: number | null;
  /**
   * Additionalinsured
   */
  additionalInsured?: Array<AdditionalInsuredWritable>;
  /**
   * Blackbagcoverage
   */
  blackBagCoverage?: Array<BlackBagCoverageDict>;
};

/**
 * ProfessionalLiabilityCoverageSectionRequestSchema
 */
export type ProfessionalLiabilityCoverageSectionRequestSchemaWritable = {
  answers: ProfessionalLiabilityCoverageSectionRequestDictWritable;
};

/**
 * FileDocumentSchema
 */
export type FileDocumentSchemaWritable = {
  /**
   * Transactionnumber
   */
  transactionNumber: number;
  status: TransactionStatus;
  /**
   * Effectivedate
   */
  effectiveDate: string | null;
  /**
   * Documentwarehouse
   */
  documentWarehouse: Array<FileDocumentWritable>;
};

/**
 * ErpRow
 */
export type ErpRowWritable = {
  /**
   * Erpenabled
   */
  erpEnabled?: boolean;
  /**
   * Erpeffectivedate
   */
  erpEffectiveDate?: string | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  /**
   * Civilregulatoryerpenabled
   */
  civilRegulatoryErpEnabled?: boolean | null;
  /**
   * Erpflatadjustment
   */
  erpFlatAdjustment?: number | null;
  /**
   * Civilregulatoryerpflatadjustment
   */
  civilRegulatoryErpFlatAdjustment?: number | null;
  /**
   * Pk
   */
  pk: string;
  /**
   * Entitytype
   */
  entityType: ErpEntityKind | string;
  /**
   * Name
   */
  name: string;
  /**
   * Effectivedate
   */
  effectiveDate: string;
  /**
   * Expirationdate
   */
  expirationDate?: string | null;
  /**
   * Erpestimateprice
   */
  erpEstimatePrice?: number | null;
  /**
   * Erpquoteissuedat
   */
  erpQuoteIssuedAt?: string | null;
  /**
   * Erpestimateasof
   */
  erpEstimateAsOf?: string | null;
};

/**
 * ErpSection
 */
export type ErpSectionWritable = {
  key: ErpSectionKind;
  /**
   * Entitytype
   */
  entityType: ErpEntityKind | string;
  /**
   * Hascivilregulatoryerp
   */
  hasCivilRegulatoryErp: boolean;
  /**
   * Erptypeoptions
   */
  erpTypeOptions: Array<SelectOption>;
  /**
   * Erpdurationoptions
   */
  erpDurationOptions: Array<SelectOption>;
  /**
   * Rows
   */
  rows: Array<ErpRowWritable>;
};

/**
 * ErpSaveResponse
 *
 * The updated ERP sections and rating warnings returned after saving.
 */
export type ErpSaveResponseWritable = {
  /**
   * Sections
   */
  sections: Array<ErpSectionWritable>;
  /**
   * Warnings
   */
  warnings?: Array<ErpWarning>;
};

export type GlacierUsersApiListUsersData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/users/';
};

export type GlacierUsersApiListUsersResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<UserSchema>;
};

export type GlacierUsersApiListUsersResponse =
  GlacierUsersApiListUsersResponses[keyof GlacierUsersApiListUsersResponses];

export type GlacierUsersApiCurrentUserData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/users/current_user';
};

export type GlacierUsersApiCurrentUserResponses = {
  /**
   * OK
   */
  200: CurrentUserSchema;
};

export type GlacierUsersApiCurrentUserResponse =
  GlacierUsersApiCurrentUserResponses[keyof GlacierUsersApiCurrentUserResponses];

export type GlacierUsersApiRelatedUsersData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/users/related_users';
};

export type GlacierUsersApiRelatedUsersResponses = {
  /**
   * OK
   */
  200: RelatedAgentsSchema;
};

export type GlacierUsersApiRelatedUsersResponse =
  GlacierUsersApiRelatedUsersResponses[keyof GlacierUsersApiRelatedUsersResponses];

export type GlacierUsersApiUnderwritersData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/users/underwriters';
};

export type GlacierUsersApiUnderwritersResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<UserSchema>;
};

export type GlacierUsersApiUnderwritersResponse =
  GlacierUsersApiUnderwritersResponses[keyof GlacierUsersApiUnderwritersResponses];

export type GlacierUsersApiForgotPasswordEndpointData = {
  body: ForgotPasswordSchema;
  path?: never;
  query?: never;
  url: '/api/v1/users/forgot-password/';
};

export type GlacierUsersApiForgotPasswordEndpointResponses = {
  /**
   * OK
   */
  200: ResetPasswordResponse;
};

export type GlacierUsersApiForgotPasswordEndpointResponse =
  GlacierUsersApiForgotPasswordEndpointResponses[keyof GlacierUsersApiForgotPasswordEndpointResponses];

export type GlacierUsersApiResetPasswordEndpointData = {
  body: ResetPasswordSchema;
  path?: never;
  query?: never;
  url: '/api/v1/users/reset-password/';
};

export type GlacierUsersApiResetPasswordEndpointResponses = {
  /**
   * OK
   */
  200: ResetPasswordResponse;
};

export type GlacierUsersApiResetPasswordEndpointResponse =
  GlacierUsersApiResetPasswordEndpointResponses[keyof GlacierUsersApiResetPasswordEndpointResponses];

export type GlacierUsersFeatureFlagsApiGetFeatureFlagsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/feature-flags/';
};

export type GlacierUsersFeatureFlagsApiGetFeatureFlagsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: {
    [key: string]: boolean;
  };
};

export type GlacierUsersFeatureFlagsApiGetFeatureFlagsResponse =
  GlacierUsersFeatureFlagsApiGetFeatureFlagsResponses[keyof GlacierUsersFeatureFlagsApiGetFeatureFlagsResponses];

export type GlacierPolicyApiListPoliciesData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/policy/';
};

export type GlacierPolicyApiListPoliciesResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<Policy>;
};

export type GlacierPolicyApiListPoliciesResponse =
  GlacierPolicyApiListPoliciesResponses[keyof GlacierPolicyApiListPoliciesResponses];

export type GlacierPolicyApiCreatePolicyData = {
  body: CreatePolicyRequest;
  path?: never;
  query?: never;
  url: '/api/v1/policy/';
};

export type GlacierPolicyApiCreatePolicyResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiCreatePolicyResponse =
  GlacierPolicyApiCreatePolicyResponses[keyof GlacierPolicyApiCreatePolicyResponses];

export type GlacierPolicyApiGetPolicySummaryData = {
  body?: never;
  path?: never;
  query?: {
    policy_type?: PolicyTypeEnum | null;
    /**
     * Has Alerts
     */
    has_alerts?: boolean | null;
    /**
     * Assigned To
     */
    assigned_to?: number | null;
    /**
     * Referred By
     */
    referred_by?: number | null;
  };
  url: '/api/v1/policy/summaries/';
};

export type GlacierPolicyApiGetPolicySummaryResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<PolicySummaryData>;
};

export type GlacierPolicyApiGetPolicySummaryResponse =
  GlacierPolicyApiGetPolicySummaryResponses[keyof GlacierPolicyApiGetPolicySummaryResponses];

export type GlacierPolicyApiGetPolicySummarySearchData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Q
     */
    q: string;
  };
  url: '/api/v1/policy/summaries/search/';
};

export type GlacierPolicyApiGetPolicySummarySearchResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<PolicySummaryData>;
};

export type GlacierPolicyApiGetPolicySummarySearchResponse =
  GlacierPolicyApiGetPolicySummarySearchResponses[keyof GlacierPolicyApiGetPolicySummarySearchResponses];

export type GlacierPolicyApiDeletePrintQueueData = {
  /**
   * Print Queue Id
   */
  body: Array<string>;
  path?: never;
  query?: never;
  url: '/api/v1/policy/print_queue/';
};

export type GlacierPolicyApiDeletePrintQueueResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiGetPrintQueueData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Downloaded
     */
    downloaded?: boolean | null;
  };
  url: '/api/v1/policy/print_queue/';
};

export type GlacierPolicyApiGetPrintQueueResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<PolicyPrintQueueList>;
};

export type GlacierPolicyApiGetPrintQueueResponse =
  GlacierPolicyApiGetPrintQueueResponses[keyof GlacierPolicyApiGetPrintQueueResponses];

export type GlacierPolicyApiPrintQueueData = {
  body: AccountsToPrintRequest;
  path?: never;
  query?: never;
  url: '/api/v1/policy/print_queue/';
};

export type GlacierPolicyApiPrintQueueResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiPrintQueueResponse =
  GlacierPolicyApiPrintQueueResponses[keyof GlacierPolicyApiPrintQueueResponses];

export type GlacierPolicyApiGetPolicyData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: {
    /**
     * Version
     */
    version?: number | null;
  };
  url: '/api/v1/policy/{account_id}/';
};

export type GlacierPolicyApiGetPolicyResponses = {
  /**
   * OK
   */
  200: FastPolicy;
};

export type GlacierPolicyApiGetPolicyResponse =
  GlacierPolicyApiGetPolicyResponses[keyof GlacierPolicyApiGetPolicyResponses];

export type GlacierPolicyApiGetPolicyAlertsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/alerts/';
};

export type GlacierPolicyApiGetPolicyAlertsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<PolicyAlertWithIdSchema>;
};

export type GlacierPolicyApiGetPolicyAlertsResponse =
  GlacierPolicyApiGetPolicyAlertsResponses[keyof GlacierPolicyApiGetPolicyAlertsResponses];

export type GlacierPolicyApiAcknowledgePolicyAlertData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Alert Id
     */
    alert_id: number;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/alerts/{alert_id}/acknowledge/';
};

export type GlacierPolicyApiAcknowledgePolicyAlertResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiGetLatestTransactionSummaryData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: {
    /**
     * Version
     */
    version?: number | null;
  };
  url: '/api/v1/policy/{account_id}/latest_transaction/summary';
};

export type GlacierPolicyApiGetLatestTransactionSummaryResponses = {
  /**
   * OK
   */
  200: TransactionSummaryData;
};

export type GlacierPolicyApiGetLatestTransactionSummaryResponse =
  GlacierPolicyApiGetLatestTransactionSummaryResponses[keyof GlacierPolicyApiGetLatestTransactionSummaryResponses];

export type GlacierPolicyApiGetLatestTransactionLatestAttemptData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/latest_transaction/latest_attempt';
};

export type GlacierPolicyApiGetLatestTransactionLatestAttemptResponses = {
  /**
   * OK
   */
  200: LastRateAttempt | null;
};

export type GlacierPolicyApiGetLatestTransactionLatestAttemptResponse =
  GlacierPolicyApiGetLatestTransactionLatestAttemptResponses[keyof GlacierPolicyApiGetLatestTransactionLatestAttemptResponses];

export type GlacierPolicyApiAssignAgentData = {
  body: UserId;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/assign_agent/';
};

export type GlacierPolicyApiAssignAgentResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiAssignUnderwriterData = {
  body: UserId;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/assign_underwriter/';
};

export type GlacierPolicyApiAssignUnderwriterResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiAssignData = {
  body: UserId;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/assign/';
};

export type GlacierPolicyApiAssignResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiAssignableData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/assignable/';
};

export type GlacierPolicyApiAssignableResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<UserSchema2>;
};

export type GlacierPolicyApiAssignableResponse =
  GlacierPolicyApiAssignableResponses[keyof GlacierPolicyApiAssignableResponses];

export type GlacierPolicyApiGetPolicyWithSummariesData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: {
    /**
     * Version
     */
    version?: number | null;
  };
  url: '/api/v1/policy/{account_id}/summaries/';
};

export type GlacierPolicyApiGetPolicyWithSummariesResponses = {
  /**
   * OK
   */
  200: PolicyWithSummaries;
};

export type GlacierPolicyApiGetPolicyWithSummariesResponse =
  GlacierPolicyApiGetPolicyWithSummariesResponses[keyof GlacierPolicyApiGetPolicyWithSummariesResponses];

export type GlacierPolicyApiGetPolicyPermissionsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/permissions/';
};

export type GlacierPolicyApiGetPolicyPermissionsResponses = {
  /**
   * OK
   */
  200: ResponseEnum;
};

export type GlacierPolicyApiGetPolicyPermissionsResponse =
  GlacierPolicyApiGetPolicyPermissionsResponses[keyof GlacierPolicyApiGetPolicyPermissionsResponses];

export type GlacierPolicyApiDeclineTransactionData = {
  body: DeclineReason;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/decline/';
};

export type GlacierPolicyApiDeclineTransactionErrors = {
  /**
   * Response
   *
   * Unauthorized
   */
  401: 'unauthorized';
};

export type GlacierPolicyApiDeclineTransactionError =
  GlacierPolicyApiDeclineTransactionErrors[keyof GlacierPolicyApiDeclineTransactionErrors];

export type GlacierPolicyApiDeclineTransactionResponses = {
  /**
   * Response
   *
   * OK
   */
  200: 'ok';
};

export type GlacierPolicyApiDeclineTransactionResponse =
  GlacierPolicyApiDeclineTransactionResponses[keyof GlacierPolicyApiDeclineTransactionResponses];

export type GlacierPolicyApiDiscardTransactionData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/discard/';
};

export type GlacierPolicyApiDiscardTransactionErrors = {
  /**
   * Response
   *
   * Unauthorized
   */
  401: 'unauthorized';
};

export type GlacierPolicyApiDiscardTransactionError =
  GlacierPolicyApiDiscardTransactionErrors[keyof GlacierPolicyApiDiscardTransactionErrors];

export type GlacierPolicyApiDiscardTransactionResponses = {
  /**
   * Response
   *
   * OK
   */
  200: 'ok';
};

export type GlacierPolicyApiDiscardTransactionResponse =
  GlacierPolicyApiDiscardTransactionResponses[keyof GlacierPolicyApiDiscardTransactionResponses];

export type GlacierPolicyApiReopenTransactionData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/reopen/';
};

export type GlacierPolicyApiReopenTransactionErrors = {
  /**
   * Response
   *
   * Unauthorized
   */
  401: 'unauthorized';
};

export type GlacierPolicyApiReopenTransactionError =
  GlacierPolicyApiReopenTransactionErrors[keyof GlacierPolicyApiReopenTransactionErrors];

export type GlacierPolicyApiReopenTransactionResponses = {
  /**
   * Response
   *
   * OK
   */
  200: 'ok';
};

export type GlacierPolicyApiReopenTransactionResponse =
  GlacierPolicyApiReopenTransactionResponses[keyof GlacierPolicyApiReopenTransactionResponses];

export type GlacierPolicyApiAddLocationData = {
  body: AddLocationRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/location/';
};

export type GlacierPolicyApiAddLocationResponses = {
  /**
   * OK
   */
  200: PracticeLocation;
};

export type GlacierPolicyApiAddLocationResponse =
  GlacierPolicyApiAddLocationResponses[keyof GlacierPolicyApiAddLocationResponses];

export type GlacierPolicyApiUpdatePrimaryLocationData = {
  body: MakePrimarySchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/location/primary/';
};

export type GlacierPolicyApiUpdatePrimaryLocationResponses = {
  /**
   * OK
   */
  200: PracticeLocation;
};

export type GlacierPolicyApiUpdatePrimaryLocationResponse =
  GlacierPolicyApiUpdatePrimaryLocationResponses[keyof GlacierPolicyApiUpdatePrimaryLocationResponses];

export type GlacierPolicyApiDeleteLocationData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/location/{location_id}/';
};

export type GlacierPolicyApiDeleteLocationResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiGetLocationData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/location/{location_id}/';
};

export type GlacierPolicyApiGetLocationResponses = {
  /**
   * OK
   */
  200: PracticeLocation;
};

export type GlacierPolicyApiGetLocationResponse =
  GlacierPolicyApiGetLocationResponses[keyof GlacierPolicyApiGetLocationResponses];

export type GlacierPolicyApiUpdateLocationData = {
  body: UpdateLocationRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/location/{location_id}/';
};

export type GlacierPolicyApiUpdateLocationResponses = {
  /**
   * OK
   */
  200: PracticeLocation;
};

export type GlacierPolicyApiUpdateLocationResponse =
  GlacierPolicyApiUpdateLocationResponses[keyof GlacierPolicyApiUpdateLocationResponses];

export type GlacierPolicyApiBulkUpdateLocationsData = {
  /**
   * Locations
   */
  body: Array<BulkUpdateLocationRequest>;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/locations/';
};

export type GlacierPolicyApiBulkUpdateLocationsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<PracticeLocation>;
};

export type GlacierPolicyApiBulkUpdateLocationsResponse =
  GlacierPolicyApiBulkUpdateLocationsResponses[keyof GlacierPolicyApiBulkUpdateLocationsResponses];

export type GlacierPolicyApiUndoDeleteLocationData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/location/{location_id}/reinstate';
};

export type GlacierPolicyApiUndoDeleteLocationResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiGetDentistData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Dentist Id
     */
    dentist_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}';
};

export type GlacierPolicyApiGetDentistResponses = {
  /**
   * OK
   */
  200: Dentist;
};

export type GlacierPolicyApiGetDentistResponse =
  GlacierPolicyApiGetDentistResponses[keyof GlacierPolicyApiGetDentistResponses];

export type GlacierPolicyApiSetDentistAsFirstNamedInsuredData = {
  body: SetDentistAsFirstNamedInsuredSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/set-dentist-as-first-named-insured/';
};

export type GlacierPolicyApiSetDentistAsFirstNamedInsuredResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiSetDentistAsFirstNamedInsuredResponse =
  GlacierPolicyApiSetDentistAsFirstNamedInsuredResponses[keyof GlacierPolicyApiSetDentistAsFirstNamedInsuredResponses];

export type GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredData = {
  body: SetOwnedEntityAsFirstNamedInsuredSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/owned-entity/set-owned-entity-as-first-named-insured/';
};

export type GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponse =
  GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponses[keyof GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponses];

export type GlacierPolicyApiAddDentistData = {
  body: CreateDentistRequestSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/';
};

export type GlacierPolicyApiAddDentistResponses = {
  /**
   * OK
   */
  200: Dentist;
};

export type GlacierPolicyApiAddDentistResponse =
  GlacierPolicyApiAddDentistResponses[keyof GlacierPolicyApiAddDentistResponses];

export type GlacierPolicyApiDeleteDentistData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Dentist Id
     */
    dentist_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/';
};

export type GlacierPolicyApiDeleteDentistResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiDeleteDentistResponse =
  GlacierPolicyApiDeleteDentistResponses[keyof GlacierPolicyApiDeleteDentistResponses];

export type GlacierPolicyApiUpdateBasicDentistData = {
  body: UpdateBasicDentistRequestSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Dentist Id
     */
    dentist_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/';
};

export type GlacierPolicyApiUpdateBasicDentistResponses = {
  /**
   * OK
   */
  200: Dentist;
};

export type GlacierPolicyApiUpdateBasicDentistResponse =
  GlacierPolicyApiUpdateBasicDentistResponses[keyof GlacierPolicyApiUpdateBasicDentistResponses];

export type GlacierPolicyApiUndoDeleteDentistData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Dentist Id
     */
    dentist_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/reinstate/';
};

export type GlacierPolicyApiUndoDeleteDentistResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiUndoDeleteDentistResponse =
  GlacierPolicyApiUndoDeleteDentistResponses[keyof GlacierPolicyApiUndoDeleteDentistResponses];

export type GlacierPolicyApiGetDentistInformationData = {
  body?: never;
  path: {
    /**
     * Dentist Id
     */
    dentist_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/information/';
};

export type GlacierPolicyApiGetDentistInformationResponses = {
  /**
   * OK
   */
  200: DentistInformation;
};

export type GlacierPolicyApiGetDentistInformationResponse =
  GlacierPolicyApiGetDentistInformationResponses[keyof GlacierPolicyApiGetDentistInformationResponses];

export type GlacierPolicyApiUpdateDentistInformationData = {
  body: DentistInformationSchema;
  path: {
    /**
     * Dentist Id
     */
    dentist_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/information/';
};

export type GlacierPolicyApiUpdateDentistInformationResponses = {
  /**
   * OK
   */
  200: DentistInformation;
};

export type GlacierPolicyApiUpdateDentistInformationResponse =
  GlacierPolicyApiUpdateDentistInformationResponses[keyof GlacierPolicyApiUpdateDentistInformationResponses];

export type GlacierPolicyApiGetDentistPricingData = {
  body?: never;
  path: {
    /**
     * Dentist Id
     */
    dentist_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/pricing/';
};

export type GlacierPolicyApiGetDentistPricingResponses = {
  /**
   * OK
   */
  200: DentistAdditionalPricing;
};

export type GlacierPolicyApiGetDentistPricingResponse =
  GlacierPolicyApiGetDentistPricingResponses[keyof GlacierPolicyApiGetDentistPricingResponses];

export type GlacierPolicyApiUpdateDentistPricingData = {
  body: DentistAdditionalPricing;
  path: {
    /**
     * Dentist Id
     */
    dentist_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/pricing/';
};

export type GlacierPolicyApiUpdateDentistPricingResponses = {
  /**
   * OK
   */
  200: DentistAdditionalPricing;
};

export type GlacierPolicyApiUpdateDentistPricingResponse =
  GlacierPolicyApiUpdateDentistPricingResponses[keyof GlacierPolicyApiUpdateDentistPricingResponses];

export type GlacierPolicyApiGetDentistProceduresData = {
  body?: never;
  path: {
    /**
     * Dentist Id
     */
    dentist_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/procedures/';
};

export type GlacierPolicyApiGetDentistProceduresResponses = {
  /**
   * OK
   */
  200: DentistProcedures;
};

export type GlacierPolicyApiGetDentistProceduresResponse =
  GlacierPolicyApiGetDentistProceduresResponses[keyof GlacierPolicyApiGetDentistProceduresResponses];

export type GlacierPolicyApiUpdateDentistProceduresData = {
  body: DentistProcedures;
  path: {
    /**
     * Dentist Id
     */
    dentist_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/procedures/';
};

export type GlacierPolicyApiUpdateDentistProceduresResponses = {
  /**
   * OK
   */
  200: DentistProcedures;
};

export type GlacierPolicyApiUpdateDentistProceduresResponse =
  GlacierPolicyApiUpdateDentistProceduresResponses[keyof GlacierPolicyApiUpdateDentistProceduresResponses];

export type GlacierPolicyApiSearchTruthmdDataData = {
  body: TruthMdSearchRequestSchema;
  path: {
    /**
     * Dentist Id
     */
    dentist_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/truthmd-search/';
};

export type GlacierPolicyApiSearchTruthmdDataResponses = {
  /**
   * OK
   */
  200: TruthMdData;
};

export type GlacierPolicyApiSearchTruthmdDataResponse =
  GlacierPolicyApiSearchTruthmdDataResponses[keyof GlacierPolicyApiSearchTruthmdDataResponses];

export type GlacierPolicyApiClearDentistTruthmdData = {
  body?: never;
  path: {
    /**
     * Dentist Id
     */
    dentist_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/truthmd/';
};

export type GlacierPolicyApiClearDentistTruthmdResponses = {
  /**
   * Response
   *
   * OK
   */
  200: {
    [key: string]: boolean;
  };
};

export type GlacierPolicyApiClearDentistTruthmdResponse =
  GlacierPolicyApiClearDentistTruthmdResponses[keyof GlacierPolicyApiClearDentistTruthmdResponses];

export type GlacierPolicyApiSaveDentistTruthmdData = {
  body: TruthMdData;
  path: {
    /**
     * Dentist Id
     */
    dentist_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/truthmd/';
};

export type GlacierPolicyApiSaveDentistTruthmdResponses = {
  /**
   * OK
   */
  200: TruthMdData;
};

export type GlacierPolicyApiSaveDentistTruthmdResponse =
  GlacierPolicyApiSaveDentistTruthmdResponses[keyof GlacierPolicyApiSaveDentistTruthmdResponses];

export type GlacierPolicyApiGetPracticeOwnersData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/pl/practice_owners/';
};

export type GlacierPolicyApiGetPracticeOwnersResponses = {
  /**
   * OK
   */
  200: PracticeOwner;
};

export type GlacierPolicyApiGetPracticeOwnersResponse =
  GlacierPolicyApiGetPracticeOwnersResponses[keyof GlacierPolicyApiGetPracticeOwnersResponses];

export type GlacierPolicyApiUpdatePlPracticeOwnerData = {
  body: PracticeOwnerSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/pl/practice_owners/';
};

export type GlacierPolicyApiUpdatePlPracticeOwnerResponses = {
  /**
   * OK
   */
  200: PracticeOwner;
};

export type GlacierPolicyApiUpdatePlPracticeOwnerResponse =
  GlacierPolicyApiUpdatePlPracticeOwnerResponses[keyof GlacierPolicyApiUpdatePlPracticeOwnerResponses];

export type GlacierPolicyApiGetPlCoverageData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/pl/coverage/';
};

export type GlacierPolicyApiGetPlCoverageResponses = {
  /**
   * OK
   */
  200: ProfessionalLiabilityCoverageSection;
};

export type GlacierPolicyApiGetPlCoverageResponse =
  GlacierPolicyApiGetPlCoverageResponses[keyof GlacierPolicyApiGetPlCoverageResponses];

export type GlacierPolicyApiUpdatePlCoverageData = {
  body: ProfessionalLiabilityCoverageSectionRequestSchemaWritable;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/pl/coverage/';
};

export type GlacierPolicyApiUpdatePlCoverageResponses = {
  /**
   * OK
   */
  200: ProfessionalLiabilityCoverageSection;
};

export type GlacierPolicyApiUpdatePlCoverageResponse =
  GlacierPolicyApiUpdatePlCoverageResponses[keyof GlacierPolicyApiUpdatePlCoverageResponses];

export type GlacierPolicyApiGetPolicyDetailsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/details/';
};

export type GlacierPolicyApiGetPolicyDetailsResponses = {
  /**
   * OK
   */
  200: PolicyDetails;
};

export type GlacierPolicyApiGetPolicyDetailsResponse =
  GlacierPolicyApiGetPolicyDetailsResponses[keyof GlacierPolicyApiGetPolicyDetailsResponses];

export type GlacierPolicyApiUpdatePolicyDetailsData = {
  body: PolicyDetailsSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/details/';
};

export type GlacierPolicyApiUpdatePolicyDetailsResponses = {
  /**
   * OK
   */
  200: PolicyDetails;
};

export type GlacierPolicyApiUpdatePolicyDetailsResponse =
  GlacierPolicyApiUpdatePolicyDetailsResponses[keyof GlacierPolicyApiUpdatePolicyDetailsResponses];

export type GlacierPolicyApiUpdateBypassValidatorsData = {
  body: UpdateBypassValidatorsRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/bypass-validators/';
};

export type GlacierPolicyApiUpdateBypassValidatorsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: {
    [key: string]: boolean;
  };
};

export type GlacierPolicyApiUpdateBypassValidatorsResponse =
  GlacierPolicyApiUpdateBypassValidatorsResponses[keyof GlacierPolicyApiUpdateBypassValidatorsResponses];

export type GlacierPolicyApiRefreshCommercialPropertyWithVeriskData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/verisk';
};

export type GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponses = {
  /**
   * OK
   */
  200: CommercialProperty;
};

export type GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponse =
  GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponses[keyof GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponses];

export type GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/corelogic';
};

export type GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponses = {
  /**
   * OK
   */
  200: CommercialProperty;
};

export type GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponse =
  GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponses[keyof GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponses];

export type GlacierPolicyApiAddCommercialPropertyCoverageData = {
  body: AddPropertyCoverageSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cp/locations/';
};

export type GlacierPolicyApiAddCommercialPropertyCoverageResponses = {
  /**
   * OK
   */
  200: CommercialProperty;
};

export type GlacierPolicyApiAddCommercialPropertyCoverageResponse =
  GlacierPolicyApiAddCommercialPropertyCoverageResponses[keyof GlacierPolicyApiAddCommercialPropertyCoverageResponses];

export type GlacierPolicyApiDeleteCommercialPropertyCoverageData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/';
};

export type GlacierPolicyApiDeleteCommercialPropertyCoverageResponses = {
  /**
   * OK
   */
  200: CommercialProperty;
};

export type GlacierPolicyApiDeleteCommercialPropertyCoverageResponse =
  GlacierPolicyApiDeleteCommercialPropertyCoverageResponses[keyof GlacierPolicyApiDeleteCommercialPropertyCoverageResponses];

export type GlacierPolicyApiGetCommercialPropertyLocationData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/';
};

export type GlacierPolicyApiGetCommercialPropertyLocationResponses = {
  /**
   * OK
   */
  200: Location;
};

export type GlacierPolicyApiGetCommercialPropertyLocationResponse =
  GlacierPolicyApiGetCommercialPropertyLocationResponses[keyof GlacierPolicyApiGetCommercialPropertyLocationResponses];

export type GlacierPolicyApiUpdateCommercialPropertyCoverageData = {
  body: UpdateLocationSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/';
};

export type GlacierPolicyApiUpdateCommercialPropertyCoverageResponses = {
  /**
   * OK
   */
  200: CommercialProperty;
};

export type GlacierPolicyApiUpdateCommercialPropertyCoverageResponse =
  GlacierPolicyApiUpdateCommercialPropertyCoverageResponses[keyof GlacierPolicyApiUpdateCommercialPropertyCoverageResponses];

export type GlacierPolicyApiUndoDeleteCommercialPropertyCoverageData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/reinstate/';
};

export type GlacierPolicyApiUndoDeleteCommercialPropertyCoverageResponses = {
  /**
   * OK
   */
  200: CommercialProperty;
};

export type GlacierPolicyApiUndoDeleteCommercialPropertyCoverageResponse =
  GlacierPolicyApiUndoDeleteCommercialPropertyCoverageResponses[keyof GlacierPolicyApiUndoDeleteCommercialPropertyCoverageResponses];

export type GlacierPolicyApiGetCommercialPropertyCoverageData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query: {
    /**
     * Location Id
     */
    location_id: string;
  };
  url: '/api/v1/policy/{account_id}/cp/coverage/';
};

export type GlacierPolicyApiGetCommercialPropertyCoverageResponses = {
  /**
   * OK
   */
  200: Coverage;
};

export type GlacierPolicyApiGetCommercialPropertyCoverageResponse =
  GlacierPolicyApiGetCommercialPropertyCoverageResponses[keyof GlacierPolicyApiGetCommercialPropertyCoverageResponses];

export type GlacierPolicyApiUpdateCpCoverageData = {
  body: UpdateCoverageSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cp/coverage/';
};

export type GlacierPolicyApiUpdateCpCoverageResponses = {
  /**
   * OK
   */
  200: Coverage;
};

export type GlacierPolicyApiUpdateCpCoverageResponse =
  GlacierPolicyApiUpdateCpCoverageResponses[keyof GlacierPolicyApiUpdateCpCoverageResponses];

export type GlacierPolicyApiRatePolicyData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/rate/';
};

export type GlacierPolicyApiRatePolicyErrors = {
  /**
   * Bad Request
   */
  400: MultipleMissingRequiredFieldErrorTypedDict;
  /**
   * Unprocessable Content
   */
  422: FieldValidationErrors;
  /**
   * Response
   *
   * Locked
   */
  423: unknown;
};

export type GlacierPolicyApiRatePolicyError =
  GlacierPolicyApiRatePolicyErrors[keyof GlacierPolicyApiRatePolicyErrors];

export type GlacierPolicyApiRatePolicyResponses = {
  /**
   * OK
   */
  200: LastRateAttempt | null;
};

export type GlacierPolicyApiRatePolicyResponse =
  GlacierPolicyApiRatePolicyResponses[keyof GlacierPolicyApiRatePolicyResponses];

export type GlacierPolicyApiGetFormulasData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/formulas/';
};

export type GlacierPolicyApiGetFormulasResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<FormulasForUi>;
};

export type GlacierPolicyApiGetFormulasResponse =
  GlacierPolicyApiGetFormulasResponses[keyof GlacierPolicyApiGetFormulasResponses];

export type GlacierPolicyApiCreateOwnedEntitiesData = {
  body: OwnedEntityCreationSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/owned_entities/';
};

export type GlacierPolicyApiCreateOwnedEntitiesResponses = {
  /**
   * OK
   */
  200: OwnedEntity;
};

export type GlacierPolicyApiCreateOwnedEntitiesResponse =
  GlacierPolicyApiCreateOwnedEntitiesResponses[keyof GlacierPolicyApiCreateOwnedEntitiesResponses];

export type GlacierPolicyApiDeleteOwnedEntityData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/';
};

export type GlacierPolicyApiDeleteOwnedEntityResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiDeleteOwnedEntityResponse =
  GlacierPolicyApiDeleteOwnedEntityResponses[keyof GlacierPolicyApiDeleteOwnedEntityResponses];

export type GlacierPolicyApiGetOwnedEntityData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/';
};

export type GlacierPolicyApiGetOwnedEntityResponses = {
  /**
   * Response
   *
   * OK
   */
  200: {
    [key: string]: unknown;
  };
};

export type GlacierPolicyApiGetOwnedEntityResponse =
  GlacierPolicyApiGetOwnedEntityResponses[keyof GlacierPolicyApiGetOwnedEntityResponses];

export type GlacierPolicyApiUpdatedOwnedEntityData = {
  body: OwnedEntityUpdateSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/';
};

export type GlacierPolicyApiUpdatedOwnedEntityResponses = {
  /**
   * OK
   */
  200: OwnedEntity;
};

export type GlacierPolicyApiUpdatedOwnedEntityResponse =
  GlacierPolicyApiUpdatedOwnedEntityResponses[keyof GlacierPolicyApiUpdatedOwnedEntityResponses];

export type GlacierPolicyApiUndoDeleteOwnedEntityData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/reinstate/';
};

export type GlacierPolicyApiUndoDeleteOwnedEntityResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiUndoDeleteOwnedEntityResponse =
  GlacierPolicyApiUndoDeleteOwnedEntityResponses[keyof GlacierPolicyApiUndoDeleteOwnedEntityResponses];

export type GlacierPolicyApiUpdateGeneralLiabilityData = {
  body: GeneralLiabilityRequestSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/general_liability/';
};

export type GlacierPolicyApiUpdateGeneralLiabilityResponses = {
  /**
   * OK
   */
  200: GeneralLiability;
};

export type GlacierPolicyApiUpdateGeneralLiabilityResponse =
  GlacierPolicyApiUpdateGeneralLiabilityResponses[keyof GlacierPolicyApiUpdateGeneralLiabilityResponses];

export type GlacierPolicyApiUpdateEmploymentPracticesLiabilityData = {
  body: EmploymentPracticesLiabilityRequestSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/employment_practices_liability/';
};

export type GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponses = {
  /**
   * OK
   */
  200: EmploymentPracticesLiability;
};

export type GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponse =
  GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponses[keyof GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponses];

export type GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData = {
  body: ErisaAndEmployeeBenefitsSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/erisa_and_employee_benefits/';
};

export type GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponses = {
  /**
   * OK
   */
  200: ErisaAndEmployeeBenefits;
};

export type GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponse =
  GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponses[keyof GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponses];

export type GlacierPolicyApiGetCyberLiabilityData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cyber_liability/';
};

export type GlacierPolicyApiGetCyberLiabilityResponses = {
  /**
   * OK
   */
  200: CyberLiability;
};

export type GlacierPolicyApiGetCyberLiabilityResponse =
  GlacierPolicyApiGetCyberLiabilityResponses[keyof GlacierPolicyApiGetCyberLiabilityResponses];

export type GlacierPolicyApiUpdateCyberLiabilityData = {
  body: CyberLiabilitySchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cyber_liability/';
};

export type GlacierPolicyApiUpdateCyberLiabilityResponses = {
  /**
   * OK
   */
  200: CyberLiability;
};

export type GlacierPolicyApiUpdateCyberLiabilityResponse =
  GlacierPolicyApiUpdateCyberLiabilityResponses[keyof GlacierPolicyApiUpdateCyberLiabilityResponses];

export type GlacierPolicyApiIssuePolicyData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/transactions/issue-policy/';
};

export type GlacierPolicyApiIssuePolicyResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiGetAgentAuthorityData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/agent-authority/';
};

export type GlacierPolicyApiGetAgentAuthorityResponses = {
  /**
   * OK
   */
  200: AgentAuthorityResponse;
};

export type GlacierPolicyApiGetAgentAuthorityResponse =
  GlacierPolicyApiGetAgentAuthorityResponses[keyof GlacierPolicyApiGetAgentAuthorityResponses];

export type GlacierPolicyApiCreateMidtermTransactionData = {
  body: CreateMidtermTransactionRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/midterm-change/create/';
};

export type GlacierPolicyApiCreateMidtermTransactionResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiCreateMidtermTransactionResponse =
  GlacierPolicyApiCreateMidtermTransactionResponses[keyof GlacierPolicyApiCreateMidtermTransactionResponses];

export type GlacierPolicyApiStartChangeExpirationDateMidtermData = {
  body: ChangeExpirationDateMidtermRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/midterm-change/change-expiration-date/';
};

export type GlacierPolicyApiStartChangeExpirationDateMidtermResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiStartChangeExpirationDateMidtermResponse =
  GlacierPolicyApiStartChangeExpirationDateMidtermResponses[keyof GlacierPolicyApiStartChangeExpirationDateMidtermResponses];

export type GlacierPolicyApiChangeEndorsementEffectiveDateData = {
  body: ChangeEndorsementEffectiveDateRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/midterm-change/effective-date/';
};

export type GlacierPolicyApiChangeEndorsementEffectiveDateResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiChangeEndorsementEffectiveDateResponse =
  GlacierPolicyApiChangeEndorsementEffectiveDateResponses[keyof GlacierPolicyApiChangeEndorsementEffectiveDateResponses];

export type GlacierPolicyApiSetReasonForChangeData = {
  body: SetReasonForChangeRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/midterm-change/set-reason-for-change/';
};

export type GlacierPolicyApiSetReasonForChangeResponses = {
  /**
   * Response
   *
   * OK
   */
  200: {
    [key: string]: string | boolean;
  };
};

export type GlacierPolicyApiSetReasonForChangeResponse =
  GlacierPolicyApiSetReasonForChangeResponses[keyof GlacierPolicyApiSetReasonForChangeResponses];

export type GlacierPolicyApiPricePreviewMidtermChangeData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/midterm-change/price-preview/';
};

export type GlacierPolicyApiPricePreviewMidtermChangeResponses = {
  /**
   * OK
   */
  200: MidtermPreviewResponse;
};

export type GlacierPolicyApiPricePreviewMidtermChangeResponse =
  GlacierPolicyApiPricePreviewMidtermChangeResponses[keyof GlacierPolicyApiPricePreviewMidtermChangeResponses];

export type GlacierPolicyApiReasonForChangePreviewData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/midterm-change/reason-for-change-preview/';
};

export type GlacierPolicyApiReasonForChangePreviewResponses = {
  /**
   * OK
   */
  200: ReasonForChangePreviewResponse;
};

export type GlacierPolicyApiReasonForChangePreviewResponse =
  GlacierPolicyApiReasonForChangePreviewResponses[keyof GlacierPolicyApiReasonForChangePreviewResponses];

export type GlacierPolicyApiFinalizeMidtermChangeData = {
  body: FinalizeMidtermChange;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/midterm-change/finalize/';
};

export type GlacierPolicyApiFinalizeMidtermChangeResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiFinalizeMidtermChangeResponse =
  GlacierPolicyApiFinalizeMidtermChangeResponses[keyof GlacierPolicyApiFinalizeMidtermChangeResponses];

export type GlacierPolicyApiCancelMidtermChangeData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/midterm-change/cancel/';
};

export type GlacierPolicyApiCancelMidtermChangeResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiCancelMidtermChangeResponse =
  GlacierPolicyApiCancelMidtermChangeResponses[keyof GlacierPolicyApiCancelMidtermChangeResponses];

export type GlacierPolicyApiGetSummaryOfChangesPdfData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/summary-of-changes/pdf/';
};

export type GlacierPolicyApiGetSummaryOfChangesPdfResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiRevertTransactionData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Number
     */
    number: number;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/transactions/{number}/revert/';
};

export type GlacierPolicyApiRevertTransactionResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyApiRevertTransactionResponse =
  GlacierPolicyApiRevertTransactionResponses[keyof GlacierPolicyApiRevertTransactionResponses];

export type GlacierPolicyApiUpdateDentistUnderwritingQuestionsData = {
  body: DentistUnderwritingQuestionsSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Dentist Id
     */
    dentist_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/underwriting_questions/';
};

export type GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponses = {
  /**
   * OK
   */
  200: DentistUnderwritingQuestions;
};

export type GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponse =
  GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponses[keyof GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponses];

export type GlacierPolicyApiPremiumStatementData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/premium-statement/';
};

export type GlacierPolicyApiPremiumStatementResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiPremiumStatementResponse =
  GlacierPolicyApiPremiumStatementResponses[keyof GlacierPolicyApiPremiumStatementResponses];

export type GlacierPolicyApiAgencyBillInvoiceData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/agency-bill-invoice/';
};

export type GlacierPolicyApiAgencyBillInvoiceResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiAgencyBillInvoiceResponse =
  GlacierPolicyApiAgencyBillInvoiceResponses[keyof GlacierPolicyApiAgencyBillInvoiceResponses];

export type GlacierPolicyApiGetSpecialFormsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query: {
    special_form: SpecialForms;
  };
  url: '/api/v1/policy/{account_id}/documents/special-forms/';
};

export type GlacierPolicyApiGetSpecialFormsResponses = {
  /**
   * Response
   *
   * OK
   */
  200:
    | {
        [key: string]: string;
      }
    | unknown;
};

export type GlacierPolicyApiGetSpecialFormsResponse =
  GlacierPolicyApiGetSpecialFormsResponses[keyof GlacierPolicyApiGetSpecialFormsResponses];

export type GlacierPolicyApiConditionalRenewalNoticeData = {
  body: ConditionalRenewalNoticeRequestSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/renewal-notice/';
};

export type GlacierPolicyApiConditionalRenewalNoticeResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiConditionalRenewalNoticeResponse =
  GlacierPolicyApiConditionalRenewalNoticeResponses[keyof GlacierPolicyApiConditionalRenewalNoticeResponses];

export type GlacierPolicyApiDownloadRatingWorksheetsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    worksheet_enum: RatingWorksheetEnum;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/rating_worksheets/{worksheet_enum}/';
};

export type GlacierPolicyApiDownloadRatingWorksheetsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiDownloadRatingWorksheetsResponse =
  GlacierPolicyApiDownloadRatingWorksheetsResponses[keyof GlacierPolicyApiDownloadRatingWorksheetsResponses];

export type GlacierPolicyApiDownloadErpWorksheetsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    worksheet_enum: ErpWorksheetEnum;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/erp_worksheets/{worksheet_enum}/';
};

export type GlacierPolicyApiDownloadErpWorksheetsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiDownloadErpWorksheetsResponse =
  GlacierPolicyApiDownloadErpWorksheetsResponses[keyof GlacierPolicyApiDownloadErpWorksheetsResponses];

export type GlacierPolicyApiPremiumRenewalNoticeData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/premium-renewal-notice/';
};

export type GlacierPolicyApiPremiumRenewalNoticeResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiPremiumRenewalNoticeResponse =
  GlacierPolicyApiPremiumRenewalNoticeResponses[keyof GlacierPolicyApiPremiumRenewalNoticeResponses];

export type GlacierPolicyApiDownloadLookerDashboardPdfData = {
  body: DownloadLookerDashboard;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/looker_dashboard_pdf/';
};

export type GlacierPolicyApiDownloadLookerDashboardPdfResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiDownloadLookerDashboardPdfResponse =
  GlacierPolicyApiDownloadLookerDashboardPdfResponses[keyof GlacierPolicyApiDownloadLookerDashboardPdfResponses];

export type GlacierPolicyApiDownloadLookerDashboardCsvData = {
  body: DownloadLookerDashboard;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/looker_dashboard_csv/';
};

export type GlacierPolicyApiDownloadLookerDashboardCsvResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiDownloadLookerDashboardCsvResponse =
  GlacierPolicyApiDownloadLookerDashboardCsvResponses[keyof GlacierPolicyApiDownloadLookerDashboardCsvResponses];

export type GlacierPolicyApiSpecimenPreviewData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: {
    /**
     * Regenerate Full Policy
     */
    regenerate_full_policy?: boolean;
  };
  url: '/api/v1/policy/{account_id}/generate-preview/specimen/';
};

export type GlacierPolicyApiSpecimenPreviewResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiSpecimenPreviewResponse =
  GlacierPolicyApiSpecimenPreviewResponses[keyof GlacierPolicyApiSpecimenPreviewResponses];

export type GlacierPolicyApiListDocumentsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/';
};

export type GlacierPolicyApiListDocumentsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<FileDocumentSchema>;
};

export type GlacierPolicyApiListDocumentsResponse =
  GlacierPolicyApiListDocumentsResponses[keyof GlacierPolicyApiListDocumentsResponses];

export type GlacierPolicyApiUploadDocumentData = {
  /**
   * FileParams
   */
  body: {
    /**
     * File
     */
    file: Blob | File;
  };
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/';
};

export type GlacierPolicyApiUploadDocumentResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiDownloadAllTransactionsDocumentsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: {
    /**
     * Download
     */
    download?: boolean;
  };
  url: '/api/v1/policy/{account_id}/all-transactions-documents/download/';
};

export type GlacierPolicyApiDownloadAllTransactionsDocumentsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiDownloadAllTransactionsDocumentsResponse =
  GlacierPolicyApiDownloadAllTransactionsDocumentsResponses[keyof GlacierPolicyApiDownloadAllTransactionsDocumentsResponses];

export type GlacierPolicyApiUploadDocumentsWithMetadataData = {
  /**
   * MultiPartBodyParams
   */
  body: {
    /**
     * Files
     */
    files: Array<Blob | File>;
    /**
     * Metadata
     */
    metadata?: string;
  };
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/upload/';
};

export type GlacierPolicyApiUploadDocumentsWithMetadataResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiDetachDocumentData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Document Id
     */
    document_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/{document_id}/';
};

export type GlacierPolicyApiDetachDocumentResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiUpdateDocumentData = {
  body: UpdateDocumentRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Document Id
     */
    document_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/documents/{document_id}/';
};

export type GlacierPolicyApiUpdateDocumentResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type DocumentIsReadyData = {
  body?: never;
  path: {
    /**
     * Document Id
     */
    document_id: string;
  };
  query?: never;
  url: '/api/v1/policy/document-warehouse/{document_id}/is-ready/';
};

export type DocumentIsReadyErrors = {
  /**
   * Not Found
   */
  404: DocumentStatusResponse;
};

export type DocumentIsReadyError =
  DocumentIsReadyErrors[keyof DocumentIsReadyErrors];

export type DocumentIsReadyResponses = {
  /**
   * OK
   */
  200: DocumentStatusResponse;
};

export type DocumentIsReadyResponse =
  DocumentIsReadyResponses[keyof DocumentIsReadyResponses];

export type GlacierPolicyApiDownloadDocumentData = {
  body?: never;
  path: {
    /**
     * Document Id
     */
    document_id: string;
    /**
     * Policy Id
     */
    policy_id: string;
  };
  query?: {
    /**
     * Filename
     */
    filename?: string | null;
    /**
     * Download
     */
    download?: boolean;
  };
  url: '/api/v1/policy/document-warehouse/{document_id}/{policy_id}/download/';
};

export type GlacierPolicyApiDownloadDocumentResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyApiDownloadDocumentResponse =
  GlacierPolicyApiDownloadDocumentResponses[keyof GlacierPolicyApiDownloadDocumentResponses];

export type GlacierPolicyApiRegenerateDocumentData = {
  body?: never;
  path: {
    /**
     * Document Id
     */
    document_id: string;
    /**
     * Policy Id
     */
    policy_id: string;
  };
  query?: never;
  url: '/api/v1/policy/document-warehouse/{document_id}/{policy_id}/regenerate/';
};

export type GlacierPolicyApiRegenerateDocumentResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiRegenerateCompletePolicyBundleData = {
  body?: never;
  path: {
    /**
     * Document Id
     */
    document_id: string;
    /**
     * Policy Id
     */
    policy_id: string;
  };
  query?: never;
  url: '/api/v1/policy/document-warehouse/{document_id}/{policy_id}/regenerate-complete/';
};

export type GlacierPolicyApiRegenerateCompletePolicyBundleResponses = {
  /**
   * No Content
   */
  204: void;
};

export type GlacierPolicyApiRegenerateCompletePolicyBundleResponse =
  GlacierPolicyApiRegenerateCompletePolicyBundleResponses[keyof GlacierPolicyApiRegenerateCompletePolicyBundleResponses];

export type GlacierPolicyApiCommitTransactionTestData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/commit_transaction_test/';
};

export type GlacierPolicyApiCommitTransactionTestResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiListUnderwriterNotesData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/underwriter-notes/';
};

export type GlacierPolicyApiListUnderwriterNotesResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<UnderwriterNoteSchema>;
};

export type GlacierPolicyApiListUnderwriterNotesResponse =
  GlacierPolicyApiListUnderwriterNotesResponses[keyof GlacierPolicyApiListUnderwriterNotesResponses];

export type GlacierPolicyApiCreateUnderwriterNotesData = {
  body: UnderwriterNoteRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/underwriter-notes/';
};

export type GlacierPolicyApiCreateUnderwriterNotesResponses = {
  /**
   * OK
   */
  200: UnderwriterNoteSchema;
};

export type GlacierPolicyApiCreateUnderwriterNotesResponse =
  GlacierPolicyApiCreateUnderwriterNotesResponses[keyof GlacierPolicyApiCreateUnderwriterNotesResponses];

export type GlacierPolicyApiDeleteUnderwriterNotesData = {
  body?: never;
  path: {
    /**
     * Note Id
     */
    note_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/underwriter-notes/{note_id}/';
};

export type GlacierPolicyApiDeleteUnderwriterNotesResponses = {
  /**
   * No Content
   */
  204: void;
};

export type GlacierPolicyApiDeleteUnderwriterNotesResponse =
  GlacierPolicyApiDeleteUnderwriterNotesResponses[keyof GlacierPolicyApiDeleteUnderwriterNotesResponses];

export type GlacierPolicyApiUpdateUnderwriterNotesData = {
  body: UnderwriterNoteRequest;
  path: {
    /**
     * Note Id
     */
    note_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/underwriter-notes/{note_id}/';
};

export type GlacierPolicyApiUpdateUnderwriterNotesResponses = {
  /**
   * OK
   */
  200: UnderwriterNoteSchema;
};

export type GlacierPolicyApiUpdateUnderwriterNotesResponse =
  GlacierPolicyApiUpdateUnderwriterNotesResponses[keyof GlacierPolicyApiUpdateUnderwriterNotesResponses];

export type GlacierPolicyApiReopenUnlockedAccountData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/reopen_unlocked_account/';
};

export type GlacierPolicyApiReopenUnlockedAccountErrors = {
  /**
   * Response
   *
   * Bad Request
   */
  400: string;
  /**
   * Response
   *
   * Forbidden
   */
  403: string;
};

export type GlacierPolicyApiReopenUnlockedAccountError =
  GlacierPolicyApiReopenUnlockedAccountErrors[keyof GlacierPolicyApiReopenUnlockedAccountErrors];

export type GlacierPolicyApiReopenUnlockedAccountResponses = {
  /**
   * No Content
   */
  204: void;
};

export type GlacierPolicyApiReopenUnlockedAccountResponse =
  GlacierPolicyApiReopenUnlockedAccountResponses[keyof GlacierPolicyApiReopenUnlockedAccountResponses];

export type GlacierPolicyApiCreatePolicyPendingCancellationTransactionData = {
  /**
   * MultiPartBodyParams
   */
  body: {
    /**
     * Notice Generation Date
     */
    notice_generation_date: string;
    /**
     * Cancellation Process Date
     */
    cancellation_process_date: string;
    cancellation_reason: CancellationReasonEnum;
    cancel_type: CancelTypeEnum;
    /**
     * Effective Date
     */
    effective_date: string;
    /**
     * File
     */
    file: Blob | File;
  };
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/midterm-change/pending-cancellation-policy/';
};

export type GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponses =
  {
    /**
     * OK
     */
    200: Policy;
  };

export type GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponse =
  GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponses[keyof GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponses];

export type GlacierPolicyApiListObjectSummariesData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    object_type: ObjectSummaryTypeEnum;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/object-summaries/{object_type}/';
};

export type GlacierPolicyApiListObjectSummariesResponses = {
  /**
   * Response
   *
   * OK
   */
  200:
    | Array<PracticeLocationFrontend>
    | Array<DentistFrontend>
    | Array<OwnedEntityFrontend>
    | Array<CpLocationFrontend>;
};

export type GlacierPolicyApiListObjectSummariesResponse =
  GlacierPolicyApiListObjectSummariesResponses[keyof GlacierPolicyApiListObjectSummariesResponses];

export type GlacierPolicyApiGetObjectDetailsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    object_type: ObjectSummaryTypeEnum;
    /**
     * Object Id
     */
    object_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/object-details/{object_type}/{object_id}/';
};

export type GlacierPolicyApiGetObjectDetailsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: {
    [key: string]: unknown;
  };
};

export type GlacierPolicyApiGetObjectDetailsResponse =
  GlacierPolicyApiGetObjectDetailsResponses[keyof GlacierPolicyApiGetObjectDetailsResponses];

export type GlacierPolicyApiReferPolicyData = {
  body: ReferPolicyRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/refer/';
};

export type GlacierPolicyApiReferPolicyErrors = {
  /**
   * Bad Request
   */
  400: ErrorDetailDict;
};

export type GlacierPolicyApiReferPolicyError =
  GlacierPolicyApiReferPolicyErrors[keyof GlacierPolicyApiReferPolicyErrors];

export type GlacierPolicyApiReferPolicyResponses = {
  /**
   * No Content
   */
  204: void;
};

export type GlacierPolicyApiReferPolicyResponse =
  GlacierPolicyApiReferPolicyResponses[keyof GlacierPolicyApiReferPolicyResponses];

export type GlacierPolicyApiListTransactionsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/transactions/';
};

export type GlacierPolicyApiListTransactionsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<TransactionSnapshotSchema>;
};

export type GlacierPolicyApiListTransactionsResponse =
  GlacierPolicyApiListTransactionsResponses[keyof GlacierPolicyApiListTransactionsResponses];

export type GlacierPolicyApiGetTransactionSummaryData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Transaction Number
     */
    transaction_number: number;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/transactions/{transaction_number}/summary/';
};

export type GlacierPolicyApiGetTransactionSummaryResponses = {
  /**
   * Response
   *
   * OK
   */
  200: {
    [key: string]: unknown;
  };
};

export type GlacierPolicyApiGetTransactionSummaryResponse =
  GlacierPolicyApiGetTransactionSummaryResponses[keyof GlacierPolicyApiGetTransactionSummaryResponses];

export type GlacierPolicyApiGetTransactionDetailData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Transaction Number
     */
    transaction_number: number;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/transaction-detail/{transaction_number}/';
};

export type GlacierPolicyApiGetTransactionDetailResponses = {
  /**
   * OK
   */
  200: TransactionDetailSchema;
};

export type GlacierPolicyApiGetTransactionDetailResponse =
  GlacierPolicyApiGetTransactionDetailResponses[keyof GlacierPolicyApiGetTransactionDetailResponses];

export type GlacierPolicyApiConfirmRatingChecksData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/confirm-rating-checks/';
};

export type GlacierPolicyApiConfirmRatingChecksResponses = {
  /**
   * No Content
   */
  204: void;
};

export type GlacierPolicyApiConfirmRatingChecksResponse =
  GlacierPolicyApiConfirmRatingChecksResponses[keyof GlacierPolicyApiConfirmRatingChecksResponses];

export type GlacierPolicyApiDeletePolicyRenewalFlagData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    flag: RenewalFlagEnum;
  };
  query?: {
    /**
     * Note
     */
    note?: string | null;
  };
  url: '/api/v1/policy/{account_id}/renewal-flag/{flag}';
};

export type GlacierPolicyApiDeletePolicyRenewalFlagResponses = {
  /**
   * No Content
   */
  204: void;
};

export type GlacierPolicyApiDeletePolicyRenewalFlagResponse =
  GlacierPolicyApiDeletePolicyRenewalFlagResponses[keyof GlacierPolicyApiDeletePolicyRenewalFlagResponses];

export type GlacierPolicyApiSetPolicyRenewalFlagData = {
  /**
   * FormParams
   */
  body: {
    reasonForNonRenewal?: NonRenewalReasonEnum | null;
    /**
     * Note
     */
    note?: string | null;
  };
  path: {
    /**
     * Account Id
     */
    account_id: string;
    flag: RenewalFlagEnum;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/renewal-flag/{flag}';
};

export type GlacierPolicyApiSetPolicyRenewalFlagResponses = {
  /**
   * No Content
   */
  204: void;
};

export type GlacierPolicyApiSetPolicyRenewalFlagResponse =
  GlacierPolicyApiSetPolicyRenewalFlagResponses[keyof GlacierPolicyApiSetPolicyRenewalFlagResponses];

export type GlacierPolicyApiGetChildPolicyData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/child-policy/';
};

export type GlacierPolicyApiGetChildPolicyResponses = {
  /**
   * OK
   */
  200: ChildPolicyData;
};

export type GlacierPolicyApiGetChildPolicyResponse =
  GlacierPolicyApiGetChildPolicyResponses[keyof GlacierPolicyApiGetChildPolicyResponses];

export type GlacierPolicyApiGetPolicyTermsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/terms/';
};

export type GlacierPolicyApiGetPolicyTermsResponses = {
  /**
   * OK
   */
  200: TermsData;
};

export type GlacierPolicyApiGetPolicyTermsResponse =
  GlacierPolicyApiGetPolicyTermsResponses[keyof GlacierPolicyApiGetPolicyTermsResponses];

export type GlacierPolicyApiCreateRenewalData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/create_renewal/';
};

export type GlacierPolicyApiCreateRenewalResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiCloseRenewalData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/close_renewal/';
};

export type GlacierPolicyApiCloseRenewalResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyApiRenewalSummaryOfChangesData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/renewal_summary_of_changes/';
};

export type GlacierPolicyApiRenewalSummaryOfChangesResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: {
    /**
     * Include Superseded
     */
    include_superseded?: boolean;
  };
  url: '/api/v1/policy/{account_id}/cms-forms/policy/attached-forms/';
};

export type GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<AttachedFormSchema>;
};

export type GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponse =
  GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponses[keyof GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponses];

export type GlacierPolicyFormsApiAttachFormToPolicyData = {
  body: FormsInputSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/policy/attach-form/';
};

export type GlacierPolicyFormsApiAttachFormToPolicyResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyFormsApiAttachFormToPolicyResponse =
  GlacierPolicyFormsApiAttachFormToPolicyResponses[keyof GlacierPolicyFormsApiAttachFormToPolicyResponses];

export type GlacierPolicyFormsApiDetachFormFromPolicyData = {
  body: FormsInputSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/policy/detach-form/';
};

export type GlacierPolicyFormsApiDetachFormFromPolicyResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyFormsApiGetAvailableEndorsementsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/policy/available-endorsements/';
};

export type GlacierPolicyFormsApiGetAvailableEndorsementsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<AvailableFormSchema>;
};

export type GlacierPolicyFormsApiGetAvailableEndorsementsResponse =
  GlacierPolicyFormsApiGetAvailableEndorsementsResponses[keyof GlacierPolicyFormsApiGetAvailableEndorsementsResponses];

export type GlacierPolicyFormsApiAttachFormToDentistData = {
  body: FormsInputSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Dentist Id
     */
    dentist_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attach-form/';
};

export type GlacierPolicyFormsApiAttachFormToDentistResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<AttachedFormSchema>;
};

export type GlacierPolicyFormsApiAttachFormToDentistResponse =
  GlacierPolicyFormsApiAttachFormToDentistResponses[keyof GlacierPolicyFormsApiAttachFormToDentistResponses];

export type GlacierPolicyFormsApiDetachFormFromDentistData = {
  body: FormsInputSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Dentist Id
     */
    dentist_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/detach-form/';
};

export type GlacierPolicyFormsApiDetachFormFromDentistResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyFormsApiGetDentistAttachedFormsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Dentist Id
     */
    dentist_id: string;
  };
  query?: {
    /**
     * Include Superseded
     */
    include_superseded?: boolean;
  };
  url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attached-forms/';
};

export type GlacierPolicyFormsApiGetDentistAttachedFormsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<AttachedFormSchema>;
};

export type GlacierPolicyFormsApiGetDentistAttachedFormsResponse =
  GlacierPolicyFormsApiGetDentistAttachedFormsResponses[keyof GlacierPolicyFormsApiGetDentistAttachedFormsResponses];

export type GlacierPolicyFormsApiGetDentistAvailableEndorsementsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Dentist Id
     */
    dentist_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/available-endorsements/';
};

export type GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<AvailableFormSchema>;
};

export type GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponse =
  GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponses[keyof GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponses];

export type GlacierPolicyFormsApiAttachFormToLocationData = {
  body: FormsInputSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attach-form/';
};

export type GlacierPolicyFormsApiAttachFormToLocationResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<AttachedFormSchema>;
};

export type GlacierPolicyFormsApiAttachFormToLocationResponse =
  GlacierPolicyFormsApiAttachFormToLocationResponses[keyof GlacierPolicyFormsApiAttachFormToLocationResponses];

export type GlacierPolicyFormsApiDetachFormFromLocationData = {
  body: FormsInputSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/detach-form/';
};

export type GlacierPolicyFormsApiDetachFormFromLocationResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyFormsApiGetLocationAttachedFormsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: {
    /**
     * Include Superseded
     */
    include_superseded?: boolean;
  };
  url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attached-forms/';
};

export type GlacierPolicyFormsApiGetLocationAttachedFormsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<AttachedFormSchema>;
};

export type GlacierPolicyFormsApiGetLocationAttachedFormsResponse =
  GlacierPolicyFormsApiGetLocationAttachedFormsResponses[keyof GlacierPolicyFormsApiGetLocationAttachedFormsResponses];

export type GlacierPolicyFormsApiGetLocationAvailableEndorsementsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/available-endorsements/';
};

export type GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<AvailableFormSchema>;
};

export type GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponse =
  GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponses[keyof GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponses];

export type GlacierPolicyFormsApiAttachFormToEntityData = {
  body: FormsInputSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attach-form/';
};

export type GlacierPolicyFormsApiAttachFormToEntityResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<AttachedFormSchema>;
};

export type GlacierPolicyFormsApiAttachFormToEntityResponse =
  GlacierPolicyFormsApiAttachFormToEntityResponses[keyof GlacierPolicyFormsApiAttachFormToEntityResponses];

export type GlacierPolicyFormsApiDetachFormFromEntityData = {
  body: FormsInputSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/detach-form/';
};

export type GlacierPolicyFormsApiDetachFormFromEntityResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyFormsApiGetEntityAttachedFormsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
  };
  query?: {
    /**
     * Include Superseded
     */
    include_superseded?: boolean;
  };
  url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attached-forms/';
};

export type GlacierPolicyFormsApiGetEntityAttachedFormsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<AttachedFormSchema>;
};

export type GlacierPolicyFormsApiGetEntityAttachedFormsResponse =
  GlacierPolicyFormsApiGetEntityAttachedFormsResponses[keyof GlacierPolicyFormsApiGetEntityAttachedFormsResponses];

export type GlacierPolicyFormsApiGetEntityAvailableEndorsementsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/available-endorsements/';
};

export type GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<AvailableFormSchema>;
};

export type GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponse =
  GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponses[keyof GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponses];

export type GlacierPolicyFormsApiRenderFormData = {
  body: RenderFormsInputSchema;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/render-form/';
};

export type GlacierPolicyFormsApiRenderFormResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierPolicyFormsApiRenderFormResponse =
  GlacierPolicyFormsApiRenderFormResponses[keyof GlacierPolicyFormsApiRenderFormResponses];

export type GlacierPolicyFormsApiGetQuestionsByPolicyData = {
  body?: never;
  path: {
    /**
     * Attached Form Id
     */
    attached_form_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/policy/attached-forms/{attached_form_id}/questions/';
};

export type GlacierPolicyFormsApiGetQuestionsByPolicyResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<FrontendQuestionSchema>;
};

export type GlacierPolicyFormsApiGetQuestionsByPolicyResponse =
  GlacierPolicyFormsApiGetQuestionsByPolicyResponses[keyof GlacierPolicyFormsApiGetQuestionsByPolicyResponses];

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData = {
  body: SaveQuestionsBody;
  path: {
    /**
     * Attached Form Id
     */
    attached_form_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/policy/attached-forms/{attached_form_id}/questions/';
};

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyFormsApiGetQuestionsByDentistData = {
  body?: never;
  path: {
    /**
     * Attached Form Id
     */
    attached_form_id: string;
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Dentist Id
     */
    dentist_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attached-forms/{attached_form_id}/questions/';
};

export type GlacierPolicyFormsApiGetQuestionsByDentistResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<FrontendQuestionSchema>;
};

export type GlacierPolicyFormsApiGetQuestionsByDentistResponse =
  GlacierPolicyFormsApiGetQuestionsByDentistResponses[keyof GlacierPolicyFormsApiGetQuestionsByDentistResponses];

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData = {
  body: SaveQuestionsBody;
  path: {
    /**
     * Dentist Id
     */
    dentist_id: string;
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Attached Form Id
     */
    attached_form_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attached-forms/{attached_form_id}/questions/';
};

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyFormsApiGetQuestionsByLocationData = {
  body?: never;
  path: {
    /**
     * Attached Form Id
     */
    attached_form_id: string;
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Location Id
     */
    location_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attached-forms/{attached_form_id}/questions/';
};

export type GlacierPolicyFormsApiGetQuestionsByLocationResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<FrontendQuestionSchema>;
};

export type GlacierPolicyFormsApiGetQuestionsByLocationResponse =
  GlacierPolicyFormsApiGetQuestionsByLocationResponses[keyof GlacierPolicyFormsApiGetQuestionsByLocationResponses];

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData = {
  body: SaveQuestionsBody;
  path: {
    /**
     * Attached Form Id
     */
    attached_form_id: string;
    /**
     * Location Id
     */
    location_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attached-forms/{attached_form_id}/questions/';
};

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyFormsApiGetQuestionsByEntityData = {
  body?: never;
  path: {
    /**
     * Attached Form Id
     */
    attached_form_id: string;
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attached-forms/{attached_form_id}/questions/';
};

export type GlacierPolicyFormsApiGetQuestionsByEntityResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<FrontendQuestionSchema>;
};

export type GlacierPolicyFormsApiGetQuestionsByEntityResponse =
  GlacierPolicyFormsApiGetQuestionsByEntityResponses[keyof GlacierPolicyFormsApiGetQuestionsByEntityResponses];

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData = {
  body: SaveQuestionsBody;
  path: {
    /**
     * Attached Form Id
     */
    attached_form_id: string;
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attached-forms/{attached_form_id}/questions/';
};

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GlacierPolicyConditionsApiListBindingConditionsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/binding-conditions/';
};

export type GlacierPolicyConditionsApiListBindingConditionsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<BindingConditionsSchema>;
};

export type GlacierPolicyConditionsApiListBindingConditionsResponse =
  GlacierPolicyConditionsApiListBindingConditionsResponses[keyof GlacierPolicyConditionsApiListBindingConditionsResponses];

export type GlacierPolicyConditionsApiCreateBindingConditionData = {
  body: BindingConditionRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/binding-conditions/';
};

export type GlacierPolicyConditionsApiCreateBindingConditionResponses = {
  /**
   * OK
   */
  200: BindingConditionsSchema;
};

export type GlacierPolicyConditionsApiCreateBindingConditionResponse =
  GlacierPolicyConditionsApiCreateBindingConditionResponses[keyof GlacierPolicyConditionsApiCreateBindingConditionResponses];

export type GlacierPolicyConditionsApiDeleteBindingConditionData = {
  body?: never;
  path: {
    /**
     * Condition Id
     */
    condition_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/binding-conditions/{condition_id}/';
};

export type GlacierPolicyConditionsApiDeleteBindingConditionResponses = {
  /**
   * No Content
   */
  204: void;
};

export type GlacierPolicyConditionsApiDeleteBindingConditionResponse =
  GlacierPolicyConditionsApiDeleteBindingConditionResponses[keyof GlacierPolicyConditionsApiDeleteBindingConditionResponses];

export type GlacierPolicyConditionsApiUpdateBindingConditionData = {
  body: BindingConditionRequest;
  path: {
    /**
     * Condition Id
     */
    condition_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/binding-conditions/{condition_id}/';
};

export type GlacierPolicyConditionsApiUpdateBindingConditionResponses = {
  /**
   * OK
   */
  200: BindingConditionsSchema;
};

export type GlacierPolicyConditionsApiUpdateBindingConditionResponse =
  GlacierPolicyConditionsApiUpdateBindingConditionResponses[keyof GlacierPolicyConditionsApiUpdateBindingConditionResponses];

export type GlacierPolicyConditionsApiListTermsConditionsData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/terms-conditions/';
};

export type GlacierPolicyConditionsApiListTermsConditionsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<TermConditionsSchema>;
};

export type GlacierPolicyConditionsApiListTermsConditionsResponse =
  GlacierPolicyConditionsApiListTermsConditionsResponses[keyof GlacierPolicyConditionsApiListTermsConditionsResponses];

export type GlacierPolicyConditionsApiCreateTermsConditionData = {
  body: TermConditionRequest;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/terms-conditions/';
};

export type GlacierPolicyConditionsApiCreateTermsConditionResponses = {
  /**
   * OK
   */
  200: TermConditionsSchema;
};

export type GlacierPolicyConditionsApiCreateTermsConditionResponse =
  GlacierPolicyConditionsApiCreateTermsConditionResponses[keyof GlacierPolicyConditionsApiCreateTermsConditionResponses];

export type GlacierPolicyConditionsApiDeleteTermsConditionData = {
  body?: never;
  path: {
    /**
     * Term Id
     */
    term_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/terms-conditions/{term_id}/';
};

export type GlacierPolicyConditionsApiDeleteTermsConditionResponses = {
  /**
   * No Content
   */
  204: void;
};

export type GlacierPolicyConditionsApiDeleteTermsConditionResponse =
  GlacierPolicyConditionsApiDeleteTermsConditionResponses[keyof GlacierPolicyConditionsApiDeleteTermsConditionResponses];

export type GlacierPolicyConditionsApiUpdateTermsConditionData = {
  body: PartialTermConditionRequest;
  path: {
    /**
     * Term Id
     */
    term_id: string;
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/terms-conditions/{term_id}/';
};

export type GlacierPolicyConditionsApiUpdateTermsConditionResponses = {
  /**
   * OK
   */
  200: TermConditionsSchema;
};

export type GlacierPolicyConditionsApiUpdateTermsConditionResponse =
  GlacierPolicyConditionsApiUpdateTermsConditionResponses[keyof GlacierPolicyConditionsApiUpdateTermsConditionResponses];

export type GlacierPolicyErpApiGetErpEligibleDatesData = {
  body?: never;
  path: {
    /**
     * Policy Id
     */
    policy_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{policy_id}/erp/eligible-dates';
};

export type GlacierPolicyErpApiGetErpEligibleDatesResponses = {
  /**
   * OK
   */
  200: ErpEligibleDatesResponse;
};

export type GlacierPolicyErpApiGetErpEligibleDatesResponse =
  GlacierPolicyErpApiGetErpEligibleDatesResponses[keyof GlacierPolicyErpApiGetErpEligibleDatesResponses];

export type GlacierPolicyErpApiGetErpSectionsData = {
  body?: never;
  path: {
    /**
     * Policy Id
     */
    policy_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{policy_id}/erp/sections';
};

export type GlacierPolicyErpApiGetErpSectionsResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<ErpSection>;
};

export type GlacierPolicyErpApiGetErpSectionsResponse =
  GlacierPolicyErpApiGetErpSectionsResponses[keyof GlacierPolicyErpApiGetErpSectionsResponses];

export type GlacierPolicyErpApiStartErpEndorsementData = {
  body: ErpStartRequest;
  path: {
    /**
     * Policy Id
     */
    policy_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{policy_id}/erp/start';
};

export type GlacierPolicyErpApiStartErpEndorsementResponses = {
  /**
   * OK
   */
  200: Policy;
};

export type GlacierPolicyErpApiStartErpEndorsementResponse =
  GlacierPolicyErpApiStartErpEndorsementResponses[keyof GlacierPolicyErpApiStartErpEndorsementResponses];

export type GlacierPolicyErpApiSaveErpSelectionsData = {
  body: ErpSaveRequest;
  path: {
    /**
     * Policy Id
     */
    policy_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{policy_id}/erp/save';
};

export type GlacierPolicyErpApiSaveErpSelectionsResponses = {
  /**
   * OK
   */
  200: ErpSaveResponse;
};

export type GlacierPolicyErpApiSaveErpSelectionsResponse =
  GlacierPolicyErpApiSaveErpSelectionsResponses[keyof GlacierPolicyErpApiSaveErpSelectionsResponses];

export type GlacierPolicyCloneApiCopyPolicyEndpointData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/policy/{account_id}/copy/';
};

export type GlacierPolicyCloneApiCopyPolicyEndpointResponses = {
  /**
   * OK
   */
  200: CopyPolicyResponse;
};

export type GlacierPolicyCloneApiCopyPolicyEndpointResponse =
  GlacierPolicyCloneApiCopyPolicyEndpointResponses[keyof GlacierPolicyCloneApiCopyPolicyEndpointResponses];

export type GlacierOneschemaApiGetJwtTokenData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/bulk/token/';
};

export type GlacierOneschemaApiGetJwtTokenErrors = {
  /**
   * Unauthorized
   */
  401: Message;
};

export type GlacierOneschemaApiGetJwtTokenError =
  GlacierOneschemaApiGetJwtTokenErrors[keyof GlacierOneschemaApiGetJwtTokenErrors];

export type GlacierOneschemaApiGetJwtTokenResponses = {
  /**
   * OK
   */
  200: TokenSchema;
};

export type GlacierOneschemaApiGetJwtTokenResponse =
  GlacierOneschemaApiGetJwtTokenResponses[keyof GlacierOneschemaApiGetJwtTokenResponses];

export type GlacierOneschemaApiBulkUploadPoliciesData = {
  body: OneSchemaPolicyRequest;
  path?: never;
  query?: never;
  url: '/api/v1/bulk/policies/';
};

export type GlacierOneschemaApiBulkUploadPoliciesErrors = {
  /**
   * Bad Request
   */
  400: Message;
  /**
   * Unauthorized
   */
  401: Message;
  /**
   * Internal Server Error
   */
  500: Message;
};

export type GlacierOneschemaApiBulkUploadPoliciesError =
  GlacierOneschemaApiBulkUploadPoliciesErrors[keyof GlacierOneschemaApiBulkUploadPoliciesErrors];

export type GlacierOneschemaApiBulkUploadPoliciesResponses = {
  /**
   * OK
   */
  200: BulkPolicyResponse;
};

export type GlacierOneschemaApiBulkUploadPoliciesResponse =
  GlacierOneschemaApiBulkUploadPoliciesResponses[keyof GlacierOneschemaApiBulkUploadPoliciesResponses];

export type GlacierOneschemaApiBulkUploadDentistsData = {
  body: OneSchemaDentistRequest;
  path?: never;
  query?: never;
  url: '/api/v1/bulk/dentists/';
};

export type GlacierOneschemaApiBulkUploadDentistsErrors = {
  /**
   * Bad Request
   */
  400: Message;
  /**
   * Unauthorized
   */
  401: Message;
  /**
   * Internal Server Error
   */
  500: Message;
};

export type GlacierOneschemaApiBulkUploadDentistsError =
  GlacierOneschemaApiBulkUploadDentistsErrors[keyof GlacierOneschemaApiBulkUploadDentistsErrors];

export type GlacierOneschemaApiBulkUploadDentistsResponses = {
  /**
   * OK
   */
  200: BulkDentistResponse;
};

export type GlacierOneschemaApiBulkUploadDentistsResponse =
  GlacierOneschemaApiBulkUploadDentistsResponses[keyof GlacierOneschemaApiBulkUploadDentistsResponses];

export type GlacierOneschemaApiBulkUploadLocationsData = {
  body: OneSchemaPropertyRequest;
  path?: never;
  query?: never;
  url: '/api/v1/bulk/locations/';
};

export type GlacierOneschemaApiBulkUploadLocationsErrors = {
  /**
   * Bad Request
   */
  400: Message;
  /**
   * Unauthorized
   */
  401: Message;
  /**
   * Internal Server Error
   */
  500: Message;
};

export type GlacierOneschemaApiBulkUploadLocationsError =
  GlacierOneschemaApiBulkUploadLocationsErrors[keyof GlacierOneschemaApiBulkUploadLocationsErrors];

export type GlacierOneschemaApiBulkUploadLocationsResponses = {
  /**
   * OK
   */
  200: BulkPropertyResponse;
};

export type GlacierOneschemaApiBulkUploadLocationsResponse =
  GlacierOneschemaApiBulkUploadLocationsResponses[keyof GlacierOneschemaApiBulkUploadLocationsResponses];

export type GlacierAgenciesApiListWritingCompanyData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/writing-company/';
};

export type GlacierAgenciesApiListWritingCompanyResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Array<WritingCompanySchema>;
};

export type GlacierAgenciesApiListWritingCompanyResponse =
  GlacierAgenciesApiListWritingCompanyResponses[keyof GlacierAgenciesApiListWritingCompanyResponses];

export type GlacierNewGradApiValidateAgencyData = {
  body: ValidateAgencyRequest;
  path?: never;
  query?: never;
  url: '/api/v1/new-grad/validate-agency';
};

export type GlacierNewGradApiValidateAgencyErrors = {
  /**
   * Response
   *
   * Not Found
   */
  404: string;
};

export type GlacierNewGradApiValidateAgencyError =
  GlacierNewGradApiValidateAgencyErrors[keyof GlacierNewGradApiValidateAgencyErrors];

export type GlacierNewGradApiValidateAgencyResponses = {
  /**
   * OK
   */
  200: ValidatedAgencyResponse;
};

export type GlacierNewGradApiValidateAgencyResponse =
  GlacierNewGradApiValidateAgencyResponses[keyof GlacierNewGradApiValidateAgencyResponses];

export type GlacierNewGradApiValidateAssociationCodeData = {
  body: ValidateAssociationCodeRequest;
  path?: never;
  query?: never;
  url: '/api/v1/new-grad/validate-association-code';
};

export type GlacierNewGradApiValidateAssociationCodeErrors = {
  /**
   * Bad Request
   */
  400: AssociationCodeValidationMessage;
};

export type GlacierNewGradApiValidateAssociationCodeError =
  GlacierNewGradApiValidateAssociationCodeErrors[keyof GlacierNewGradApiValidateAssociationCodeErrors];

export type GlacierNewGradApiValidateAssociationCodeResponses = {
  /**
   * OK
   */
  200: ValidatedAssociationCodeResponse;
};

export type GlacierNewGradApiValidateAssociationCodeResponse =
  GlacierNewGradApiValidateAssociationCodeResponses[keyof GlacierNewGradApiValidateAssociationCodeResponses];

export type GlacierNewGradApiSaveAnswersData = {
  body: AnswersRequest;
  path?: never;
  query?: never;
  url: '/api/v1/new-grad/answers';
};

export type GlacierNewGradApiSaveAnswersErrors = {
  /**
   * Bad Request
   */
  400: AssociationCodeValidationError;
};

export type GlacierNewGradApiSaveAnswersError =
  GlacierNewGradApiSaveAnswersErrors[keyof GlacierNewGradApiSaveAnswersErrors];

export type GlacierNewGradApiSaveAnswersResponses = {
  /**
   * OK
   */
  200: AnswersResponse;
};

export type GlacierNewGradApiSaveAnswersResponse =
  GlacierNewGradApiSaveAnswersResponses[keyof GlacierNewGradApiSaveAnswersResponses];

export type GlacierNewGradApiIssuePolicyData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/new-grad/{account_id}/issue';
};

export type GlacierNewGradApiIssuePolicyErrors = {
  /**
   * Response
   *
   * Bad Request
   */
  400: string;
};

export type GlacierNewGradApiIssuePolicyError =
  GlacierNewGradApiIssuePolicyErrors[keyof GlacierNewGradApiIssuePolicyErrors];

export type GlacierNewGradApiIssuePolicyResponses = {
  /**
   * No Content
   */
  204: void;
};

export type GlacierNewGradApiIssuePolicyResponse =
  GlacierNewGradApiIssuePolicyResponses[keyof GlacierNewGradApiIssuePolicyResponses];

export type GlacierNewGradApiGetAnswersData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/new-grad/answers/{account_id}';
};

export type GlacierNewGradApiGetAnswersResponses = {
  /**
   * OK
   */
  200: AnswersResponse;
};

export type GlacierNewGradApiGetAnswersResponse =
  GlacierNewGradApiGetAnswersResponses[keyof GlacierNewGradApiGetAnswersResponses];

export type GlacierNewGradApiPollPaymentData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/new-grad/{account_id}/poll';
};

export type GlacierNewGradApiPollPaymentResponses = {
  /**
   * OK
   */
  200: Payment | null;
};

export type GlacierNewGradApiPollPaymentResponse =
  GlacierNewGradApiPollPaymentResponses[keyof GlacierNewGradApiPollPaymentResponses];

export type GlacierNewGradApiDownloadQuoteData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/new-grad/{account_id}/quote';
};

export type GlacierNewGradApiDownloadQuoteResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierNewGradApiDownloadQuoteResponse =
  GlacierNewGradApiDownloadQuoteResponses[keyof GlacierNewGradApiDownloadQuoteResponses];

export type GlacierNewGradApiDownloadPolicyData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/new-grad/{account_id}/policy';
};

export type GlacierNewGradApiDownloadPolicyResponses = {
  /**
   * Response
   *
   * OK
   */
  200: Blob | File;
};

export type GlacierNewGradApiDownloadPolicyResponse =
  GlacierNewGradApiDownloadPolicyResponses[keyof GlacierNewGradApiDownloadPolicyResponses];

export type GlacierNewGradApiMarkPaymentAsPaidData = {
  body?: never;
  path: {
    /**
     * Account Id
     */
    account_id: string;
  };
  query?: never;
  url: '/api/v1/new-grad/{account_id}/mark-as-paid';
};

export type GlacierNewGradApiMarkPaymentAsPaidResponses = {
  /**
   * OK
   */
  200: Payment;
};

export type GlacierNewGradApiMarkPaymentAsPaidResponse =
  GlacierNewGradApiMarkPaymentAsPaidResponses[keyof GlacierNewGradApiMarkPaymentAsPaidResponses];

export type GlacierAuthenticationApiMfaVerifyData = {
  body: MfaVerifySchema;
  path?: never;
  query?: never;
  url: '/api/v1/auth/mfa_verify';
};

export type GlacierAuthenticationApiMfaVerifyResponses = {
  /**
   * OK
   */
  200: MfaVerifyResponse;
};

export type GlacierAuthenticationApiMfaVerifyResponse =
  GlacierAuthenticationApiMfaVerifyResponses[keyof GlacierAuthenticationApiMfaVerifyResponses];

export type GlacierAssistantApiAssistantConfigData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/assistant/config';
};

export type GlacierAssistantApiAssistantConfigResponses = {
  /**
   * OK
   */
  200: AssistantConfigResponse;
};

export type GlacierAssistantApiAssistantConfigResponse =
  GlacierAssistantApiAssistantConfigResponses[keyof GlacierAssistantApiAssistantConfigResponses];

export type GlacierAssistantApiChatData = {
  body: ChatRequest;
  path?: never;
  query?: never;
  url: '/api/v1/assistant/chat';
};

export type GlacierAssistantApiChatResponses = {
  /**
   * OK
   */
  200: ChatResponse;
};

export type GlacierAssistantApiChatResponse =
  GlacierAssistantApiChatResponses[keyof GlacierAssistantApiChatResponses];

export type GlacierAssistantApiSubmitFeedbackData = {
  body: FeedbackRequest;
  path: {
    /**
     * Interaction Id
     */
    interaction_id: number;
  };
  query?: never;
  url: '/api/v1/assistant/{interaction_id}/feedback';
};

export type GlacierAssistantApiSubmitFeedbackResponses = {
  /**
   * Response
   *
   * OK
   */
  200: {
    [key: string]: boolean;
  };
};

export type GlacierAssistantApiSubmitFeedbackResponse =
  GlacierAssistantApiSubmitFeedbackResponses[keyof GlacierAssistantApiSubmitFeedbackResponses];
